(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("async-validator"), require("graphql-tag"), require("moment"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("CoyoteJsutilities", ["antd", "async-validator", "graphql-tag", "moment", "react"], factory);
	else if(typeof exports === 'object')
		exports["CoyoteJsutilities"] = factory(require("antd"), require("async-validator"), require("graphql-tag"), require("moment"), require("react"));
	else
		root["CoyoteJsutilities"] = factory(root["antd"], root["async-validator"], root["graphql-tag"], root["moment"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_antd__, __WEBPACK_EXTERNAL_MODULE_async_validator__, __WEBPACK_EXTERNAL_MODULE_graphql_tag__, __WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/antd/lib/badge/style/index.js":
/*!****************************************************!*\
  !*** ./node_modules/antd/lib/badge/style/index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ../../style/index.less */ "./node_modules/antd/lib/style/index.less");

__webpack_require__(/*! ./index.less */ "./node_modules/antd/lib/badge/style/index.less");

/***/ }),

/***/ "./node_modules/antd/lib/badge/style/index.less":
/*!******************************************************!*\
  !*** ./node_modules/antd/lib/badge/style/index.less ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../css-loader!../../../../less-loader/dist/cjs.js??ref--7-2!./index.less */ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js?!./node_modules/antd/lib/badge/style/index.less");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./node_modules/antd/lib/popover/style/index.js":
/*!******************************************************!*\
  !*** ./node_modules/antd/lib/popover/style/index.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ../../style/index.less */ "./node_modules/antd/lib/style/index.less");

__webpack_require__(/*! ./index.less */ "./node_modules/antd/lib/popover/style/index.less");

/***/ }),

/***/ "./node_modules/antd/lib/popover/style/index.less":
/*!********************************************************!*\
  !*** ./node_modules/antd/lib/popover/style/index.less ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../css-loader!../../../../less-loader/dist/cjs.js??ref--7-2!./index.less */ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js?!./node_modules/antd/lib/popover/style/index.less");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./node_modules/antd/lib/style/index.less":
/*!************************************************!*\
  !*** ./node_modules/antd/lib/style/index.less ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../css-loader!../../../less-loader/dist/cjs.js??ref--7-2!./index.less */ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js?!./node_modules/antd/lib/style/index.less");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../style-loader/lib/addStyles.js */ "./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js?!./node_modules/antd/lib/badge/style/index.less":
/*!*********************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js??ref--7-2!./node_modules/antd/lib/badge/style/index.less ***!
  \*********************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-badge {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  color: unset;\n  line-height: 1;\n}\n.ant-badge-count {\n  z-index: auto;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  color: #fff;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: center;\n  background: #ff4d4f;\n  border-radius: 10px;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count a,\n.ant-badge-count a:hover {\n  color: #fff;\n}\n.ant-badge-multiple-words {\n  padding: 0 8px;\n}\n.ant-badge-dot {\n  z-index: auto;\n  width: 6px;\n  height: 6px;\n  background: #ff4d4f;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-count,\n.ant-badge-dot,\n.ant-badge .ant-scroll-number-custom-component {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n  transform-origin: 100% 0%;\n}\n.ant-badge-status {\n  line-height: inherit;\n  vertical-align: baseline;\n}\n.ant-badge-status-dot {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  vertical-align: middle;\n  border-radius: 50%;\n}\n.ant-badge-status-success {\n  background-color: #52c41a;\n}\n.ant-badge-status-processing {\n  position: relative;\n  background-color: #1890ff;\n}\n.ant-badge-status-processing::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #1890ff;\n  border-radius: 50%;\n  animation: antStatusProcessing 1.2s infinite ease-in-out;\n  content: '';\n}\n.ant-badge-status-default {\n  background-color: #d9d9d9;\n}\n.ant-badge-status-error {\n  background-color: #ff4d4f;\n}\n.ant-badge-status-warning {\n  background-color: #faad14;\n}\n.ant-badge-status-pink {\n  background: #eb2f96;\n}\n.ant-badge-status-magenta {\n  background: #eb2f96;\n}\n.ant-badge-status-red {\n  background: #f5222d;\n}\n.ant-badge-status-volcano {\n  background: #fa541c;\n}\n.ant-badge-status-orange {\n  background: #fa8c16;\n}\n.ant-badge-status-yellow {\n  background: #fadb14;\n}\n.ant-badge-status-gold {\n  background: #faad14;\n}\n.ant-badge-status-cyan {\n  background: #13c2c2;\n}\n.ant-badge-status-lime {\n  background: #a0d911;\n}\n.ant-badge-status-green {\n  background: #52c41a;\n}\n.ant-badge-status-blue {\n  background: #1890ff;\n}\n.ant-badge-status-geekblue {\n  background: #2f54eb;\n}\n.ant-badge-status-purple {\n  background: #722ed1;\n}\n.ant-badge-status-text {\n  margin-left: 8px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n.ant-badge-zoom-appear,\n.ant-badge-zoom-enter {\n  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  animation-fill-mode: both;\n}\n.ant-badge-zoom-leave {\n  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n  animation-fill-mode: both;\n}\n.ant-badge-not-a-wrapper:not(.ant-badge-status) {\n  vertical-align: middle;\n}\n.ant-badge-not-a-wrapper .ant-scroll-number {\n  position: relative;\n  top: auto;\n  display: block;\n}\n.ant-badge-not-a-wrapper .ant-badge-count {\n  transform: none;\n}\n@keyframes antStatusProcessing {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.ant-scroll-number {\n  overflow: hidden;\n}\n.ant-scroll-number-only {\n  display: inline-block;\n  height: 20px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-scroll-number-only > p.ant-scroll-number-only-unit {\n  height: 20px;\n  margin: 0;\n}\n.ant-scroll-number-symbol {\n  vertical-align: top;\n}\n@keyframes antZoomBadgeIn {\n  0% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1) translate(50%, -50%);\n  }\n}\n@keyframes antZoomBadgeOut {\n  0% {\n    transform: scale(1) translate(50%, -50%);\n  }\n  100% {\n    transform: scale(0) translate(50%, -50%);\n    opacity: 0;\n  }\n}\n.ant-badge-rtl {\n  direction: rtl;\n}\n.ant-badge-rtl .ant-badge-count,\n.ant-badge-rtl .ant-badge-dot,\n.ant-badge-rtl .ant-badge .ant-scroll-number-custom-component {\n  right: auto;\n  left: 0;\n  direction: ltr;\n  transform: translate(-50%, -50%);\n  transform-origin: 0% 0%;\n}\n.ant-badge-rtl.ant-badge .ant-scroll-number-custom-component {\n  right: auto;\n  left: 0;\n  transform: translate(-50%, -50%);\n  transform-origin: 0% 0%;\n}\n.ant-badge-rtl .ant-badge-status-text {\n  margin-right: 8px;\n  margin-left: 0;\n}\n.ant-badge-rtl .ant-badge-zoom-appear,\n.ant-badge-rtl .ant-badge-zoom-enter {\n  animation-name: antZoomBadgeInRtl;\n}\n.ant-badge-rtl .ant-badge-zoom-leave {\n  animation-name: antZoomBadgeOutRtl;\n}\n.ant-badge-not-a-wrapper .ant-badge-count {\n  transform: none;\n}\n@keyframes antZoomBadgeInRtl {\n  0% {\n    transform: scale(0) translate(-50%, -50%);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1) translate(-50%, -50%);\n  }\n}\n@keyframes antZoomBadgeOutRtl {\n  0% {\n    transform: scale(1) translate(-50%, -50%);\n  }\n  100% {\n    transform: scale(0) translate(-50%, -50%);\n    opacity: 0;\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js?!./node_modules/antd/lib/popover/style/index.less":
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js??ref--7-2!./node_modules/antd/lib/popover/style/index.less ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.ant-popover {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  font-weight: normal;\n  white-space: normal;\n  text-align: left;\n  cursor: auto;\n  user-select: text;\n}\n.ant-popover::after {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n  content: '';\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 10px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 10px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 10px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 10px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 2px;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15) \\9;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ant-popover {\n    /* IE10+ */\n  }\n  .ant-popover-inner {\n    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  }\n}\n.ant-popover-title {\n  min-width: 177px;\n  min-height: 32px;\n  margin: 0;\n  padding: 5px 16px 4px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  border-bottom: 1px solid #f0f0f0;\n}\n.ant-popover-inner-content {\n  padding: 12px 16px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message {\n  position: relative;\n  padding: 4px 0 12px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n.ant-popover-message > .anticon {\n  position: absolute;\n  top: 8.0005px;\n  color: #faad14;\n  font-size: 14px;\n}\n.ant-popover-message-title {\n  padding-left: 22px;\n}\n.ant-popover-buttons {\n  margin-bottom: 4px;\n  text-align: right;\n}\n.ant-popover-buttons button {\n  margin-left: 8px;\n}\n.ant-popover-arrow {\n  position: absolute;\n  display: block;\n  width: 8.48528137px;\n  height: 8.48528137px;\n  background: transparent;\n  border-style: solid;\n  border-width: 4.24264069px;\n  transform: rotate(45deg);\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  bottom: 6.2px;\n  border-top-color: transparent;\n  border-right-color: #fff;\n  border-bottom-color: #fff;\n  border-left-color: transparent;\n  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n}\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  left: 6px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: #fff;\n  border-left-color: #fff;\n  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n}\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  top: 6px;\n  border-top-color: #fff;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: #fff;\n  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  transform: translateX(-50%) rotate(45deg);\n}\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  right: 6px;\n  border-top-color: #fff;\n  border-right-color: #fff;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n}\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.ant-popover-rtl .ant-popover-message-title {\n  padding-right: 22px;\n  padding-left: 16px;\n}\n.ant-popover-rtl .ant-popover-buttons {\n  text-align: left;\n}\n.ant-popover-rtl .ant-popover-buttons button {\n  margin-right: 8px;\n  margin-left: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js?!./node_modules/antd/lib/style/index.less":
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js??ref--7-2!./node_modules/antd/lib/style/index.less ***!
  \***************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../css-loader/lib/css-base.js */ "./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n[class^=ant-]::-ms-clear,\n[class*= ant-]::-ms-clear,\n[class^=ant-] input::-ms-clear,\n[class*= ant-] input::-ms-clear,\n[class^=ant-] input::-ms-reveal,\n[class*= ant-] input::-ms-reveal {\n  display: none;\n}\n[class^=ant-],\n[class*= ant-],\n[class^=ant-] *,\n[class*= ant-] *,\n[class^=ant-] *::before,\n[class*= ant-] *::before,\n[class^=ant-] *::after,\n[class*= ant-] *::after {\n  box-sizing: border-box;\n}\n/* stylelint-disable at-rule-no-unknown */\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n}\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@-ms-viewport {\n  width: device-width;\n}\nbody {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  background-color: #fff;\n  font-feature-settings: 'tnum';\n}\n[tabindex='-1']:focus {\n  outline: none !important;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  border-bottom: 0;\n  cursor: help;\n}\naddress {\n  margin-bottom: 1em;\n  font-style: normal;\n  line-height: inherit;\n}\ninput[type='text'],\ninput[type='password'],\ninput[type='number'],\ntextarea {\n  -webkit-appearance: none;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 500;\n}\ndd {\n  margin-bottom: 0.5em;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1em;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\na {\n  color: #1890ff;\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: #40a9ff;\n}\na:active {\n  color: #096dd9;\n}\na:active,\na:hover {\n  text-decoration: none;\n  outline: 0;\n}\na:focus {\n  text-decoration: none;\n  outline: 0;\n}\na[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  pointer-events: none;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-size: 1em;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1em;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1em;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\na,\narea,\nbutton,\n[role='button'],\ninput:not([type='range']),\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75em;\n  padding-bottom: 0.3em;\n  color: rgba(0, 0, 0, 0.45);\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: inherit;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type='radio'],\ninput[type='checkbox'] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0.5em;\n  padding: 0;\n  color: inherit;\n  font-size: 1.5em;\n  line-height: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n[type='search'] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\nmark {\n  padding: 0.2em;\n  background-color: #feffe6;\n}\n::selection {\n  color: #fff;\n  background: #1890ff;\n}\n.clearfix::before {\n  display: table;\n  content: '';\n}\n.clearfix::after {\n  display: table;\n  clear: both;\n  content: '';\n}\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.anticon > * {\n  line-height: 1;\n}\n.anticon svg {\n  display: inline-block;\n}\n.anticon::before {\n  display: none;\n}\n.anticon .anticon-icon {\n  display: block;\n}\n.anticon[tabindex] {\n  cursor: pointer;\n}\n.anticon-spin::before {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.anticon-spin {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.fade-enter,\n.fade-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-enter.fade-enter-active,\n.fade-appear.fade-appear-active {\n  animation-name: antFadeIn;\n  animation-play-state: running;\n}\n.fade-leave.fade-leave-active {\n  animation-name: antFadeOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.fade-enter,\n.fade-appear {\n  opacity: 0;\n  animation-timing-function: linear;\n}\n.fade-leave {\n  animation-timing-function: linear;\n}\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.move-up-enter,\n.move-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-enter.move-up-enter-active,\n.move-up-appear.move-up-appear-active {\n  animation-name: antMoveUpIn;\n  animation-play-state: running;\n}\n.move-up-leave.move-up-leave-active {\n  animation-name: antMoveUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-up-enter,\n.move-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-up-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-down-enter,\n.move-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-enter.move-down-enter-active,\n.move-down-appear.move-down-appear-active {\n  animation-name: antMoveDownIn;\n  animation-play-state: running;\n}\n.move-down-leave.move-down-leave-active {\n  animation-name: antMoveDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-down-enter,\n.move-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-down-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-left-enter,\n.move-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-enter.move-left-enter-active,\n.move-left-appear.move-left-appear-active {\n  animation-name: antMoveLeftIn;\n  animation-play-state: running;\n}\n.move-left-leave.move-left-leave-active {\n  animation-name: antMoveLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-left-enter,\n.move-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-left-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-right-enter,\n.move-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-enter.move-right-enter-active,\n.move-right-appear.move-right-appear-active {\n  animation-name: antMoveRightIn;\n  animation-play-state: running;\n}\n.move-right-leave.move-right-leave-active {\n  animation-name: antMoveRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-right-enter,\n.move-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-right-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n@keyframes antMoveDownIn {\n  0% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveDownOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveLeftIn {\n  0% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveLeftOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveRightIn {\n  0% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveRightOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes antMoveUpIn {\n  0% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n@keyframes antMoveUpOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n@keyframes loadingCircle {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n[ant-click-animating='true'],\n[ant-click-animating-without-extra-node='true'] {\n  position: relative;\n}\nhtml {\n  --antd-wave-shadow-color: #1890ff;\n  --scroll-bar: 0;\n}\n[ant-click-animating-without-extra-node='true']::after,\n.ant-click-animating-node {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 #1890ff;\n  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n  opacity: 0.2;\n  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n@keyframes waveEffect {\n  100% {\n    box-shadow: 0 0 0 #1890ff;\n    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);\n  }\n}\n@keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n.slide-up-enter,\n.slide-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-enter.slide-up-enter-active,\n.slide-up-appear.slide-up-appear-active {\n  animation-name: antSlideUpIn;\n  animation-play-state: running;\n}\n.slide-up-leave.slide-up-leave-active {\n  animation-name: antSlideUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-up-enter,\n.slide-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-up-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-down-enter,\n.slide-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-enter.slide-down-enter-active,\n.slide-down-appear.slide-down-appear-active {\n  animation-name: antSlideDownIn;\n  animation-play-state: running;\n}\n.slide-down-leave.slide-down-leave-active {\n  animation-name: antSlideDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-down-enter,\n.slide-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-left-enter,\n.slide-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-enter.slide-left-enter-active,\n.slide-left-appear.slide-left-appear-active {\n  animation-name: antSlideLeftIn;\n  animation-play-state: running;\n}\n.slide-left-leave.slide-left-leave-active {\n  animation-name: antSlideLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-left-enter,\n.slide-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-left-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-right-enter,\n.slide-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-enter.slide-right-enter-active,\n.slide-right-appear.slide-right-appear-active {\n  animation-name: antSlideRightIn;\n  animation-play-state: running;\n}\n.slide-right-leave.slide-right-leave-active {\n  animation-name: antSlideRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-right-enter,\n.slide-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-right-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes antSlideUpIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideDownIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideDownOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideLeftIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideLeftOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antSlideRightIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n@keyframes antSlideRightOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n.zoom-enter,\n.zoom-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-enter.zoom-enter-active,\n.zoom-appear.zoom-appear-active {\n  animation-name: antZoomIn;\n  animation-play-state: running;\n}\n.zoom-leave.zoom-leave-active {\n  animation-name: antZoomOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-enter,\n.zoom-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-enter.zoom-big-enter-active,\n.zoom-big-appear.zoom-big-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-leave.zoom-big-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-leave {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-enter.zoom-big-fast-enter-active,\n.zoom-big-fast-appear.zoom-big-fast-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-fast-leave.zoom-big-fast-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-fast-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-enter.zoom-up-enter-active,\n.zoom-up-appear.zoom-up-appear-active {\n  animation-name: antZoomUpIn;\n  animation-play-state: running;\n}\n.zoom-up-leave.zoom-up-leave-active {\n  animation-name: antZoomUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-up-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-enter.zoom-down-enter-active,\n.zoom-down-appear.zoom-down-appear-active {\n  animation-name: antZoomDownIn;\n  animation-play-state: running;\n}\n.zoom-down-leave.zoom-down-leave-active {\n  animation-name: antZoomDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-enter.zoom-left-enter-active,\n.zoom-left-appear.zoom-left-appear-active {\n  animation-name: antZoomLeftIn;\n  animation-play-state: running;\n}\n.zoom-left-leave.zoom-left-leave-active {\n  animation-name: antZoomLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-left-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-enter.zoom-right-enter-active,\n.zoom-right-appear.zoom-right-appear-active {\n  animation-name: antZoomRightIn;\n  animation-play-state: running;\n}\n.zoom-right-leave.zoom-right-leave-active {\n  animation-name: antZoomRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  transform: scale(0);\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-right-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n@keyframes antZoomIn {\n  0% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n}\n@keyframes antZoomBigIn {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes antZoomBigOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n}\n@keyframes antZoomUpIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n}\n@keyframes antZoomUpOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomLeftIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n}\n@keyframes antZoomLeftOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomRightIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n}\n@keyframes antZoomRightOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n@keyframes antZoomDownIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n}\n@keyframes antZoomDownOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.ant-motion-collapse-legacy {\n  overflow: hidden;\n}\n.ant-motion-collapse-legacy-active {\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-motion-collapse {\n  overflow: hidden;\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/lib/css-base.js":
/*!*************************************************!*\
  !*** ./node_modules/css-loader/lib/css-base.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "./node_modules/style-loader/lib/addStyles.js":
/*!****************************************************!*\
  !*** ./node_modules/style-loader/lib/addStyles.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(/*! ./urls */ "./node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "./node_modules/style-loader/lib/urls.js":
/*!***********************************************!*\
  !*** ./node_modules/style-loader/lib/urls.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "./src/components/account_status_icons/index.ts":
/*!******************************************************!*\
  !*** ./src/components/account_status_icons/index.ts ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// export * from './__generated__';
__exportStar(__webpack_require__(/*! ./status_components */ "./src/components/account_status_icons/status_components/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./status_icons */ "./src/components/account_status_icons/status_icons/index.ts"), exports);


/***/ }),

/***/ "./src/components/account_status_icons/status_components/index.ts":
/*!************************************************************************!*\
  !*** ./src/components/account_status_icons/status_components/index.ts ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// export * from './__generated__';
__exportStar(__webpack_require__(/*! ./mirror_hauler_bill_status */ "./src/components/account_status_icons/status_components/mirror_hauler_bill_status.tsx"), exports);


/***/ }),

/***/ "./src/components/account_status_icons/status_components/mirror_hauler_bill_status.tsx":
/*!*********************************************************************************************!*\
  !*** ./src/components/account_status_icons/status_components/mirror_hauler_bill_status.tsx ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirrorHaulerBillStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var status_icons_1 = __webpack_require__(/*! ../status_icons */ "./src/components/account_status_icons/status_icons/index.ts");
var location_status_icons_1 = __webpack_require__(/*! ../../location_status_icons */ "./src/components/location_status_icons/index.ts");
var MirrorHaulerBillStatus = function (props) {
    var mirrorHaulerBill = props.mirrorHaulerBill;
    if (mirrorHaulerBill) {
        return (React.createElement(location_status_icons_1.IconTextWrapper, { text: "Mirror hauler bill" },
            React.createElement(status_icons_1.MirrorHaulerBillIcon, { style: location_status_icons_1.style })));
    }
    return null;
};
exports.MirrorHaulerBillStatus = MirrorHaulerBillStatus;


/***/ }),

/***/ "./src/components/account_status_icons/status_icons/index.ts":
/*!*******************************************************************!*\
  !*** ./src/components/account_status_icons/status_icons/index.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./svg_icons */ "./src/components/account_status_icons/status_icons/svg_icons.ts"), exports);


/***/ }),

/***/ "./src/components/account_status_icons/status_icons/mirror_hauler_bill.svg":
/*!*********************************************************************************!*\
  !*** ./src/components/account_status_icons/status_icons/mirror_hauler_bill.svg ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2 43.4c10.604 0 19.2-8.596 19.2-19.2S34.804 5 24.2 5 5 13.596 5 24.2s8.596 19.2 19.2 19.2z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M38 12H20v22h18V12z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  mask: "url(#mirror_hauler_bill_svg__a)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M35 12.75H23A2.25 2.25 0 0 0 20.75 15v16A2.25 2.25 0 0 0 23 33.25h12A2.25 2.25 0 0 0 37.25 31V15A2.25 2.25 0 0 0 35 12.75z",
  fill: "#F6E6E9",
  stroke: "#F6E6E9",
  strokeWidth: 0.5
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M27.653 21.538c.166 0 .309-.019.429-.057a.794.794 0 0 0 .294-.159.63.63 0 0 0 .17-.246.89.89 0 0 0 .055-.315.64.64 0 0 0-.237-.525c-.158-.13-.395-.195-.711-.195h-.93v1.497h.93zm-.93-3.378v1.467h.768c.164 0 .306-.018.426-.054a.844.844 0 0 0 .3-.15.583.583 0 0 0 .177-.231.778.778 0 0 0 .057-.3c0-.254-.076-.439-.228-.555-.152-.118-.388-.177-.708-.177h-.792zm.792-.459c.264 0 .49.026.68.078.193.052.35.126.472.222a.857.857 0 0 1 .273.354c.058.138.087.294.087.468a.927.927 0 0 1-.198.576c-.066.084-.15.16-.252.228-.1.066-.218.12-.354.162.316.06.553.173.71.339.16.164.24.38.24.648 0 .182-.033.348-.101.498-.066.15-.164.279-.294.387a1.372 1.372 0 0 1-.474.252 2.177 2.177 0 0 1-.642.087h-1.518v-4.299h1.37zm2.787 1.26V22h-.534v-3.039h.534zm.114-.954a.336.336 0 0 1-.033.147.407.407 0 0 1-.084.12.376.376 0 0 1-.123.081.365.365 0 0 1-.294 0 .396.396 0 0 1-.198-.201.365.365 0 0 1 0-.294.376.376 0 0 1 .081-.123.37.37 0 0 1 .117-.084.365.365 0 0 1 .294 0c.048.02.09.048.123.084a.354.354 0 0 1 .084.123.336.336 0 0 1 .033.147zm1.222-.426V22h-.534v-4.419h.534zm1.324 0V22h-.534v-4.419h.534z",
  fill: "#B73B40"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M29 28h6M27 26h8M30 30h5",
  stroke: "#B73B40",
  strokeLinecap: "round"
}));

var _ref4 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M29 23H10v13h19V23z",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  mask: "url(#mirror_hauler_bill_svg__b)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M21.762 23.867H10.905V33.4h10.857v-9.533zM25.381 26.467h-3.619V30.8h3.619v-4.333z",
  fill: "#fff"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M26.286 27.333h-3.62v4.334h3.62v-4.334z",
  fill: "#fff"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M27.19 28.2h-3.619v4.333h3.62V28.2zM14.524 35.133c1 0 1.81-.776 1.81-1.733 0-.957-.81-1.733-1.81-1.733s-1.81.776-1.81 1.733c0 .957.81 1.733 1.81 1.733z",
  fill: "#fff"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M24.476 35.133c1 0 1.81-.776 1.81-1.733 0-.957-.81-1.733-1.81-1.733s-1.81.776-1.81 1.733c0 .957.81 1.733 1.81 1.733z",
  fill: "#fff"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M17.6 33.563c0 1.345-1.277 2.437-2.85 2.437-1.6 0-2.85-1.092-2.85-2.438-1.05 0-1.9-.728-1.9-1.624v-7.313c0-.898.85-1.625 1.9-1.625h8.55c1.048 0 1.9.727 1.9 1.625v.813h1.268c.442 0 .864.15 1.175.416l2.77 2.369c.312.267.487.627.487 1.005v3.116h.238c.394 0 .712.271.712.61 0 .337-.318.608-.712.608H27.1c0 1.346-1.277 2.438-2.85 2.438-1.6 0-2.85-1.092-2.85-2.438h-3.8zm2.85-9.344H11.9c-.262 0-.475.181-.475.406v7.313c0 .223.213.406.475.406h.381c.493-.729 1.415-1.219 2.469-1.219 1.054 0 1.977.49 2.47 1.219h3.23c.261 0 .475-.183.475-.407v-7.312c0-.224-.214-.406-.475-.406zm3.337 2.496a.258.258 0 0 0-.17-.059H22.35v2.438h4.216c-.003-.003-.006-.008-.01-.01l-2.77-2.37zm-9.037 5.629c-.787 0-1.425.546-1.425 1.218 0 .673.638 1.22 1.425 1.22s1.425-.547 1.425-1.22c0-.672-.638-1.218-1.425-1.218zm9.5 2.437c.787 0 1.425-.546 1.425-1.218 0-.673-.638-1.22-1.425-1.22s-1.425.547-1.425 1.22c0 .672.638 1.218 1.425 1.218z",
  fill: "#0180ED"
}));

var SvgMirrorHaulerBill = function SvgMirrorHaulerBill(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("mask", {
    id: "mirror_hauler_bill_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 12,
    width: 18,
    height: 22
  }, _ref2), _ref3, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("mask", {
    id: "mirror_hauler_bill_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 23,
    width: 19,
    height: 13
  }, _ref4), _ref5);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMirrorHaulerBill);

/***/ }),

/***/ "./src/components/account_status_icons/status_icons/svg_icons.ts":
/*!***********************************************************************!*\
  !*** ./src/components/account_status_icons/status_icons/svg_icons.ts ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirrorHaulerBillIcon = void 0;
var mirror_hauler_bill_svg_1 = __webpack_require__(/*! ./mirror_hauler_bill.svg */ "./src/components/account_status_icons/status_icons/mirror_hauler_bill.svg");
Object.defineProperty(exports, "MirrorHaulerBillIcon", { enumerable: true, get: function () { return __importDefault(mirror_hauler_bill_svg_1).default; } });


/***/ }),

/***/ "./src/components/index.ts":
/*!*********************************!*\
  !*** ./src/components/index.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./account_status_icons */ "./src/components/account_status_icons/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./location_status_icons */ "./src/components/location_status_icons/index.ts"), exports);


/***/ }),

/***/ "./src/components/location_status_icons/__generated__/getOneLoc.ts":
/*!*************************************************************************!*\
  !*** ./src/components/location_status_icons/__generated__/getOneLoc.ts ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/__generated__/index.ts":
/*!*********************************************************************!*\
  !*** ./src/components/location_status_icons/__generated__/index.ts ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./getOneLoc */ "./src/components/location_status_icons/__generated__/getOneLoc.ts"), exports);


/***/ }),

/***/ "./src/components/location_status_icons/index.ts":
/*!*******************************************************!*\
  !*** ./src/components/location_status_icons/index.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./__generated__ */ "./src/components/location_status_icons/__generated__/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./status_components */ "./src/components/location_status_icons/status_components/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./status_icons */ "./src/components/location_status_icons/status_icons/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./utils */ "./src/components/location_status_icons/utils.ts"), exports);


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/ActiveServicesFragment.ts":
/*!********************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/ActiveServicesFragment.ts ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/AllServicesEngagementFragment.ts":
/*!***************************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/AllServicesEngagementFragment.ts ***!
  \***************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/BigPortfolioFragment.ts":
/*!******************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/BigPortfolioFragment.ts ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/BillOngoingTasksFragment.ts":
/*!**********************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/BillOngoingTasksFragment.ts ***!
  \**********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/BoarFragment.ts":
/*!**********************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/BoarFragment.ts ***!
  \**********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/CustomIssueFragment.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/CustomIssueFragment.ts ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/HaulerAccountIssueFragment.ts":
/*!************************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/HaulerAccountIssueFragment.ts ***!
  \************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/HealthFragment.ts":
/*!************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/HealthFragment.ts ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/InvoiceBlockerFragment.ts":
/*!********************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/InvoiceBlockerFragment.ts ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/KeyFragment.ts":
/*!*********************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/KeyFragment.ts ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/LatePayerFragment.ts":
/*!***************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/LatePayerFragment.ts ***!
  \***************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/LiquidationFragment.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/LiquidationFragment.ts ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/MgpRankingFragment.ts":
/*!****************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/MgpRankingFragment.ts ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/NewFragment.ts":
/*!*********************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/NewFragment.ts ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/PayAheadFragment.ts":
/*!**************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/PayAheadFragment.ts ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/PaymentTermFragment.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/PaymentTermFragment.ts ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/PrimaryKeyFragment.ts":
/*!****************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/PrimaryKeyFragment.ts ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/RecentlySavedFragment.ts":
/*!*******************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/RecentlySavedFragment.ts ***!
  \*******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/RecycleMoreFragment.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/RecycleMoreFragment.ts ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/SecondaryKeyFragment.ts":
/*!******************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/SecondaryKeyFragment.ts ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/StrategyHistoriesFragment.ts":
/*!***********************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/StrategyHistoriesFragment.ts ***!
  \***********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/components/location_status_icons/status_components/__generated__/index.ts":
/*!***************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/__generated__/index.ts ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./ActiveServicesFragment */ "./src/components/location_status_icons/status_components/__generated__/ActiveServicesFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./AllServicesEngagementFragment */ "./src/components/location_status_icons/status_components/__generated__/AllServicesEngagementFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./BigPortfolioFragment */ "./src/components/location_status_icons/status_components/__generated__/BigPortfolioFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./CustomIssueFragment */ "./src/components/location_status_icons/status_components/__generated__/CustomIssueFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./HaulerAccountIssueFragment */ "./src/components/location_status_icons/status_components/__generated__/HaulerAccountIssueFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./HealthFragment */ "./src/components/location_status_icons/status_components/__generated__/HealthFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./InvoiceBlockerFragment */ "./src/components/location_status_icons/status_components/__generated__/InvoiceBlockerFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./KeyFragment */ "./src/components/location_status_icons/status_components/__generated__/KeyFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./LatePayerFragment */ "./src/components/location_status_icons/status_components/__generated__/LatePayerFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./LiquidationFragment */ "./src/components/location_status_icons/status_components/__generated__/LiquidationFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./NewFragment */ "./src/components/location_status_icons/status_components/__generated__/NewFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./PayAheadFragment */ "./src/components/location_status_icons/status_components/__generated__/PayAheadFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./PaymentTermFragment */ "./src/components/location_status_icons/status_components/__generated__/PaymentTermFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./PrimaryKeyFragment */ "./src/components/location_status_icons/status_components/__generated__/PrimaryKeyFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./RecentlySavedFragment */ "./src/components/location_status_icons/status_components/__generated__/RecentlySavedFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./SecondaryKeyFragment */ "./src/components/location_status_icons/status_components/__generated__/SecondaryKeyFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./StrategyHistoriesFragment */ "./src/components/location_status_icons/status_components/__generated__/StrategyHistoriesFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./BoarFragment */ "./src/components/location_status_icons/status_components/__generated__/BoarFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./RecycleMoreFragment */ "./src/components/location_status_icons/status_components/__generated__/RecycleMoreFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./MgpRankingFragment */ "./src/components/location_status_icons/status_components/__generated__/MgpRankingFragment.ts"), exports);
__exportStar(__webpack_require__(/*! ./BillOngoingTasksFragment */ "./src/components/location_status_icons/status_components/__generated__/BillOngoingTasksFragment.ts"), exports);


/***/ }),

/***/ "./src/components/location_status_icons/status_components/big_portfolio_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/big_portfolio_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigPortfolioStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var BigPortfolioStatus = function (props) {
    var _a = (props.accountByAccountId || {}).portfolioByPortfolioId, portfolioByPortfolioId = _a === void 0 ? null : _a;
    var _b = (portfolioByPortfolioId || {}).accountsByPortfolioId, accountsByPortfolioId = _b === void 0 ? null : _b;
    var _c = (accountsByPortfolioId || {}).nodes, accounts = _c === void 0 ? [] : _c;
    // total number of locations
    var totalLocations = accounts.reduce(function (total, cur) {
        var _a = (cur || {}).locationsByAccountId, locationsByAccountId = _a === void 0 ? null : _a;
        var _b = (locationsByAccountId || {}).totalCount, totalCount = _b === void 0 ? 0 : _b;
        return total + Number(totalCount);
    }, 0);
    if (totalLocations > 5) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Part Of Big Portfolio" },
            React.createElement(svg_icons_1.BigPortfolio, { style: utils_1.style })));
    }
    return null;
};
exports.BigPortfolioStatus = BigPortfolioStatus;
exports.BigPortfolioStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment BigPortfolioFragment on Location {\n      id\n      manualNotKey\n      accountByAccountId {\n        id\n        portfolioByPortfolioId {\n          id\n          manualKey\n          accountsByPortfolioId {\n            nodes {\n              id\n              locationsByAccountId(filter: { salesStatus: { notEqualTo: \"Closed Lost\" } }) {\n                totalCount\n              }\n            }\n          }\n        }\n      }\n    }\n  "], ["\n    fragment BigPortfolioFragment on Location {\n      id\n      manualNotKey\n      accountByAccountId {\n        id\n        portfolioByPortfolioId {\n          id\n          manualKey\n          accountsByPortfolioId {\n            nodes {\n              id\n              locationsByAccountId(filter: { salesStatus: { notEqualTo: \"Closed Lost\" } }) {\n                totalCount\n              }\n            }\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/bill_blocker_status.tsx":
/*!****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/bill_blocker_status.tsx ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillBlockerStatus = void 0;
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var status_icons_1 = __webpack_require__(/*! ../status_icons */ "./src/components/location_status_icons/status_icons/index.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var BillBlockerStatus = function (props) {
    var billBlocker = props.billBlocker;
    if (!billBlocker) {
        return null;
    }
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Bill Blocker" },
        React.createElement(status_icons_1.BillBlocker, { style: utils_1.style })));
};
exports.BillBlockerStatus = BillBlockerStatus;
exports.BillBlockerStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment BillBlockerStatusFragment on Location {\n      id\n      billBlocker\n    }\n  "], ["\n    fragment BillBlockerStatusFragment on Location {\n      id\n      billBlocker\n    }\n  "]))),
};
exports.default = exports.BillBlockerStatus;
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/bill_ongoing_tasks_status.tsx":
/*!**********************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/bill_ongoing_tasks_status.tsx ***!
  \**********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillOngoingTasksStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var Text = antd_1.Typography.Text;
var BillOngoingTasksStatus = function (props) {
    var _a = __read(React.useState(false), 2), popoverVisible = _a[0], setPopoverVisible = _a[1];
    var _b = props.data, billTasksCount = _b.billTasksByBillId.totalCount, billServiceTasksCount = _b.billServiceTasksByBillId.totalCount, closedBillTaskCount = _b.closedBillTasks.totalCount, closedBillServiceTaskCount = _b.closedBillServiceTasks.totalCount, ongoingTasksUrl = props.ongoingTasksUrl, completeTasksUrl = props.completeTasksUrl;
    var totalBillRelatedTasks = closedBillTaskCount +
        closedBillServiceTaskCount +
        billTasksCount +
        billServiceTasksCount;
    if (totalBillRelatedTasks <= 0) {
        return null;
    }
    var OngoingTasksItem = function () {
        if (!billTasksCount && !billServiceTasksCount) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement(antd_1.List.Item, { actions: [
                    React.createElement("a", { style: { fontWeight: 'bold', textDecoration: 'none' }, href: ongoingTasksUrl, target: "_blank" }, "See all"),
                ] },
                React.createElement(antd_1.List.Item.Meta, { avatar: React.createElement(antd_1.Badge, { count: billTasksCount + billServiceTasksCount }), title: React.createElement("span", null, "Ongoing Tasks"), description: React.createElement(React.Fragment, null,
                        billTasksCount > 0 && React.createElement(React.Fragment, null,
                            React.createElement(Text, null,
                                "Bill (",
                                billTasksCount,
                                ")"),
                            React.createElement("br", null)),
                        billServiceTasksCount > 0 && React.createElement(Text, null,
                            "Bill Service (",
                            billServiceTasksCount,
                            ")")) })),
            React.createElement(antd_1.Divider, { style: { margin: 0, padding: 0 } })));
    };
    var AllTasksItem = function () {
        if (!closedBillTaskCount && !closedBillServiceTaskCount) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement(antd_1.List.Item, { actions: [
                    React.createElement("a", { style: { fontWeight: 'bold', textDecoration: 'none' }, href: completeTasksUrl, target: "_blank" }, "See all"),
                ] },
                React.createElement(antd_1.List.Item.Meta, { avatar: React.createElement(antd_1.Badge, { style: { backgroundColor: '#a0a0a0' }, count: totalBillRelatedTasks }), title: React.createElement("span", null, "All Tasks"), description: React.createElement(Text, null, "Completed + Active") }))));
    };
    return (React.createElement(antd_1.Popover, { trigger: totalBillRelatedTasks > 0 ? 'hover' : [], content: React.createElement(antd_1.List, { size: "small", style: { width: '300px' }, dataSource: [OngoingTasksItem, AllTasksItem], itemLayout: "horizontal", split: false, renderItem: function (item) { return item(); } }), onVisibleChange: function (v) {
            setPopoverVisible(v);
        }, placement: "bottom" },
        React.createElement("div", null,
            React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Related Tasks" },
                React.createElement(antd_1.Badge, { count: billTasksCount + billServiceTasksCount, offset: [-5, 5] }, popoverVisible ? React.createElement(svg_icons_1.OngoingTasksHover, { style: utils_1.style }) : React.createElement(svg_icons_1.OngoingTasks, { style: utils_1.style }))))));
};
exports.BillOngoingTasksStatus = BillOngoingTasksStatus;
// garphql query for getting the total number of bill related tasks based on given bill id
exports.BillOngoingTasksStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment BillOngoingTasksFragment on Bill {\n      id\n      billTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      billServiceTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      closedBillTasks: billTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Complete\", \"Canceled\"]}}]\n          }\n        }\n      ) {\n        totalCount\n      }\n      closedBillServiceTasks: billServiceTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Complete\", \"Canceled\"]}}]\n          }\n        }\n      ) {\n        totalCount\n      }\n    }\n  "], ["\n    fragment BillOngoingTasksFragment on Bill {\n      id\n      billTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      billServiceTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      closedBillTasks: billTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Complete\", \"Canceled\"]}}]\n          }\n        }\n      ) {\n        totalCount\n      }\n      closedBillServiceTasks: billServiceTasksByBillId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Complete\", \"Canceled\"]}}]\n          }\n        }\n      ) {\n        totalCount\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/boar_status.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/boar_status.tsx ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoarStatus = void 0;
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var React = __importStar(__webpack_require__(/*! react */ "react"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var BoarStatus = function (_a) {
    var totalCount = _a.boarsByLocationId.totalCount;
    if (totalCount === 0) {
        return null;
    }
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "BOAR" },
        React.createElement(svg_icons_1.Boar, { style: utils_1.style })));
};
exports.BoarStatus = BoarStatus;
exports.BoarStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment BoarFragment on Location {\n      id\n      boarsByLocationId {\n        totalCount\n      }\n    }\n\t"], ["\n    fragment BoarFragment on Location {\n      id\n      boarsByLocationId {\n        totalCount\n      }\n    }\n\t"]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/custom_invoicing_status.tsx":
/*!********************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/custom_invoicing_status.tsx ***!
  \********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomInvoicingStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var antd_1 = __webpack_require__(/*! antd */ "antd");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var CustomInvoicingStatus = function (props) {
    var _a = __read(React.useState(false), 2), popoverVisible = _a[0], setPopoverVisible = _a[1];
    var accountByAccountId = props.accountByAccountId;
    if (accountByAccountId) {
        var notes = accountByAccountId.notes;
        if (notes && notes.totalCount > 0) {
            return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Custom Invoicing" },
                React.createElement(antd_1.Popover, { overlayClassName: "custom-invoicing-popover", overlayStyle: { maxWidth: 300 }, title: "Notes", content: (React.createElement(antd_1.List, { size: "small", dataSource: notes.nodes, renderItem: function (note) { return (React.createElement(antd_1.List.Item, null,
                            React.createElement(antd_1.Comment, { author: note.user.name, content: note.content, datetime: (React.createElement("span", null, (0, moment_1.default)(note.createdAt).format('YYYY-MM-DD'))) }))); } })), onVisibleChange: function (v) { setPopoverVisible(v); } }, !popoverVisible ? (React.createElement(svg_icons_1.CustomInvoicing, { style: utils_1.style })) : (React.createElement(svg_icons_1.CustomInvoicingHover, { style: utils_1.style })))));
        }
    }
    return null;
};
exports.CustomInvoicingStatus = CustomInvoicingStatus;
exports.CustomInvoicingStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment CustomInvoicingFragment on Location {\n      id\n      accountByAccountId {\n        id\n        notes(\n            filter: {\n                flagTypeId: { isNull: true }\n                subtype: { equalTo: \"invoicing\" }\n            }\n        ) {\n          totalCount\n          nodes {\n            id\n            content\n            user: userByWhodunnitId {\n              id\n              name\n            }\n            createdAt\n          }\n        }\n      }\n    }\n  "], ["\n    fragment CustomInvoicingFragment on Location {\n      id\n      accountByAccountId {\n        id\n        notes(\n            filter: {\n                flagTypeId: { isNull: true }\n                subtype: { equalTo: \"invoicing\" }\n            }\n        ) {\n          totalCount\n          nodes {\n            id\n            content\n            user: userByWhodunnitId {\n              id\n              name\n            }\n            createdAt\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/customer_issue_status.tsx":
/*!******************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/customer_issue_status.tsx ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomIssueStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var CustomIssueStatus = function (props) {
    var nodes = props.customIssueWorkflows.nodes;
    if (nodes.length === 0) {
        return null;
    }
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Customer Issue" },
        React.createElement(antd_1.Badge, { count: nodes.length, offset: [-5, 5] },
            React.createElement(svg_icons_1.CustomerIssue, { style: utils_1.style }))));
};
exports.CustomIssueStatus = CustomIssueStatus;
exports.CustomIssueStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tfragment CustomIssueFragment on Location {\n\t\t\tid\n\t\t\tcustomIssueWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tstatus: { equalTo: \"open\" }\n\t\t\t\t\tworkflowByWorkflowId: { name: { equalTo: \"customer_issue\" } }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tcreatedAt\n\t\t\t\t\tworkflowByWorkflowId {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"], ["\n\t\tfragment CustomIssueFragment on Location {\n\t\t\tid\n\t\t\tcustomIssueWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tstatus: { equalTo: \"open\" }\n\t\t\t\t\tworkflowByWorkflowId: { name: { equalTo: \"customer_issue\" } }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tcreatedAt\n\t\t\t\t\tworkflowByWorkflowId {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/hauler_account_issue_status.tsx":
/*!************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/hauler_account_issue_status.tsx ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerAccountIssueStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var HaulerAccountIssueStatus = function (props) {
    var nodes = props.haulerAccountIssueWorkflows.nodes;
    if (nodes.length === 0) {
        return null;
    }
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Hauler Account Issue" },
        React.createElement(antd_1.Badge, { count: nodes.length, offset: [-5, 5] },
            React.createElement(svg_icons_1.HaulerAccountIssue, { style: utils_1.style }))));
};
exports.HaulerAccountIssueStatus = HaulerAccountIssueStatus;
exports.HaulerAccountIssueStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tfragment HaulerAccountIssueFragment on Location {\n\t\t\tid\n\t\t\thaulerAccountIssueWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tworkflowByWorkflowId: { name: { equalTo: \"hauler_account_issue\" } }\n\t\t\t\t\tstatus: { equalTo: \"open\" }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tworkflowByWorkflowId {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"], ["\n\t\tfragment HaulerAccountIssueFragment on Location {\n\t\t\tid\n\t\t\thaulerAccountIssueWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tworkflowByWorkflowId: { name: { equalTo: \"hauler_account_issue\" } }\n\t\t\t\t\tstatus: { equalTo: \"open\" }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tworkflowByWorkflowId {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/hauler_change_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/hauler_change_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerChangeStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var status_icons_1 = __webpack_require__(/*! ../status_icons */ "./src/components/location_status_icons/status_icons/index.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var HaulerChangeStatus = function (props) {
    var nodes = props.serviceChangePeriodsByLocationId.nodes, swapWf = props.haulerSwapWorkflows.nodes;
    var haulerStatus = null;
    var hasHaulerSwap = !!swapWf.find(function (w) {
        var _a = (w || {}).status, status = _a === void 0 ? null : _a;
        return status === 'executed';
    });
    if (!hasHaulerSwap) {
        var hasHaulerChange_1 = false;
        nodes.forEach(function (sh) {
            var _a = (sh || {}), _b = _a.costBasedServiceAsFromService, costBasedServiceAsFromService = _b === void 0 ? null : _b, _c = _a.rateBasedServiceAsFromService, rateBasedServiceAsFromService = _c === void 0 ? null : _c, _d = _a.costBasedServiceAsToService, costBasedServiceAsToService = _d === void 0 ? null : _d, _e = _a.rateBasedServiceAsToService, rateBasedServiceAsToService = _e === void 0 ? null : _e;
            // From hauler must be  hostile, To hauler must be non-hostile
            var _f = (costBasedServiceAsFromService
                || rateBasedServiceAsFromService || {}).haulerByHaulerId, haulerByHaulerId = _f === void 0 ? null : _f;
            var _g = (haulerByHaulerId || {}).hostile, fromHaulerHostile = _g === void 0 ? false : _g;
            if (fromHaulerHostile) {
                // first step passed, now look at toService
                var _h = (costBasedServiceAsToService || rateBasedServiceAsToService || {}).haulerByHaulerId, toHauler = _h === void 0 ? null : _h;
                var _j = (toHauler || {}).hostile, toHaulerHostile = _j === void 0 ? false : _j;
                if (!toHaulerHostile) {
                    hasHaulerChange_1 = true;
                }
            }
        });
        if (hasHaulerChange_1) {
            haulerStatus = 'change';
        }
    }
    else {
        haulerStatus = 'swap';
    }
    if (haulerStatus) {
        return React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: haulerStatus === 'change' ? 'Hauler Change' : 'Hauler Swap' },
            React.createElement(status_icons_1.HaulerChange, { state: haulerStatus, style: utils_1.style }));
    }
    return null;
};
exports.HaulerChangeStatus = HaulerChangeStatus;
exports.HaulerChangeStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment StrategyHistoriesFragment on Location {\n      id\n      haulerSwapWorkflows: workflowInstances(\n        filter: {\n          workflowByWorkflowId: { name: { equalTo: \"hauler_swap\" } }\n        }\n      ) {\n        nodes{\n          id\n          status\n        }\n      }\n      serviceChangePeriodsByLocationId(\n        filter: { changeType: { in: [\"Brokering\", \"Optimization\", \"Diversion\"] } }\n      ) {\n        nodes {\n          id\n          changeType\n          startDate\n          endDate\n          costBasedServiceAsFromService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n          rateBasedServiceAsFromService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n          costBasedServiceAsToService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n          rateBasedServiceAsToService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n        }\n      }\n    }\n  "], ["\n    fragment StrategyHistoriesFragment on Location {\n      id\n      haulerSwapWorkflows: workflowInstances(\n        filter: {\n          workflowByWorkflowId: { name: { equalTo: \"hauler_swap\" } }\n        }\n      ) {\n        nodes{\n          id\n          status\n        }\n      }\n      serviceChangePeriodsByLocationId(\n        filter: { changeType: { in: [\"Brokering\", \"Optimization\", \"Diversion\"] } }\n      ) {\n        nodes {\n          id\n          changeType\n          startDate\n          endDate\n          costBasedServiceAsFromService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n          rateBasedServiceAsFromService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n          costBasedServiceAsToService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n          rateBasedServiceAsToService {\n            id\n            haulerByHaulerId {\n              id\n              hostile\n            }\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/health_status.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/health_status.tsx ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var status_icons_1 = __webpack_require__(/*! ../status_icons/ */ "./src/components/location_status_icons/status_icons/index.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var recently_saved_status_1 = __webpack_require__(/*! ./recently_saved_status */ "./src/components/location_status_icons/status_components/recently_saved_status.tsx");
var hauler_change_status_1 = __webpack_require__(/*! ./hauler_change_status */ "./src/components/location_status_icons/status_components/hauler_change_status.tsx");
var late_payer_status_1 = __webpack_require__(/*! ./late_payer_status */ "./src/components/location_status_icons/status_components/late_payer_status.tsx");
var icon_with_popover_1 = __webpack_require__(/*! ./icon_with_popover */ "./src/components/location_status_icons/status_components/icon_with_popover.tsx");
var HealthStatus = function (props) {
    var healthReasons = [];
    var customIssues = props.importantCustomIssueWorkflows.nodes, deIntegrations = props.deIntegrationWorkflows.nodes, invoices = props.invoicesByLocationId.nodes, forms = props.fleetHaulIntegrationFormsByLocationId.nodes, fprs = props.sixMonthMargin.nodes, _a = props.locationStatusById, primaryKey = _a.primaryKey, secondaryKey = _a.secondaryKey;
    // If it is either primary key or secondary key
    var k = primaryKey || secondaryKey;
    // has customer issue ?
    if (customIssues.find(function (i) { return i.status === 'open' && (k || (0, moment_1.default)(i.createdAt) < (0, moment_1.default)().subtract(5, 'd')); })) {
        healthReasons.push('Has Open Customer Issue and has "Issue" in step 1 answer');
    }
    // has de-integration workflow?
    if (deIntegrations.find(function (i) { return ['open', 'paused'].includes(i.status); })) {
        healthReasons.push('Has De-Integration Workflow');
    }
    // Has late invoice?
    if (invoices.find(function (i) {
        var _a = i.intacctSoTransactionByIntacctSoTransactionDocumentNumber || {}, _b = _a.datePaid, datePaid = _b === void 0 ? null : _b, _c = _a.dateDue, dateDue = _c === void 0 ? null : _c;
        return (!datePaid && !!dateDue &&
            (0, moment_1.default)()
                .subtract(30, 'd')
                .isAfter((0, moment_1.default)(dateDue)));
    })) {
        healthReasons.push('Has Invoice over 30 days');
    }
    if (healthReasons.length > 0) {
        return (React.createElement(icon_with_popover_1.IconWithPopover, { title: "Red", reasons: healthReasons, name: "Health", iconOnHover: React.createElement(status_icons_1.Health, { state: "red", style: utils_1.style, hover: true }) },
            React.createElement(status_icons_1.Health, { state: "red", style: utils_1.style })));
    }
    // Now Look at strategy to determining it's warning or green
    var bodSeparate = (0, utils_1.bodStrat)(props);
    var bod = { b: bodSeparate.b || bodSeparate.o, d: bodSeparate.d };
    var maxMarginPercent = fprs.reduce(function (acc, cur) {
        if (Number(cur.revenue) <= 0)
            return acc;
        return Math.max(acc, (Number(cur.revenue) - Number(cur.cost)) / Number(cur.revenue));
    }, 0);
    if (!bod.b && !bod.d) {
        // no strategy, warning
        healthReasons.push('No Strategy is implemented');
    }
    else if (maxMarginPercent > 0.3) {
        // true = 30% margin, then green
        healthReasons.push('Making 30% margin!');
        return (React.createElement(icon_with_popover_1.IconWithPopover, { title: "No Warning", reasons: healthReasons, name: "Health", iconOnHover: React.createElement(status_icons_1.Health, { state: "green", style: utils_1.style, hover: true }) },
            React.createElement(status_icons_1.Health, { state: "green", style: utils_1.style })));
    }
    else if (!bod.b && (bod.d || forms.find(function (f) { return !f.eligible; }))) {
        healthReasons.push('Not making 30% margin and Not All Strategies are Implemented');
    }
    if (healthReasons.length > 0) {
        return (React.createElement(icon_with_popover_1.IconWithPopover, { title: "Warning", reasons: healthReasons, name: "Health", iconOnHover: React.createElement(status_icons_1.Health, { state: "yellow", style: utils_1.style, hover: true }) },
            React.createElement(status_icons_1.Health, { state: "yellow", style: utils_1.style })));
    }
    // If it is all the way here, it means all strategy are implemented but still not 30% margin
    // Not much we can do
    healthReasons.push("Not making 30% margin but all possible strategies are implemented\n   (Note: D may not be eligible)");
    return (React.createElement(icon_with_popover_1.IconWithPopover, { title: "Reasons", reasons: healthReasons, name: "Health", iconOnHover: React.createElement(status_icons_1.Health, { state: "green", style: utils_1.style, hover: true }) },
        React.createElement(status_icons_1.Health, { state: "green", style: utils_1.style })));
};
exports.HealthStatus = HealthStatus;
exports.HealthStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    fragment HealthFragment on Location {\n      id\n      locationStatusById{\n        id\n        health\n        primaryKey\n        secondaryKey\n      }\n      fleetHaulIntegrationFormsByLocationId {\n        nodes {\n          id\n          eligible\n        }\n      }\n      deIntegrationWorkflows: workflowInstances(\n        filter: { workflowByWorkflowId: { name: { equalTo: \"de-integration\" } } }\n      ) {\n        nodes {\n          id\n          status\n          updatedAt\n        }\n      }\n      importantCustomIssueWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tstatus: { equalTo: \"open\" }\n          workflowByWorkflowId: { name: { equalTo: \"customer_issue\" } }\n            workflowExecutionsByWorkflowInstanceId:{\n            some:{\n              workflowStepByWorkflowStepId:{order:{equalTo:1}}\n              customAnswer:{includesInsensitive:\"Issue\"}\n            }\n          }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tcreatedAt\n\t\t\t\t\tworkflowByWorkflowId {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n        }\n      }\n      sixMonthMargin: financePerformanceReportsSnapshotsByLocationId(orderBy:MONTH_DESC,first:6,offset:1){\n        nodes{\n          month\n          revenue\n          cost\n        }\n      }\n      ...StrategyHistoriesFragment\n      ...LatePayerFragment\n      ...RecentlySavedFragment\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    fragment HealthFragment on Location {\n      id\n      locationStatusById{\n        id\n        health\n        primaryKey\n        secondaryKey\n      }\n      fleetHaulIntegrationFormsByLocationId {\n        nodes {\n          id\n          eligible\n        }\n      }\n      deIntegrationWorkflows: workflowInstances(\n        filter: { workflowByWorkflowId: { name: { equalTo: \"de-integration\" } } }\n      ) {\n        nodes {\n          id\n          status\n          updatedAt\n        }\n      }\n      importantCustomIssueWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tstatus: { equalTo: \"open\" }\n          workflowByWorkflowId: { name: { equalTo: \"customer_issue\" } }\n            workflowExecutionsByWorkflowInstanceId:{\n            some:{\n              workflowStepByWorkflowStepId:{order:{equalTo:1}}\n              customAnswer:{includesInsensitive:\"Issue\"}\n            }\n          }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tcreatedAt\n\t\t\t\t\tworkflowByWorkflowId {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n        }\n      }\n      sixMonthMargin: financePerformanceReportsSnapshotsByLocationId(orderBy:MONTH_DESC,first:6,offset:1){\n        nodes{\n          month\n          revenue\n          cost\n        }\n      }\n      ...StrategyHistoriesFragment\n      ...LatePayerFragment\n      ...RecentlySavedFragment\n    }\n  "])), recently_saved_status_1.RecentlySavedStatus.fragment.fields, hauler_change_status_1.HaulerChangeStatus.fragment.fields, late_payer_status_1.LatePayerStatus.fragment.fields),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/hostile_hauler_status.tsx":
/*!******************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/hostile_hauler_status.tsx ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostileHaulerStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var root_status_1 = __webpack_require__(/*! ./root_status */ "./src/components/location_status_icons/status_components/root_status.tsx");
var HostileHaulerStatus = function (props) {
    var cbses = props.costBasedServicesByLocationId.nodes, rbses = props.rateBasedServicesByLocationId.nodes;
    var hostileHaulers = [];
    __spreadArray(__spreadArray([], __read(cbses), false), __read(rbses), false).forEach(function (s) {
        if (s.haulerByHaulerId.hostile) {
            hostileHaulers.push(s.haulerByHaulerId.id);
        }
    });
    var uniqueHH = __spreadArray([], __read(new Set(hostileHaulers)), false);
    if (uniqueHH.length > 0) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Hostile Hauler" },
            React.createElement(antd_1.Badge, { count: uniqueHH.length, offset: [-5, 5] },
                React.createElement(svg_icons_1.HostileHauler, { style: utils_1.style }))));
    }
    return null;
};
exports.HostileHaulerStatus = HostileHaulerStatus;
exports.HostileHaulerStatus.fragment = root_status_1.RootStatus.fragment;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/icon_text_wrapper.tsx ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTextWrapper = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
/**
 * @description Wrapper Component that add the bottom text under an Icon. This is very specific to
 * Location Status Icons, because it also sets the left margin, and width to be exactly 60.
 * This is to align multiple icons on the same line and spread from each other.
 * @param props props need an attribute "text" which is the text at the bottom of icon.
 *
 */
var IconTextWrapper = function (props) {
    var text = props.text;
    return React.createElement("div", { style: { float: 'left', width: 60, marginRight: 6, marginLeft: 6, textAlign: 'center' } },
        props.children,
        React.createElement("span", { style: {
                display: 'block',
                fontFamily: 'Lato',
                fontSize: 12,
                fontWeight: 'bold',
                letterSpacing: 1.4,
                textAlign: 'center',
            } }, text));
};
exports.IconTextWrapper = IconTextWrapper;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/icon_with_popover.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/icon_with_popover.tsx ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithPopover = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
__webpack_require__(/*! antd/lib/popover/style */ "./node_modules/antd/lib/popover/style/index.js");
/**
 * @description Wrapper Component on an Icon with Popover. It also adds the IconTextWrapper
 * to just make the code nicer. These two components are not very reusable so they are put in here.
 * @param {string} title title of popover
 * @param {string[]} reasons  a list of string for popover display.
 * @param {string} name the bottom text of icon.
 * @param {React.Node} iconOnHover The icon to display when hovering the icon, this is to provide
 * an alternative icon to toggle
 */
var IconWithPopover = function (props) {
    var _a = __read(React.useState(false), 2), popup = _a[0], setPopup = _a[1];
    var title = props.title, reasons = props.reasons, name = props.name, iconOnHover = props.iconOnHover;
    var content = (React.createElement(React.Fragment, null, reasons.map(function (r) { return (React.createElement("p", { key: r }, r)); })));
    var icon = popup && iconOnHover ? iconOnHover : props.children;
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: name },
        React.createElement(antd_1.Popover, { title: title, content: content, onVisibleChange: function (v) { setPopup(v); } }, icon),
        " "));
};
exports.IconWithPopover = IconWithPopover;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/index.ts":
/*!*************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/index.ts ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./__generated__ */ "./src/components/location_status_icons/status_components/__generated__/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./big_portfolio_status */ "./src/components/location_status_icons/status_components/big_portfolio_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./customer_issue_status */ "./src/components/location_status_icons/status_components/customer_issue_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./hauler_account_issue_status */ "./src/components/location_status_icons/status_components/hauler_account_issue_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./hauler_change_status */ "./src/components/location_status_icons/status_components/hauler_change_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./health_status */ "./src/components/location_status_icons/status_components/health_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./hostile_hauler_status */ "./src/components/location_status_icons/status_components/hostile_hauler_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx"), exports);
__exportStar(__webpack_require__(/*! ./icon_with_popover */ "./src/components/location_status_icons/status_components/icon_with_popover.tsx"), exports);
__exportStar(__webpack_require__(/*! ./invoice_block_status */ "./src/components/location_status_icons/status_components/invoice_block_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./key_status */ "./src/components/location_status_icons/status_components/key_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./late_payer_status */ "./src/components/location_status_icons/status_components/late_payer_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./liquidation_status */ "./src/components/location_status_icons/status_components/liquidation_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./new_status */ "./src/components/location_status_icons/status_components/new_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./pay_ahead_status */ "./src/components/location_status_icons/status_components/pay_ahead_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./payment_terms_status */ "./src/components/location_status_icons/status_components/payment_terms_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./pdm_status */ "./src/components/location_status_icons/status_components/pdm_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./recently_saved_status */ "./src/components/location_status_icons/status_components/recently_saved_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./root_status */ "./src/components/location_status_icons/status_components/root_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./secondary_key_status */ "./src/components/location_status_icons/status_components/secondary_key_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./shared_saving_status */ "./src/components/location_status_icons/status_components/shared_saving_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./strategy_status */ "./src/components/location_status_icons/status_components/strategy_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./custom_invoicing_status */ "./src/components/location_status_icons/status_components/custom_invoicing_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./boar_status */ "./src/components/location_status_icons/status_components/boar_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./recycle_more_status */ "./src/components/location_status_icons/status_components/recycle_more_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./mgp_ranking */ "./src/components/location_status_icons/status_components/mgp_ranking.tsx"), exports);
__exportStar(__webpack_require__(/*! ./bill_blocker_status */ "./src/components/location_status_icons/status_components/bill_blocker_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./ongoing_tasks_status */ "./src/components/location_status_icons/status_components/ongoing_tasks_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./service_ongoing_tasks_status */ "./src/components/location_status_icons/status_components/service_ongoing_tasks_status.tsx"), exports);
__exportStar(__webpack_require__(/*! ./bill_ongoing_tasks_status */ "./src/components/location_status_icons/status_components/bill_ongoing_tasks_status.tsx"), exports);


/***/ }),

/***/ "./src/components/location_status_icons/status_components/invoice_block_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/invoice_block_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceBlockerStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var InvoiceBlockerStatus = function (props) {
    var invoiceBlocker = props.invoiceBlocker;
    if (invoiceBlocker) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Invoice Blocked" },
            React.createElement(svg_icons_1.InvoiceBlocker, { style: utils_1.style })));
    }
    return null;
};
exports.InvoiceBlockerStatus = InvoiceBlockerStatus;
exports.InvoiceBlockerStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment InvoiceBlockerFragment on Location {\n      id\n      invoiceBlocker\n    }\n  "], ["\n    fragment InvoiceBlockerFragment on Location {\n      id\n      invoiceBlocker\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/key_status.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/key_status.tsx ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var hauler_change_status_1 = __webpack_require__(/*! ./hauler_change_status */ "./src/components/location_status_icons/status_components/hauler_change_status.tsx");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_with_popover_1 = __webpack_require__(/*! ./icon_with_popover */ "./src/components/location_status_icons/status_components/icon_with_popover.tsx");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var KeyStatus = function (props) {
    var _a = __read(React.useState(false), 2), popup = _a[0], setPopup = _a[1];
    var _b = props.coyoteUrl, coyoteUrl = _b === void 0 ? '' : _b;
    var reasons = exports.KeyStatus.passCheck(props);
    if (reasons.length > 0) {
        return (React.createElement(icon_with_popover_1.IconWithPopover, { title: "Key Reasons", reasons: reasons, name: "Key", iconOnHover: React.createElement(svg_icons_1.KeyHover, { style: utils_1.style }) },
            React.createElement(svg_icons_1.Key, { style: utils_1.style })));
    }
    // It is also possible to be a secondary key
    var siblingKeyLocations = exports.KeyStatus.passSecondaryCheck(props);
    if (siblingKeyLocations.length > 0) {
        var content = (React.createElement(React.Fragment, null, siblingKeyLocations.map(function (l) { return (React.createElement("p", { key: l.id },
            React.createElement("a", { href: "".concat(coyoteUrl, "/locations/").concat(l.id) }, l.name))); })));
        var icon = popup ? React.createElement(svg_icons_1.SecondKeyHover, { style: utils_1.style }) : React.createElement(svg_icons_1.SecondKey, { style: utils_1.style });
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Secondary Key" },
            React.createElement(antd_1.Popover, { title: "Other Locs that are Primary Key", content: content, onVisibleChange: function (v) { setPopup(v); } }, icon)));
    }
    return null;
};
exports.KeyStatus = KeyStatus;
exports.KeyStatus.passCheck = function (props) {
    var swapWfs = props.haulerSwapWorkflows.nodes, liqWfs = props.liquidationWorkflows.nodes, lsv = props.locationSalesValuesByLocationId.nodes, manualNotKey = props.manualNotKey, fprs = props.sixMonthMargin.nodes, manualKey = props.accountByAccountId.portfolioByPortfolioId.manualKey;
    var keyReasons = [];
    // First check workflow
    if (swapWfs.find(function (w) { return w.status !== 'forfeited'; }) || liqWfs.find(function (w) { return w.status !== 'forfeited'; })) {
        keyReasons.push('Has Swap or Liquidation Workflow');
    }
    // Then check override keys
    if (manualNotKey) {
        // The location has override set, so don't look further
        return keyReasons;
    }
    if (manualKey) {
        keyReasons.push('Has Manual Key to set it Key');
    }
    // three conditions. 1. lsv.mrr is greater than 5000
    var totalMrr = lsv.reduce(function (acc, cur) { return acc + Number(cur.mrr); }, 0);
    if (totalMrr > 5000) {
        keyReasons.push('Monthly Recurring Revenue > $5000');
    }
    // 2. if have all BO and D this month, and last invoice is > 1500
    var bodSeparate = (0, utils_1.bodStrat)(props);
    var bod = { b: bodSeparate.b || bodSeparate.o, d: bodSeparate.d };
    // Max revenue of the last 6 month
    var revenue = fprs.reduce(function (acc, cur) {
        return Math.max(acc, Number(cur.revenue));
    }, 0);
    if (bod.b && bod.d && revenue > 1500) {
        keyReasons.push('Implemented BOD and Revenue > $1500');
    }
    // 3. if have BO not D, but invoice is > 2500
    if (bod.b && !bod.d && revenue > 2500) {
        keyReasons.push('Implemented BO and Revenue > $2500');
    }
    return keyReasons;
};
exports.KeyStatus.passSecondaryCheck = function (props) {
    var id = props.id, nodes = props.accountByAccountId.portfolioByPortfolioId.accountsByPortfolioId.nodes;
    var primaryKeyLocations = [];
    nodes.forEach(function (acc) {
        var locs = acc.keyLocations.nodes;
        locs.forEach(function (loc) {
            if (loc.id !== id && exports.KeyStatus.isPrimaryKey(loc)) {
                primaryKeyLocations.push(loc);
            }
        });
    });
    return primaryKeyLocations;
};
exports.KeyStatus.isPrimaryKey = function (props) {
    var primaryKey = props.locationStatusById.primaryKey;
    return primaryKey;
};
exports.KeyStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    fragment PrimaryKeyFragment on Location {\n      id\n      name\n      ...StrategyHistoriesFragment\n      liquidationWorkflows: workflowInstances(\n        filter: {\n          workflowByWorkflowId: { name: { equalTo: \"hauler_liquidation\" } }\n        }\n      ) {\n        nodes{\n          id\n          status\n        }\n      }\n      manualNotKey\n      accountByAccountId{\n        id\n        portfolioByPortfolioId{\n          id\n          manualKey\n        }\n      }\n      locationSalesValuesByLocationId(\n        filter: { salesforceOpportunityBySalesforceOpportunityId: { isWon: { equalTo: true } } }\n      ) {\n        nodes {\n          locationId\n          mrr\n          margin\n        }\n      }\n      sixMonthMargin: financePerformanceReportsSnapshotsByLocationId(orderBy:MONTH_DESC,first:6,offset:1){\n        nodes{\n          month\n          revenue\n          cost\n        }\n      }\n    }\n    fragment IsPrimaryKeyFragment on Location {\n      id\n      name\n      locationStatusById{\n        id\n        primaryKey\n      }\n    }\n    fragment SecondaryKeyFragment on Location {\n      id\n      accountByAccountId {\n        id\n        paymentTerms\n        portfolioByPortfolioId {\n          id\n          manualKey\n          accountsByPortfolioId {\n            nodes {\n              id\n              keyLocations: locationsByAccountId(filter:{locationStatusById:{primaryKey:{equalTo:true}}}) {\n                nodes {\n                  ...IsPrimaryKeyFragment\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    fragment KeyFragment on Location {\n      ...PrimaryKeyFragment\n      ...SecondaryKeyFragment\n    }\n  "], ["\n    ", "\n    fragment PrimaryKeyFragment on Location {\n      id\n      name\n      ...StrategyHistoriesFragment\n      liquidationWorkflows: workflowInstances(\n        filter: {\n          workflowByWorkflowId: { name: { equalTo: \"hauler_liquidation\" } }\n        }\n      ) {\n        nodes{\n          id\n          status\n        }\n      }\n      manualNotKey\n      accountByAccountId{\n        id\n        portfolioByPortfolioId{\n          id\n          manualKey\n        }\n      }\n      locationSalesValuesByLocationId(\n        filter: { salesforceOpportunityBySalesforceOpportunityId: { isWon: { equalTo: true } } }\n      ) {\n        nodes {\n          locationId\n          mrr\n          margin\n        }\n      }\n      sixMonthMargin: financePerformanceReportsSnapshotsByLocationId(orderBy:MONTH_DESC,first:6,offset:1){\n        nodes{\n          month\n          revenue\n          cost\n        }\n      }\n    }\n    fragment IsPrimaryKeyFragment on Location {\n      id\n      name\n      locationStatusById{\n        id\n        primaryKey\n      }\n    }\n    fragment SecondaryKeyFragment on Location {\n      id\n      accountByAccountId {\n        id\n        paymentTerms\n        portfolioByPortfolioId {\n          id\n          manualKey\n          accountsByPortfolioId {\n            nodes {\n              id\n              keyLocations: locationsByAccountId(filter:{locationStatusById:{primaryKey:{equalTo:true}}}) {\n                nodes {\n                  ...IsPrimaryKeyFragment\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    fragment KeyFragment on Location {\n      ...PrimaryKeyFragment\n      ...SecondaryKeyFragment\n    }\n  "])), hauler_change_status_1.HaulerChangeStatus.fragment.fields),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/late_payer_status.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/late_payer_status.tsx ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatePayerStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var LatePayerStatus = function (props) {
    var latePayer = exports.LatePayerStatus.passCheck(props);
    if (latePayer) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Late Payer" },
            React.createElement(svg_icons_1.LatePayer, { style: utils_1.style })));
    }
    return null;
};
exports.LatePayerStatus = LatePayerStatus;
exports.LatePayerStatus.passCheck = function (props) {
    var nodes = props.invoicesByLocationId.nodes;
    var totalLateDays = nodes.reduce(function (total, cur) {
        var _a = cur.intacctSoTransactionByIntacctSoTransactionDocumentNumber || {}, _b = _a.datePaid, datePaid = _b === void 0 ? undefined : _b, _c = _a.dateDue, dateDue = _c === void 0 ? undefined : _c;
        var datePaidMoment = !!datePaid ? (0, moment_1.default)(datePaid) : (0, moment_1.default)();
        var dateDueMoment = !!dateDue ? (0, moment_1.default)(dateDue) : (0, moment_1.default)();
        return total + Math.max(0, datePaidMoment.diff(dateDueMoment, 'days'));
    }, 0);
    var avgLateDays = nodes.length > 0 ? totalLateDays / nodes.length : 0;
    // if average 8 days late
    return avgLateDays > 8;
};
exports.LatePayerStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment LatePayerFragment on Location {\n      id\n      invoicesByLocationId {\n        nodes {\n          id\n          intacctSoTransactionByIntacctSoTransactionDocumentNumber {\n            id\n            datePaid\n            dateDue\n          }\n        }\n      }\n    }\n  "], ["\n    fragment LatePayerFragment on Location {\n      id\n      invoicesByLocationId {\n        nodes {\n          id\n          intacctSoTransactionByIntacctSoTransactionDocumentNumber {\n            id\n            datePaid\n            dateDue\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/liquidation_status.tsx":
/*!***************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/liquidation_status.tsx ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidationStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var antd_1 = __webpack_require__(/*! antd */ "antd");
__webpack_require__(/*! antd/lib/badge/style */ "./node_modules/antd/lib/badge/style/index.js");
var LiquidationStatus = function (props) {
    var nodes = props.haulerAccountsToLocationsByLocationId.nodes;
    var liquidatedAccounts = nodes.reduce(function (acc, cur) {
        var _a;
        if (acc)
            return acc;
        var _b = cur.haulerAccountByHaulerAccountId, id = _b.id, totalCount = _b.haulerLiquidationsByHaulerAccountId.totalCount;
        if (totalCount > 0) {
            return __assign(__assign({}, acc), (_a = {}, _a[id] = true, _a));
        }
        return acc;
    }, {});
    var accountIds = Object.keys(liquidatedAccounts);
    if (accountIds.length > 0) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Liquidation" },
            React.createElement(antd_1.Badge, { count: accountIds.length, offset: [-5, 5] },
                React.createElement(svg_icons_1.Liquidation, { style: utils_1.style }))));
    }
    return null;
};
exports.LiquidationStatus = LiquidationStatus;
exports.LiquidationStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment LiquidationFragment on Location {\n      id\n      haulerAccountsToLocationsByLocationId {\n        nodes {\n          id\n          haulerAccountByHaulerAccountId {\n            id\n            haulerLiquidationsByHaulerAccountId {\n              totalCount\n            }\n          }\n        }\n      }\n    }\n  "], ["\n    fragment LiquidationFragment on Location {\n      id\n      haulerAccountsToLocationsByLocationId {\n        nodes {\n          id\n          haulerAccountByHaulerAccountId {\n            id\n            haulerLiquidationsByHaulerAccountId {\n              totalCount\n            }\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/mgp_ranking.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/mgp_ranking.tsx ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MgpRanking = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var mgp_1 = __webpack_require__(/*! ../status_icons/mgp */ "./src/components/location_status_icons/status_icons/mgp.tsx");
var validation_1 = __webpack_require__(/*! ../../../validation/ */ "./src/validation/index.ts");
/**
 * @description This function get the tier based on an array of thresholds and the mgp value
 * The thresholds must be in ascending order. 2 values in the array would define 3 ranges:
 *  - infinity ~ value1, value1 ~ value2, and value 2 ~ +infinity.
 * @param mgp
 * @param thresholds
 */
var getTierFromMgp = function (mgp, thresholds) {
    if (mgp === null || mgp === undefined)
        return 0;
    var mgpNumber = Number(mgp);
    for (var i = 0; i < thresholds.length; i += 1) {
        if (mgpNumber < thresholds[i]) {
            return thresholds.length + 1 - i;
        }
    }
    // If the value is greater than the last value in the array then it's tier 1
    if (mgpNumber >= thresholds[thresholds.length - 1]) {
        return 1;
    }
    return 0;
};
var MgpRanking = function (props) {
    var thresholds = props.thresholds, portfolioByPortfolioId = props.accountByAccountId.portfolioByPortfolioId;
    var mgp = (0, validation_1.dig)(['portfolioInfoById', 'mgp'], portfolioByPortfolioId) || 0;
    var tier = getTierFromMgp(mgp, thresholds);
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "MGP Ranking" },
        React.createElement(mgp_1.Mgp, { style: utils_1.style, tier: tier })));
};
exports.MgpRanking = MgpRanking;
exports.MgpRanking.getTierFromMgp = getTierFromMgp;
exports.MgpRanking.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment MgpRankingFragment on Location {\n    id\n    accountByAccountId{\n      id\n      portfolioByPortfolioId{\n        id\n        portfolioInfoById{\n          id\n          mgp\n        }\n      }\n    }\n  }\n  "], ["\n  fragment MgpRankingFragment on Location {\n    id\n    accountByAccountId{\n      id\n      portfolioByPortfolioId{\n        id\n        portfolioInfoById{\n          id\n          mgp\n        }\n      }\n    }\n  }\n  "]))),
};
var templateObject_1;
// StrategyStatus.fragment = HaulerChangeStatus.fragment;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/new_status.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/new_status.tsx ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var NewStatus = function (props) {
    var integrationDate = props.integrationDate, salesStatus = props.salesStatus, opsStatus = props.opsStatus;
    var isNew = salesStatus === 'ClosedWon' && (opsStatus === 'Pending-Integration' ||
        (0, moment_1.default)(integrationDate)
            .add(90, 'd')
            .isAfter((0, moment_1.default)()));
    if (isNew) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "New" },
            React.createElement(svg_icons_1.New, { style: utils_1.style })));
    }
    return null;
};
exports.NewStatus = NewStatus;
exports.NewStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment NewFragment on Location {\n      id\n      salesStatus\n      opsStatus\n      integrationDate\n    }\n  "], ["\n    fragment NewFragment on Location {\n      id\n      salesStatus\n      opsStatus\n      integrationDate\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/ongoing_tasks_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/ongoing_tasks_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OngoingTasksStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var Text = antd_1.Typography.Text;
var OngoingTasksStatus = function (props) {
    var _a = __read(React.useState(false), 2), popoverVisible = _a[0], setPopoverVisible = _a[1];
    var locationId = props.id, analysisCount = props.analysisTasksByLocationId.totalCount, serviceCount = props.serviceTasksByLocationId.totalCount, locationCount = props.locationToLocationTasksByLocationId.totalCount, bills = props.billToLocationsByLocationId.nodes;
    var billCount = 0;
    var billServiceCount = 0;
    bills.forEach(function (node) {
        billCount += node.billByBillId.billTasksByBillId.totalCount;
        billServiceCount += node.billByBillId.billServiceTasksByBillId.totalCount;
    });
    var total = analysisCount + serviceCount + locationCount + billCount + billServiceCount;
    var data = [];
    data.push({ type: 'Ongoing Tasks', count: total, paramValue: undefined });
    if (analysisCount > 0) {
        data.push({ type: 'Analysis', count: analysisCount, paramValue: 'analysis' });
    }
    if (billCount > 0) {
        data.push({ type: 'Bill', count: billCount, paramValue: 'bill' });
    }
    if (billServiceCount > 0) {
        data.push({ type: 'Bill Service', count: billServiceCount, paramValue: 'billService' });
    }
    if (locationCount > 0) {
        data.push({ type: 'Location', count: locationCount, paramValue: 'location' });
    }
    if (serviceCount > 0) {
        data.push({ type: 'Service', count: serviceCount, paramValue: 'service' });
    }
    if (total <= 0) {
        return null;
    }
    return (React.createElement(antd_1.Popover, { trigger: total > 0 ? 'hover' : [], content: React.createElement(antd_1.List, { size: "small", style: { width: '300px' }, dataSource: data, itemLayout: "horizontal", split: false, renderItem: function (item, index) {
                if (index === 0) {
                    return (React.createElement("div", null,
                        React.createElement(antd_1.List.Item, { actions: [
                                React.createElement("a", { style: { fontWeight: 'bold', textDecoration: 'none' }, href: "/base_tasks?location=".concat(locationId), target: "_blank" }, "See all"),
                            ] },
                            React.createElement(antd_1.List.Item.Meta, { avatar: React.createElement(antd_1.Badge, { count: item.count }), title: React.createElement(Text, { style: { fontWeight: 'bold' } }, item.type) })),
                        React.createElement(antd_1.Divider, { style: { margin: 0, padding: 0 } })));
                }
                var url = "/base_tasks?location=".concat(locationId, "&type=").concat(item.paramValue);
                return (React.createElement("div", null,
                    React.createElement(antd_1.List.Item, { actions: [
                            React.createElement("a", { style: { fontWeight: 'bold', textDecoration: 'none' }, href: url, target: "_blank" }, "See"),
                        ] },
                        React.createElement(antd_1.List.Item.Meta, { avatar: React.createElement(antd_1.Badge, { count: item.count }), title: React.createElement(Text, null, item.type) }))));
            } }), onVisibleChange: function (v) {
            setPopoverVisible(v);
        }, placement: "bottom" },
        React.createElement("div", null,
            React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Ongoing Tasks" },
                React.createElement(antd_1.Badge, { count: total, offset: [-5, 5] }, popoverVisible ? React.createElement(svg_icons_1.OngoingTasksHover, { style: utils_1.style }) : React.createElement(svg_icons_1.OngoingTasks, { style: utils_1.style }))))));
};
exports.OngoingTasksStatus = OngoingTasksStatus;
// Drilling down to waitingOnUserId because any non-null waitingOnUserId
// means the task is open/awaiting approval/flagged
exports.OngoingTasksStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment OngoingTasksFragment on Location {\n      id\n      analysisTasksByLocationId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      serviceTasksByLocationId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      locationToLocationTasksByLocationId(\n        filter: {\n          locationTaskByLocationTaskId: {\n            baseTaskByBaseTaskId: {\n              or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n            }\n          }\n        }\n      ) {\n        totalCount\n      }\n      billToLocationsByLocationId {\n        nodes {\n          billByBillId {\n            billTasksByBillId(\n              filter: {\n                baseTaskByBaseTaskId: {\n                  or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n                }\n              }\n            ) {\n              totalCount\n            }\n            billServiceTasksByBillId(\n              filter: {\n                baseTaskByBaseTaskId: {\n                  or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n                }\n              }\n            ) {\n              totalCount\n            }\n          }\n        }\n      }\n    }\n  "], ["\n    fragment OngoingTasksFragment on Location {\n      id\n      analysisTasksByLocationId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      serviceTasksByLocationId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n          }\n        }\n      ) {\n        totalCount\n      }\n      locationToLocationTasksByLocationId(\n        filter: {\n          locationTaskByLocationTaskId: {\n            baseTaskByBaseTaskId: {\n              or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n            }\n          }\n        }\n      ) {\n        totalCount\n      }\n      billToLocationsByLocationId {\n        nodes {\n          billByBillId {\n            billTasksByBillId(\n              filter: {\n                baseTaskByBaseTaskId: {\n                  or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n                }\n              }\n            ) {\n              totalCount\n            }\n            billServiceTasksByBillId(\n              filter: {\n                baseTaskByBaseTaskId: {\n                  or: [{ status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] } }]\n                }\n              }\n            ) {\n              totalCount\n            }\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/pay_ahead_status.tsx":
/*!*************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/pay_ahead_status.tsx ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayAheadStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var PayAheadStatus = function (props) {
    var alwaysPayBills = props.alwaysPayBills;
    if (alwaysPayBills) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Pay Ahead" },
            React.createElement(svg_icons_1.PayAhead, { style: utils_1.style })));
    }
    return null;
};
exports.PayAheadStatus = PayAheadStatus;
exports.PayAheadStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment PayAheadFragment on Location {\n      id\n      alwaysPayBills\n    }\n  "], ["\n    fragment PayAheadFragment on Location {\n      id\n      alwaysPayBills\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/payment_terms_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/payment_terms_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTermStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var status_icons_1 = __webpack_require__(/*! ../status_icons/ */ "./src/components/location_status_icons/status_icons/index.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var PaymentTermStatus = function (props) {
    var paymentTerms = props.accountByAccountId.paymentTerms;
    return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Pay Terms" },
        React.createElement(status_icons_1.PaymentTerm, { state: "".concat(paymentTerms), style: utils_1.style })));
};
exports.PaymentTermStatus = PaymentTermStatus;
exports.PaymentTermStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment PaymentTermFragment on Location {\n      id\n      accountByAccountId {\n        id\n        paymentTerms\n      }\n    }\n  "], ["\n    fragment PaymentTermFragment on Location {\n      id\n      accountByAccountId {\n        id\n        paymentTerms\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/pdm_status.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/pdm_status.tsx ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdmStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var root_status_1 = __webpack_require__(/*! ./root_status */ "./src/components/location_status_icons/status_components/root_status.tsx");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var PdmStatus = function (props) {
    var allCbses = props.allCbses, allRbses = props.allRbses, activeCbses = props.costBasedServicesByLocationId.nodes, activeRbses = props.rateBasedServicesByLocationId.nodes;
    var pdmEngagementCount = (0, utils_1.countEngagements)({ allCbses: allCbses, allRbses: allRbses, type: 'PDM' });
    var pdm = (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "PDM" },
        React.createElement(antd_1.Badge, { count: pdmEngagementCount, offset: [-5, 5] },
            React.createElement(svg_icons_1.Pdm, { style: utils_1.style }))));
    if (pdmEngagementCount > 0) {
        return pdm;
    }
    var isPdm = activeCbses.reduce(function (acc, cur) { return acc || cur.isPdm; }, false);
    isPdm = activeRbses.reduce(function (acc, cur) { return acc || (cur.isPdm && !cur.rootId); }, isPdm);
    if (isPdm) {
        return pdm;
    }
    return null;
};
exports.PdmStatus = PdmStatus;
exports.PdmStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    fragment AllServicesEngagementFragment on Location {\n      id\n      ...ActiveServicesFragment\n      allCbses: costBasedServicesByLocationId {\n        nodes {\n          id\n          forecastSnapshots {\n            nodes {\n              id\n              engagementToServicesByForecastSnapshotId(\n                filter: {\n                  engagementByEngagementId: {\n                    internalContractByEngagementId: { status: { equalTo: \"Active\" } }\n                  }\n                }\n              ) {\n                nodes {\n                  id\n                  engagementByEngagementId {\n                    id\n                    engagementType\n                    contractNumber\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      allRbses: rateBasedServicesByLocationId {\n        nodes {\n          id\n          forecastSnapshots {\n            nodes {\n              id\n              engagementToServicesByForecastSnapshotId(\n                filter: {\n                  engagementByEngagementId: {\n                    internalContractByEngagementId: { status: { equalTo: \"Active\" } }\n                  }\n                }\n              ) {\n                nodes {\n                  id\n                  engagementByEngagementId {\n                    id\n                    engagementType\n                    contractNumber\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  "], ["\n    ", "\n    fragment AllServicesEngagementFragment on Location {\n      id\n      ...ActiveServicesFragment\n      allCbses: costBasedServicesByLocationId {\n        nodes {\n          id\n          forecastSnapshots {\n            nodes {\n              id\n              engagementToServicesByForecastSnapshotId(\n                filter: {\n                  engagementByEngagementId: {\n                    internalContractByEngagementId: { status: { equalTo: \"Active\" } }\n                  }\n                }\n              ) {\n                nodes {\n                  id\n                  engagementByEngagementId {\n                    id\n                    engagementType\n                    contractNumber\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      allRbses: rateBasedServicesByLocationId {\n        nodes {\n          id\n          forecastSnapshots {\n            nodes {\n              id\n              engagementToServicesByForecastSnapshotId(\n                filter: {\n                  engagementByEngagementId: {\n                    internalContractByEngagementId: { status: { equalTo: \"Active\" } }\n                  }\n                }\n              ) {\n                nodes {\n                  id\n                  engagementByEngagementId {\n                    id\n                    engagementType\n                    contractNumber\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  "])), root_status_1.RootStatus.fragment.fields),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/recently_saved_status.tsx":
/*!******************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/recently_saved_status.tsx ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentlySavedStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var RecentlySavedStatus = function (props) {
    var nodes = props.savedDeIntegrationWorkflows.nodes;
    var n = nodes.find(function (w) {
        var status = w.status, updatedAt = w.updatedAt;
        if (status === 'forfeited' &&
            (0, moment_1.default)(updatedAt).isAfter((0, moment_1.default)().subtract(30, 'd'))) {
            return true;
        }
        return false;
    });
    if (n) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Recently Saved" },
            React.createElement(svg_icons_1.RecentlySaved, { style: utils_1.style })));
    }
    return null;
};
exports.RecentlySavedStatus = RecentlySavedStatus;
exports.RecentlySavedStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tfragment RecentlySavedFragment on Location {\n\t\t\tid\n\t\t\tsavedDeIntegrationWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tworkflowByWorkflowId: { name: { equalTo: \"de-integration\" } }\n\t\t\t\t\tworkflowExecutionsByWorkflowInstanceId: {\n\t\t\t\t\t\tsome: {\n\t\t\t\t\t\t\tworkflowStepId: { equalTo: 505 } # This is for the save step\n\t\t\t\t\t\t\tbooleanAnswer: { equalTo: true }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tstatus: { equalTo: \"forfeited\" }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tupdatedAt\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"], ["\n\t\tfragment RecentlySavedFragment on Location {\n\t\t\tid\n\t\t\tsavedDeIntegrationWorkflows: workflowInstances(\n\t\t\t\tfilter: {\n\t\t\t\t\tworkflowByWorkflowId: { name: { equalTo: \"de-integration\" } }\n\t\t\t\t\tworkflowExecutionsByWorkflowInstanceId: {\n\t\t\t\t\t\tsome: {\n\t\t\t\t\t\t\tworkflowStepId: { equalTo: 505 } # This is for the save step\n\t\t\t\t\t\t\tbooleanAnswer: { equalTo: true }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tstatus: { equalTo: \"forfeited\" }\n\t\t\t\t}\n\t\t\t) {\n\t\t\t\tnodes {\n\t\t\t\t\tid\n\t\t\t\t\tstatus\n\t\t\t\t\tupdatedAt\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/recycle_more_status.tsx":
/*!****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/recycle_more_status.tsx ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecycleMoreStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var RecycleMoreStatus = function (props) {
    var recycleMoreWorkflows = props.recycleMoreWorkflows;
    var recycleMoreCandidate = recycleMoreWorkflows &&
        recycleMoreWorkflows.nodes.length > 0;
    var hasRecycleMore = recycleMoreCandidate &&
        recycleMoreWorkflows.nodes.some(function (workflowInstance) {
            var recycleMoreExecutions = workflowInstance.recycleMoreExecutions;
            return recycleMoreExecutions && recycleMoreExecutions.totalCount >= 1;
        });
    if (recycleMoreCandidate || hasRecycleMore) {
        var iconText = hasRecycleMore ? 'Recycle More' : 'Recycle More Candidate';
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: iconText },
            React.createElement(svg_icons_1.RecycleMore, { style: utils_1.style })));
    }
    return null;
};
exports.RecycleMoreStatus = RecycleMoreStatus;
exports.RecycleMoreStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment RecycleMoreFragment on Location {\n      id\n      recycleMoreWorkflows: workflowInstances(\n        filter: {\n          status: { in: [\"open\", \"executed\", \"paused\"] }\n          workflowByWorkflowId: { name: { equalTo: \"recycle_more\" } }\n        }\n      ) {\n        nodes {\n          id\n          recycleMoreExecutions: workflowExecutionsByWorkflowInstanceId(\n            filter: {\n              status: { equalTo: \"done\" }\n              workflowStepByWorkflowStepId: {\n                name: { equalTo: \"recycle_more_identification\" }\n              }\n            }\n          ) {\n            totalCount\n          }\n        }\n      }\n    }\n  "], ["\n    fragment RecycleMoreFragment on Location {\n      id\n      recycleMoreWorkflows: workflowInstances(\n        filter: {\n          status: { in: [\"open\", \"executed\", \"paused\"] }\n          workflowByWorkflowId: { name: { equalTo: \"recycle_more\" } }\n        }\n      ) {\n        nodes {\n          id\n          recycleMoreExecutions: workflowExecutionsByWorkflowInstanceId(\n            filter: {\n              status: { equalTo: \"done\" }\n              workflowStepByWorkflowStepId: {\n                name: { equalTo: \"recycle_more_identification\" }\n              }\n            }\n          ) {\n            totalCount\n          }\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/root_status.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/root_status.tsx ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var RootStatus = function (props) {
    var rbses = props.rateBasedServicesByLocationId.nodes;
    var count = rbses.reduce(function (acc, cur) {
        if (cur.rootId)
            return acc + 1;
        return acc;
    }, 0);
    if (count > 0) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "ROOT" },
            React.createElement(antd_1.Badge, { count: count, offset: [-5, 5] },
                React.createElement(svg_icons_1.Root, { style: utils_1.style }))));
    }
    return null;
};
exports.RootStatus = RootStatus;
exports.RootStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment ActiveServicesFragment on Location {\n      id\n      costBasedServicesByLocationId(\n        filter: {\n          or: [\n            {\n              startDate: { lessThanOrEqualTo: \"NOW\" }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { lessThanOrEqualTo: \"NOW\" }, endDate: { isNull: true } }\n            {\n              startDate: { isNull: true }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { isNull: true }, endDate: { isNull: true } }\n            { preliminary: { notEqualTo: true } }\n            {\n              locationByLocationId: {\n                opsStatus: { equalTo: \"Pending Integration\" }\n              }\n              or: [\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { isNull: true }\n                }\n                {\n                  startDate: { isNull: true }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                { startDate: { isNull: true }, endDate: { isNull: true } }\n              ]\n            }\n          ]\n        }\n      ) {\n        nodes {\n          id\n          startDate\n          endDate\n          haulerByHaulerId {\n            id\n            hostile\n          }\n          isPdm\n        }\n      }\n      rateBasedServicesByLocationId(\n        filter: {\n          or: [\n            {\n              startDate: { lessThanOrEqualTo: \"NOW\" }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { lessThanOrEqualTo: \"NOW\" }, endDate: { isNull: true } }\n            {\n              startDate: { isNull: true }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { isNull: true }, endDate: { isNull: true } }\n            { preliminary: { notEqualTo: true } }\n            {\n              locationByLocationId: {\n                opsStatus: { equalTo: \"Pending Integration\" }\n              }\n              or: [\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { isNull: true }\n                }\n                {\n                  startDate: { isNull: true }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                { startDate: { isNull: true }, endDate: { isNull: true } }\n              ]\n            }\n          ]\n        }\n      ) {\n        nodes {\n          id\n          haulerByHaulerId {\n            id\n            hostile\n          }\n          isPdm\n          rootId\n        }\n      }\n    }\n  "], ["\n    fragment ActiveServicesFragment on Location {\n      id\n      costBasedServicesByLocationId(\n        filter: {\n          or: [\n            {\n              startDate: { lessThanOrEqualTo: \"NOW\" }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { lessThanOrEqualTo: \"NOW\" }, endDate: { isNull: true } }\n            {\n              startDate: { isNull: true }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { isNull: true }, endDate: { isNull: true } }\n            { preliminary: { notEqualTo: true } }\n            {\n              locationByLocationId: {\n                opsStatus: { equalTo: \"Pending Integration\" }\n              }\n              or: [\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { isNull: true }\n                }\n                {\n                  startDate: { isNull: true }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                { startDate: { isNull: true }, endDate: { isNull: true } }\n              ]\n            }\n          ]\n        }\n      ) {\n        nodes {\n          id\n          startDate\n          endDate\n          haulerByHaulerId {\n            id\n            hostile\n          }\n          isPdm\n        }\n      }\n      rateBasedServicesByLocationId(\n        filter: {\n          or: [\n            {\n              startDate: { lessThanOrEqualTo: \"NOW\" }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { lessThanOrEqualTo: \"NOW\" }, endDate: { isNull: true } }\n            {\n              startDate: { isNull: true }\n              endDate: { greaterThanOrEqualTo: \"NOW\" }\n            }\n            { startDate: { isNull: true }, endDate: { isNull: true } }\n            { preliminary: { notEqualTo: true } }\n            {\n              locationByLocationId: {\n                opsStatus: { equalTo: \"Pending Integration\" }\n              }\n              or: [\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                {\n                  startDate: { lessThanOrEqualTo: \"NOW\" }\n                  endDate: { isNull: true }\n                }\n                {\n                  startDate: { isNull: true }\n                  endDate: { greaterThanOrEqualTo: \"NOW\" }\n                }\n                { startDate: { isNull: true }, endDate: { isNull: true } }\n              ]\n            }\n          ]\n        }\n      ) {\n        nodes {\n          id\n          haulerByHaulerId {\n            id\n            hostile\n          }\n          isPdm\n          rootId\n        }\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/secondary_key_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/secondary_key_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryKeyStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var key_status_1 = __webpack_require__(/*! ./key_status */ "./src/components/location_status_icons/status_components/key_status.tsx");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var SecondaryKeyStatus = function (props) {
    var _a = __read(React.useState(false), 2), popup = _a[0], setPopup = _a[1];
    var id = props.id, nodes = props.accountByAccountId.portfolioByPortfolioId.accountsByPortfolioId.nodes, _b = props.coyoteUrl, coyoteUrl = _b === void 0 ? '' : _b;
    var primaryKeyLocations = [];
    nodes.forEach(function (acc) {
        var locs = acc.keyLocations.nodes;
        locs.forEach(function (loc) {
            if (loc.id !== id && key_status_1.KeyStatus.isPrimaryKey(loc)) {
                primaryKeyLocations.push(loc);
            }
        });
    });
    if (primaryKeyLocations.length > 0) {
        var content = (React.createElement(React.Fragment, null, primaryKeyLocations.map(function (l) { return (React.createElement("p", { key: l.id },
            React.createElement("a", { href: "".concat(coyoteUrl, "/locations/").concat(l.id) }, l.name))); })));
        var icon = popup ? React.createElement(svg_icons_1.SecondKeyHover, { style: utils_1.style }) : React.createElement(svg_icons_1.SecondKey, { style: utils_1.style });
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Secondary Key" },
            React.createElement(antd_1.Popover, { title: "Other Locs that are Primary Key", content: content, onVisibleChange: function (v) { setPopup(v); } }, icon)));
    }
    return null;
};
exports.SecondaryKeyStatus = SecondaryKeyStatus;
exports.SecondaryKeyStatus.fragment = key_status_1.KeyStatus.fragment;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/service_ongoing_tasks_status.tsx":
/*!*************************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/service_ongoing_tasks_status.tsx ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceOngoingTasksStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var antd_1 = __webpack_require__(/*! antd */ "antd");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var graphql_tag_1 = __importDefault(__webpack_require__(/*! graphql-tag */ "graphql-tag"));
var Text = antd_1.Typography.Text;
var ServiceOngoingTasksStatus = function (props) {
    var _a = __read(React.useState(false), 2), popoverVisible = _a[0], setPopoverVisible = _a[1];
    var locationId = props.id, serviceCount = props.serviceTasksByLocationId.totalCount;
    var data = [];
    data.push({ type: 'Ongoing Tasks', count: serviceCount, paramValue: undefined });
    if (serviceCount > 0) {
        data.push({ type: 'Service', count: serviceCount, paramValue: 'service' });
    }
    if (serviceCount <= 0) {
        return null;
    }
    return (React.createElement(antd_1.Popover, { trigger: serviceCount > 0 ? 'hover' : [], content: React.createElement(antd_1.List, { size: "small", style: { width: '300px' }, dataSource: data, itemLayout: "horizontal", split: false, renderItem: function (item, index) {
                if (index === 0) {
                    var tasks_url = "/base_tasks?location=".concat(locationId, "&type=service");
                    return (React.createElement("div", null,
                        React.createElement(antd_1.List.Item, { actions: [
                                React.createElement("a", { style: { fontWeight: 'bold', textDecoration: 'none' }, href: tasks_url, target: "_blank" }, "See all"),
                            ] },
                            React.createElement(antd_1.List.Item.Meta, { avatar: React.createElement(antd_1.Badge, { count: item.count }), title: React.createElement(Text, { style: { fontWeight: 'bold' } }, item.type) })),
                        React.createElement(antd_1.Divider, { style: { margin: 0, padding: 0 } })));
                }
                var url = "/base_tasks?location=".concat(locationId, "&type=").concat(item.paramValue);
                return (React.createElement("div", null,
                    React.createElement(antd_1.List.Item, { actions: [
                            React.createElement("a", { style: { fontWeight: 'bold', textDecoration: 'none' }, href: url, target: "_blank" }, "See"),
                        ] },
                        React.createElement(antd_1.List.Item.Meta, { avatar: React.createElement(antd_1.Badge, { count: item.count }), title: React.createElement(Text, null, item.type) }))));
            } }), onVisibleChange: function (v) {
            setPopoverVisible(v);
        }, placement: "bottom" },
        React.createElement("div", null,
            React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Ongoing Tasks" },
                React.createElement(antd_1.Badge, { count: serviceCount, offset: [-5, 5] }, popoverVisible ? React.createElement(svg_icons_1.OngoingTasksHover, { style: utils_1.style }) : React.createElement(svg_icons_1.OngoingTasks, { style: utils_1.style }))))));
};
exports.ServiceOngoingTasksStatus = ServiceOngoingTasksStatus;
exports.ServiceOngoingTasksStatus.fragment = {
    fields: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment ServiceOngoingTasksFragment on Location {\n      id\n      serviceTasksByLocationId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] }\n          }\n        }\n      ) {\n        totalCount\n      }\n    }\n  "], ["\n    fragment ServiceOngoingTasksFragment on Location {\n      id\n      serviceTasksByLocationId(\n        filter: {\n          baseTaskByBaseTaskId: {\n            status: { in: [\"Open\", \"Flagged\", \"Awaiting Approval\"] }\n          }\n        }\n      ) {\n        totalCount\n      }\n    }\n  "]))),
};
var templateObject_1;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/shared_saving_status.tsx":
/*!*****************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/shared_saving_status.tsx ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedSavingStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var antd_1 = __webpack_require__(/*! antd */ "antd");
var pdm_status_1 = __webpack_require__(/*! ./pdm_status */ "./src/components/location_status_icons/status_components/pdm_status.tsx");
var svg_icons_1 = __webpack_require__(/*! ../status_icons/svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var SharedSavingStatus = function (props) {
    var allCbses = props.allCbses, allRbses = props.allRbses, activeCbses = props.costBasedServicesByLocationId.nodes, activeRbses = props.rateBasedServicesByLocationId.nodes;
    var ssEngagementCount = (0, utils_1.countEngagements)({ allCbses: allCbses, allRbses: allRbses, type: 'Shared Savings' });
    var content = (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Shared Saving" },
        React.createElement(antd_1.Badge, { count: ssEngagementCount, offset: [-5, 5] },
            React.createElement(svg_icons_1.SharedSavings, { style: utils_1.style }))));
    if (ssEngagementCount > 0) {
        return (content);
    }
    var isPdm = activeCbses.reduce(function (acc, cur) { return acc || !cur.isPdm; }, false);
    isPdm = activeRbses.reduce(function (acc, cur) { return acc || (!cur.isPdm && !cur.rootId); }, isPdm);
    if (isPdm) {
        return (content);
    }
    return null;
};
exports.SharedSavingStatus = SharedSavingStatus;
exports.SharedSavingStatus.fragment = pdm_status_1.PdmStatus.fragment;


/***/ }),

/***/ "./src/components/location_status_icons/status_components/strategy_status.tsx":
/*!************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_components/strategy_status.tsx ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyStatus = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var hauler_change_status_1 = __webpack_require__(/*! ./hauler_change_status */ "./src/components/location_status_icons/status_components/hauler_change_status.tsx");
var status_icons_1 = __webpack_require__(/*! ../status_icons/ */ "./src/components/location_status_icons/status_icons/index.ts");
var utils_1 = __webpack_require__(/*! ../utils */ "./src/components/location_status_icons/utils.ts");
var icon_text_wrapper_1 = __webpack_require__(/*! ./icon_text_wrapper */ "./src/components/location_status_icons/status_components/icon_text_wrapper.tsx");
var StrategyStatus = function (props) {
    var bod = (0, utils_1.bodStrat)(props);
    var bodyText = (bod.b ? 'b' : '') + (bod.o ? 'o' : '') + (bod.d ? 'd' : '');
    if (bodyText) {
        return (React.createElement(icon_text_wrapper_1.IconTextWrapper, { text: "Strategy" },
            React.createElement(status_icons_1.Strategy, { state: bodyText, style: utils_1.style })));
    }
    return null;
};
exports.StrategyStatus = StrategyStatus;
exports.StrategyStatus.fragment = hauler_change_status_1.HaulerChangeStatus.fragment;


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/15-days.svg":
/*!***********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/15-days.svg ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(3.75 3.75)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#BBDEFB"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  fillRule: "nonzero",
  d: "M14.063 17.988v1.387h-6v-1.387h2.197v-6.323c0-.25.007-.507.023-.772l-1.56 1.304a.645.645 0 0 1-.267.132.637.637 0 0 1-.454-.075.436.436 0 0 1-.135-.124l-.585-.803 3.308-2.812h1.523v9.473h1.95zm3.982-5.52a6.27 6.27 0 0 1 1.327-.143c.57 0 1.073.085 1.508.255.435.17.8.405 1.095.705.295.3.517.651.667 1.054.15.402.226.836.226 1.301 0 .575-.102 1.1-.304 1.575a3.564 3.564 0 0 1-.844 1.219 3.8 3.8 0 0 1-1.279.784 4.54 4.54 0 0 1-1.608.277 4.32 4.32 0 0 1-.968-.105 4.8 4.8 0 0 1-2.212-1.17l.57-.787a.553.553 0 0 1 .472-.256c.125 0 .252.04.383.12.13.08.278.168.446.263.167.095.365.182.592.263.228.08.501.12.822.12.34 0 .64-.055.9-.166.26-.11.476-.263.648-.46.173-.198.303-.433.39-.706.088-.272.131-.568.131-.889 0-.59-.17-1.05-.513-1.383-.343-.333-.849-.499-1.519-.499-.515 0-1.042.095-1.583.285l-1.154-.33.9-5.265h5.354v.788c0 .265-.082.48-.247.645-.165.165-.445.247-.84.247h-2.978l-.382 2.257z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5.625,
  cy: 5.625,
  r: 5.625,
  fill: "#1E88E5",
  stroke: "#1E88E5",
  transform: "translate(22.5 23.75)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M28.572 32.368c.353-.046.62-.165.802-.357.182-.192.273-.443.273-.753a.769.769 0 0 0-.068-.332.794.794 0 0 0-.19-.253 1.23 1.23 0 0 0-.287-.19 3.66 3.66 0 0 0-.36-.15l-.17 2.035zm-.32-5.285a1.799 1.799 0 0 0-.475.118c-.13.055-.237.122-.32.202a.739.739 0 0 0-.183.27.872.872 0 0 0 .01.648c.045.095.107.18.185.255a1.3 1.3 0 0 0 .278.2c.106.058.223.112.35.162l.155-1.855zm.585 2.095c.24.074.478.154.715.243.236.088.449.202.637.342.189.14.341.314.458.523.116.208.175.469.175.782 0 .31-.052.601-.155.873a2.114 2.114 0 0 1-.455.72c-.2.208-.445.378-.735.51s-.622.209-.995.232l-.06.735a.325.325 0 0 1-.098.213.307.307 0 0 1-.232.097h-.455l.09-1.07a3.81 3.81 0 0 1-1.1-.32 3.092 3.092 0 0 1-.875-.595l.38-.565a.39.39 0 0 1 .132-.122.35.35 0 0 1 .178-.048.45.45 0 0 1 .235.078c.083.052.178.111.285.18.106.068.228.137.365.207.136.07.298.122.485.155l.185-2.235a7.717 7.717 0 0 1-.703-.235 2.357 2.357 0 0 1-.625-.357 1.662 1.662 0 0 1-.447-.563c-.114-.226-.17-.51-.17-.85a1.925 1.925 0 0 1 .592-1.39c.195-.19.434-.346.718-.47a2.74 2.74 0 0 1 .975-.21l.055-.63a.349.349 0 0 1 .1-.215.309.309 0 0 1 .235-.095h.455l-.08.98c.353.057.658.158.915.303.256.145.478.307.665.487l-.3.455a.549.549 0 0 1-.135.15.285.285 0 0 1-.17.05.452.452 0 0 1-.18-.047 4.89 4.89 0 0 1-.235-.115 4.508 4.508 0 0 0-.293-.138 2.091 2.091 0 0 0-.357-.115l-.175 2.07z"
}));

var Svg15Days = function Svg15Days(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (Svg15Days);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/30-days.svg":
/*!***********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/30-days.svg ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(3.75 3.75)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#BBDEFB"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  fillRule: "nonzero",
  d: "M7.11 11.553c.075-.52.22-.977.435-1.37.215-.392.484-.72.806-.982a3.34 3.34 0 0 1 1.11-.592 4.427 4.427 0 0 1 1.346-.199c.5 0 .952.071 1.354.214.403.142.746.34 1.032.592a2.595 2.595 0 0 1 .885 1.992c0 .345-.04.648-.117.91a2.166 2.166 0 0 1-.334.687c-.145.195-.324.36-.54.495a3.36 3.36 0 0 1-.727.337c.65.206 1.135.518 1.455.938.32.42.48.947.48 1.582 0 .54-.1 1.018-.3 1.433-.2.415-.47.764-.81 1.046a3.53 3.53 0 0 1-1.181.642 4.582 4.582 0 0 1-1.421.217c-.546 0-1.02-.062-1.425-.188a3.094 3.094 0 0 1-1.058-.554 3.352 3.352 0 0 1-.765-.9 6.074 6.074 0 0 1-.54-1.23l.817-.338a.981.981 0 0 1 .604-.071.585.585 0 0 1 .409.303c.09.176.189.348.296.518a2.1 2.1 0 0 0 .386.454c.15.132.327.24.53.322.202.083.443.124.723.124.315 0 .59-.051.825-.154a1.79 1.79 0 0 0 .589-.401 1.699 1.699 0 0 0 .469-1.162c0-.26-.028-.497-.083-.71a1.05 1.05 0 0 0-.345-.543c-.175-.15-.426-.267-.754-.352-.327-.086-.766-.128-1.316-.128v-1.32c.455-.005.832-.047 1.133-.127.3-.08.538-.192.716-.334a1.13 1.13 0 0 0 .371-.514c.07-.2.105-.42.105-.66 0-.51-.142-.897-.428-1.162-.285-.266-.664-.398-1.14-.398-.22 0-.422.031-.607.094-.185.062-.351.15-.499.262a1.63 1.63 0 0 0-.371.394c-.1.15-.175.315-.225.495-.085.23-.196.382-.334.457-.137.076-.331.093-.581.053l-.975-.172zm16.215 2.4c0 .945-.101 1.766-.304 2.463-.202.698-.482 1.274-.84 1.729a3.39 3.39 0 0 1-1.267 1.016 3.757 3.757 0 0 1-1.579.334 3.706 3.706 0 0 1-1.571-.334 3.383 3.383 0 0 1-1.256-1.016c-.356-.455-.633-1.031-.833-1.729-.2-.697-.3-1.518-.3-2.463 0-.95.1-1.773.3-2.468.2-.695.477-1.27.832-1.725a3.383 3.383 0 0 1 1.257-1.016 3.706 3.706 0 0 1 1.571-.334c.565 0 1.091.111 1.579.334.487.222.91.561 1.267 1.016.358.455.638 1.03.84 1.725.203.695.304 1.517.304 2.468zm-1.912 0c0-.786-.058-1.435-.173-1.95-.115-.516-.269-.925-.461-1.23-.193-.306-.414-.52-.664-.642a1.713 1.713 0 0 0-1.549 0c-.247.123-.466.336-.656.642-.19.305-.341.714-.454 1.23-.112.515-.168 1.164-.168 1.95 0 .785.056 1.434.168 1.95.113.515.264.924.454 1.23.19.305.409.518.656.64a1.713 1.713 0 0 0 1.549 0c.25-.122.471-.335.664-.64.192-.306.346-.715.461-1.23.115-.516.173-1.165.173-1.95z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5.625,
  cy: 5.625,
  r: 5.625,
  fill: "#1E88E5",
  stroke: "#1E88E5",
  transform: "translate(22.5 23.75)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M28.572 32.368c.353-.046.62-.165.802-.357.182-.192.273-.443.273-.753a.769.769 0 0 0-.068-.332.794.794 0 0 0-.19-.253 1.23 1.23 0 0 0-.287-.19 3.66 3.66 0 0 0-.36-.15l-.17 2.035zm-.32-5.285a1.799 1.799 0 0 0-.475.118c-.13.055-.237.122-.32.202a.739.739 0 0 0-.183.27.872.872 0 0 0 .01.648c.045.095.107.18.185.255a1.3 1.3 0 0 0 .278.2c.106.058.223.112.35.162l.155-1.855zm.585 2.095c.24.074.478.154.715.243.236.088.449.202.637.342.189.14.341.314.458.523.116.208.175.469.175.782 0 .31-.052.601-.155.873a2.114 2.114 0 0 1-.455.72c-.2.208-.445.378-.735.51s-.622.209-.995.232l-.06.735a.325.325 0 0 1-.098.213.307.307 0 0 1-.232.097h-.455l.09-1.07a3.81 3.81 0 0 1-1.1-.32 3.092 3.092 0 0 1-.875-.595l.38-.565a.39.39 0 0 1 .132-.122.35.35 0 0 1 .178-.048.45.45 0 0 1 .235.078c.083.052.178.111.285.18.106.068.228.137.365.207.136.07.298.122.485.155l.185-2.235a7.717 7.717 0 0 1-.703-.235 2.357 2.357 0 0 1-.625-.357 1.662 1.662 0 0 1-.447-.563c-.114-.226-.17-.51-.17-.85a1.925 1.925 0 0 1 .592-1.39c.195-.19.434-.346.718-.47a2.74 2.74 0 0 1 .975-.21l.055-.63a.349.349 0 0 1 .1-.215.309.309 0 0 1 .235-.095h.455l-.08.98c.353.057.658.158.915.303.256.145.478.307.665.487l-.3.455a.549.549 0 0 1-.135.15.285.285 0 0 1-.17.05.452.452 0 0 1-.18-.047 4.89 4.89 0 0 1-.235-.115 4.508 4.508 0 0 0-.293-.138 2.091 2.091 0 0 0-.357-.115l-.175 2.07z"
}));

var Svg30Days = function Svg30Days(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (Svg30Days);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/45-days.svg":
/*!***********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/45-days.svg ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(3.75 3.75)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#BBDEFB"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  fillRule: "nonzero",
  d: "M11.64 15.287V11.74c0-.335.022-.705.067-1.11L8.34 15.287h3.3zm2.977 0v1.073c0 .1-.032.186-.097.259-.065.072-.157.108-.277.108h-.99v2.648H11.64v-2.648H7.065a.507.507 0 0 1-.33-.116.502.502 0 0 1-.18-.288l-.195-.938 5.138-6.862h1.755v6.764h1.364zm3.428-2.82c.24-.05.47-.086.69-.108a6.27 6.27 0 0 1 .637-.034c.57 0 1.073.085 1.508.255.435.17.8.405 1.095.705.295.3.517.651.667 1.054.15.402.226.836.226 1.301 0 .575-.102 1.1-.304 1.575a3.564 3.564 0 0 1-.844 1.219 3.8 3.8 0 0 1-1.279.784 4.54 4.54 0 0 1-1.608.277 4.32 4.32 0 0 1-.968-.105 4.8 4.8 0 0 1-2.212-1.17l.57-.787a.553.553 0 0 1 .472-.256c.125 0 .252.04.383.12.13.08.278.168.446.263.167.095.365.182.592.263.228.08.501.12.822.12.34 0 .64-.055.9-.166.26-.11.476-.263.648-.46.173-.198.303-.433.39-.706.088-.272.131-.568.131-.889 0-.59-.17-1.05-.513-1.383-.343-.333-.849-.499-1.519-.499-.515 0-1.042.095-1.583.285l-1.154-.33.9-5.265h5.354v.788c0 .265-.082.48-.247.645-.165.165-.445.247-.84.247h-2.978l-.382 2.257z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5.625,
  cy: 5.625,
  r: 5.625,
  fill: "#1E88E5",
  stroke: "#1E88E5",
  transform: "translate(22.5 23.75)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M28.572 32.368c.353-.046.62-.165.802-.357.182-.192.273-.443.273-.753a.769.769 0 0 0-.068-.332.794.794 0 0 0-.19-.253 1.23 1.23 0 0 0-.287-.19 3.66 3.66 0 0 0-.36-.15l-.17 2.035zm-.32-5.285a1.799 1.799 0 0 0-.475.118c-.13.055-.237.122-.32.202a.739.739 0 0 0-.183.27.872.872 0 0 0 .01.648c.045.095.107.18.185.255a1.3 1.3 0 0 0 .278.2c.106.058.223.112.35.162l.155-1.855zm.585 2.095c.24.074.478.154.715.243.236.088.449.202.637.342.189.14.341.314.458.523.116.208.175.469.175.782 0 .31-.052.601-.155.873a2.114 2.114 0 0 1-.455.72c-.2.208-.445.378-.735.51s-.622.209-.995.232l-.06.735a.325.325 0 0 1-.098.213.307.307 0 0 1-.232.097h-.455l.09-1.07a3.81 3.81 0 0 1-1.1-.32 3.092 3.092 0 0 1-.875-.595l.38-.565a.39.39 0 0 1 .132-.122.35.35 0 0 1 .178-.048.45.45 0 0 1 .235.078c.083.052.178.111.285.18.106.068.228.137.365.207.136.07.298.122.485.155l.185-2.235a7.717 7.717 0 0 1-.703-.235 2.357 2.357 0 0 1-.625-.357 1.662 1.662 0 0 1-.447-.563c-.114-.226-.17-.51-.17-.85a1.925 1.925 0 0 1 .592-1.39c.195-.19.434-.346.718-.47a2.74 2.74 0 0 1 .975-.21l.055-.63a.349.349 0 0 1 .1-.215.309.309 0 0 1 .235-.095h.455l-.08.98c.353.057.658.158.915.303.256.145.478.307.665.487l-.3.455a.549.549 0 0 1-.135.15.285.285 0 0 1-.17.05.452.452 0 0 1-.18-.047 4.89 4.89 0 0 1-.235-.115 4.508 4.508 0 0 0-.293-.138 2.091 2.091 0 0 0-.357-.115l-.175 2.07z"
}));

var Svg45Days = function Svg45Days(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (Svg45Days);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/60-days.svg":
/*!***********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/60-days.svg ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(3.75 3.75)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#BBDEFB"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  fillRule: "nonzero",
  d: "M10.215 12.467l-.375.465c.21-.105.436-.186.679-.243a3.61 3.61 0 0 1 1.98.116c.387.135.728.339 1.024.611.295.273.532.611.712 1.016.18.406.27.878.27 1.418 0 .505-.092.979-.278 1.421a3.508 3.508 0 0 1-1.99 1.939 4.16 4.16 0 0 1-1.565.285c-.58 0-1.1-.092-1.56-.277a3.394 3.394 0 0 1-1.177-.777 3.352 3.352 0 0 1-.746-1.2 4.467 4.467 0 0 1-.259-1.556c0-.51.104-1.034.311-1.571.208-.538.529-1.096.964-1.677l2.588-3.472c.09-.12.22-.222.393-.307.173-.086.371-.128.597-.128h1.65l-3.218 3.938zm.42 5.513c.295 0 .566-.05.814-.15.247-.1.46-.24.637-.42a1.94 1.94 0 0 0 .416-.634c.1-.242.15-.506.15-.791 0-.31-.047-.589-.142-.836a1.753 1.753 0 0 0-.405-.63 1.738 1.738 0 0 0-.63-.394 2.333 2.333 0 0 0-.81-.135c-.295 0-.562.05-.802.15a1.803 1.803 0 0 0-1.013 1.046 2.13 2.13 0 0 0-.143.784c0 .3.042.574.124.821.083.248.205.459.368.634.162.175.363.311.604.409a2.2 2.2 0 0 0 .832.146zm12.69-4.027c0 .945-.101 1.766-.304 2.463-.202.698-.482 1.274-.84 1.729a3.39 3.39 0 0 1-1.267 1.016 3.757 3.757 0 0 1-1.579.334 3.706 3.706 0 0 1-1.571-.334 3.383 3.383 0 0 1-1.256-1.016c-.356-.455-.633-1.031-.833-1.729-.2-.697-.3-1.518-.3-2.463 0-.95.1-1.773.3-2.468.2-.695.477-1.27.832-1.725a3.383 3.383 0 0 1 1.257-1.016 3.706 3.706 0 0 1 1.571-.334c.565 0 1.091.111 1.579.334.487.222.91.561 1.267 1.016.358.455.638 1.03.84 1.725.203.695.304 1.517.304 2.468zm-1.912 0c0-.786-.058-1.435-.173-1.95-.115-.516-.269-.925-.461-1.23-.193-.306-.414-.52-.664-.642a1.713 1.713 0 0 0-1.549 0c-.247.123-.466.336-.656.642-.19.305-.341.714-.454 1.23-.112.515-.168 1.164-.168 1.95 0 .785.056 1.434.168 1.95.113.515.264.924.454 1.23.19.305.409.518.656.64a1.713 1.713 0 0 0 1.549 0c.25-.122.471-.335.664-.64.192-.306.346-.715.461-1.23.115-.516.173-1.165.173-1.95z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5.625,
  cy: 5.625,
  r: 5.625,
  fill: "#1E88E5",
  stroke: "#1E88E5",
  transform: "translate(22.5 23.75)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M28.572 32.368c.353-.046.62-.165.802-.357.182-.192.273-.443.273-.753a.769.769 0 0 0-.068-.332.794.794 0 0 0-.19-.253 1.23 1.23 0 0 0-.287-.19 3.66 3.66 0 0 0-.36-.15l-.17 2.035zm-.32-5.285a1.799 1.799 0 0 0-.475.118c-.13.055-.237.122-.32.202a.739.739 0 0 0-.183.27.872.872 0 0 0 .01.648c.045.095.107.18.185.255a1.3 1.3 0 0 0 .278.2c.106.058.223.112.35.162l.155-1.855zm.585 2.095c.24.074.478.154.715.243.236.088.449.202.637.342.189.14.341.314.458.523.116.208.175.469.175.782 0 .31-.052.601-.155.873a2.114 2.114 0 0 1-.455.72c-.2.208-.445.378-.735.51s-.622.209-.995.232l-.06.735a.325.325 0 0 1-.098.213.307.307 0 0 1-.232.097h-.455l.09-1.07a3.81 3.81 0 0 1-1.1-.32 3.092 3.092 0 0 1-.875-.595l.38-.565a.39.39 0 0 1 .132-.122.35.35 0 0 1 .178-.048.45.45 0 0 1 .235.078c.083.052.178.111.285.18.106.068.228.137.365.207.136.07.298.122.485.155l.185-2.235a7.717 7.717 0 0 1-.703-.235 2.357 2.357 0 0 1-.625-.357 1.662 1.662 0 0 1-.447-.563c-.114-.226-.17-.51-.17-.85a1.925 1.925 0 0 1 .592-1.39c.195-.19.434-.346.718-.47a2.74 2.74 0 0 1 .975-.21l.055-.63a.349.349 0 0 1 .1-.215.309.309 0 0 1 .235-.095h.455l-.08.98c.353.057.658.158.915.303.256.145.478.307.665.487l-.3.455a.549.549 0 0 1-.135.15.285.285 0 0 1-.17.05.452.452 0 0 1-.18-.047 4.89 4.89 0 0 1-.235-.115 4.508 4.508 0 0 0-.293-.138 2.091 2.091 0 0 0-.357-.115l-.175 2.07z"
}));

var Svg60Days = function Svg60Days(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (Svg60Days);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/90-days.svg":
/*!***********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/90-days.svg ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(3.75 3.75)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#BBDEFB"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  fillRule: "nonzero",
  d: "M8.775 11.785c0 .605.156 1.066.469 1.384.312.317.756.476 1.331.476.3 0 .567-.047.803-.143a1.7 1.7 0 0 0 .592-.39c.16-.165.281-.36.364-.585.082-.225.123-.467.123-.727 0-.295-.044-.559-.135-.791a1.623 1.623 0 0 0-.382-.589 1.678 1.678 0 0 0-.589-.367 2.116 2.116 0 0 0-.746-.128c-.28 0-.532.046-.758.139a1.687 1.687 0 0 0-.577.386c-.16.165-.282.361-.367.589a2.116 2.116 0 0 0-.128.746zm2.46 3.383a10.548 10.548 0 0 0 .458-.608c-.25.16-.525.281-.825.364a3.57 3.57 0 0 1-.946.123c-.375 0-.742-.064-1.102-.195a2.76 2.76 0 0 1-.96-.588 2.975 2.975 0 0 1-.679-.975c-.172-.388-.258-.841-.258-1.361 0-.486.09-.94.27-1.366.18-.425.432-.797.757-1.117a3.57 3.57 0 0 1 1.17-.758 3.967 3.967 0 0 1 1.508-.277 4.04 4.04 0 0 1 1.496.262c.442.176.82.42 1.132.736.313.315.553.692.72 1.132.168.44.251.922.251 1.448a5.055 5.055 0 0 1-.33 1.818 5.862 5.862 0 0 1-.382.814 9.04 9.04 0 0 1-.503.788l-2.482 3.54a.978.978 0 0 1-.382.303c-.17.083-.363.124-.578.124H7.867l3.368-4.207zm12.09-1.215c0 .945-.101 1.766-.304 2.463-.202.698-.482 1.274-.84 1.729a3.39 3.39 0 0 1-1.267 1.016 3.757 3.757 0 0 1-1.579.334 3.706 3.706 0 0 1-1.571-.334 3.383 3.383 0 0 1-1.256-1.016c-.356-.455-.633-1.031-.833-1.729-.2-.697-.3-1.518-.3-2.463 0-.95.1-1.773.3-2.468.2-.695.477-1.27.832-1.725a3.383 3.383 0 0 1 1.257-1.016 3.706 3.706 0 0 1 1.571-.334c.565 0 1.091.111 1.579.334.487.222.91.561 1.267 1.016.358.455.638 1.03.84 1.725.203.695.304 1.517.304 2.468zm-1.912 0c0-.786-.058-1.435-.173-1.95-.115-.516-.269-.925-.461-1.23-.193-.306-.414-.52-.664-.642a1.713 1.713 0 0 0-1.549 0c-.247.123-.466.336-.656.642-.19.305-.341.714-.454 1.23-.112.515-.168 1.164-.168 1.95 0 .785.056 1.434.168 1.95.113.515.264.924.454 1.23.19.305.409.518.656.64a1.713 1.713 0 0 0 1.549 0c.25-.122.471-.335.664-.64.192-.306.346-.715.461-1.23.115-.516.173-1.165.173-1.95z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5.625,
  cy: 5.625,
  r: 5.625,
  fill: "#1E88E5",
  stroke: "#1E88E5",
  transform: "translate(22.5 23.75)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M28.572 32.368c.353-.046.62-.165.802-.357.182-.192.273-.443.273-.753a.769.769 0 0 0-.068-.332.794.794 0 0 0-.19-.253 1.23 1.23 0 0 0-.287-.19 3.66 3.66 0 0 0-.36-.15l-.17 2.035zm-.32-5.285a1.799 1.799 0 0 0-.475.118c-.13.055-.237.122-.32.202a.739.739 0 0 0-.183.27.872.872 0 0 0 .01.648c.045.095.107.18.185.255a1.3 1.3 0 0 0 .278.2c.106.058.223.112.35.162l.155-1.855zm.585 2.095c.24.074.478.154.715.243.236.088.449.202.637.342.189.14.341.314.458.523.116.208.175.469.175.782 0 .31-.052.601-.155.873a2.114 2.114 0 0 1-.455.72c-.2.208-.445.378-.735.51s-.622.209-.995.232l-.06.735a.325.325 0 0 1-.098.213.307.307 0 0 1-.232.097h-.455l.09-1.07a3.81 3.81 0 0 1-1.1-.32 3.092 3.092 0 0 1-.875-.595l.38-.565a.39.39 0 0 1 .132-.122.35.35 0 0 1 .178-.048.45.45 0 0 1 .235.078c.083.052.178.111.285.18.106.068.228.137.365.207.136.07.298.122.485.155l.185-2.235a7.717 7.717 0 0 1-.703-.235 2.357 2.357 0 0 1-.625-.357 1.662 1.662 0 0 1-.447-.563c-.114-.226-.17-.51-.17-.85a1.925 1.925 0 0 1 .592-1.39c.195-.19.434-.346.718-.47a2.74 2.74 0 0 1 .975-.21l.055-.63a.349.349 0 0 1 .1-.215.309.309 0 0 1 .235-.095h.455l-.08.98c.353.057.658.158.915.303.256.145.478.307.665.487l-.3.455a.549.549 0 0 1-.135.15.285.285 0 0 1-.17.05.452.452 0 0 1-.18-.047 4.89 4.89 0 0 1-.235-.115 4.508 4.508 0 0 0-.293-.138 2.091 2.091 0 0 0-.357-.115l-.175 2.07z"
}));

var Svg90Days = function Svg90Days(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (Svg90Days);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/b.svg":
/*!*****************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/b.svg ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15.318 18.117c.25 0 .46-.03.63-.09.17-.06.305-.14.407-.24a.88.88 0 0 0 .22-.35 1.32 1.32 0 0 0 .067-.425 1.13 1.13 0 0 0-.075-.423.792.792 0 0 0-.235-.32 1.098 1.098 0 0 0-.412-.202 2.297 2.297 0 0 0-.607-.07h-1.356v2.12h1.36zm-1.36-5.14v2.09h1.07c.46 0 .807-.084 1.042-.25.235-.167.352-.432.352-.795 0-.377-.106-.645-.32-.805-.213-.16-.546-.24-1-.24h-1.145zm1.144-1.04c.474 0 .879.045 1.215.135.337.09.613.218.828.385.215.166.372.368.473.605.1.236.15.503.15.8 0 .17-.025.332-.076.487-.05.155-.127.3-.232.435a1.742 1.742 0 0 1-.4.368 2.44 2.44 0 0 1-.577.28c.993.223 1.49.76 1.49 1.61 0 .306-.059.59-.175.85-.117.26-.287.484-.51.672a2.437 2.437 0 0 1-.826.443c-.326.106-.7.16-1.12.16h-2.73v-7.23h2.49z"
})));

var SvgB = function SvgB(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgB);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/bad-health-hover.svg":
/*!********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/bad-health-hover.svg ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  id: "bad-health-hover_svg__b",
  cx: 20,
  cy: 20,
  r: 20
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "bad-health-hover_svg__a",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-15%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
  fill: "#000",
  filter: "url(#bad-health-hover_svg__a)",
  xlinkHref: "#bad-health-hover_svg__b"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#E53935",
  stroke: "#E53935",
  strokeLinejoin: "round",
  d: "M19.696 16.485C25.883 11.328 30.009 8.75 32.07 8.75c3.094 0 4.64 3.094 0 10.828-3.094 5.157-7.219 10.829-12.375 17.017-6.188-8.25-10.313-13.923-12.376-17.017-3.093-4.64-3.093-10.828 0-10.828 2.063 0 6.188 2.578 12.376 7.735z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M15 18.75l9.167 7.875m0-7.875L15 26.625"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#979797",
  fillOpacity: 0.08
}));

var SvgBadHealthHover = function SvgBadHealthHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBadHealthHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/bad-health.svg":
/*!**************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/bad-health.svg ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  id: "bad-health_svg__b",
  cx: 20,
  cy: 20,
  r: 20
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "bad-health_svg__a",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-15%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
  fill: "#000",
  filter: "url(#bad-health_svg__a)",
  xlinkHref: "#bad-health_svg__b"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#E53935",
  stroke: "#E53935",
  d: "M24.696 21.485c6.187-5.157 10.313-7.735 12.375-7.735 3.094 0 4.64 3.094 0 10.828-3.094 5.157-7.219 10.829-12.375 17.017-6.188-8.25-10.313-13.923-12.376-17.017-3.093-4.64-3.093-10.828 0-10.828 2.063 0 6.188 2.578 12.376 7.735z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M20 23.75l9.167 7.875m0-7.875L20 31.625"
}));

var SvgBadHealth = function SvgBadHealth(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBadHealth);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/bd.svg":
/*!******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/bd.svg ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.515 18.117c.25 0 .46-.03.63-.09.17-.06.306-.14.408-.24a.88.88 0 0 0 .22-.35 1.32 1.32 0 0 0 .067-.425 1.13 1.13 0 0 0-.075-.423.792.792 0 0 0-.235-.32 1.098 1.098 0 0 0-.412-.202 2.297 2.297 0 0 0-.608-.07h-1.355v2.12h1.36zm-1.36-5.14v2.09h1.07c.46 0 .807-.084 1.043-.25.235-.167.352-.432.352-.795 0-.377-.107-.645-.32-.805-.213-.16-.547-.24-1-.24h-1.145zm1.145-1.04c.473 0 .878.045 1.215.135a2.3 2.3 0 0 1 .827.385c.216.166.373.368.473.605.1.236.15.503.15.8 0 .17-.025.332-.075.487-.05.155-.127.3-.232.435a1.742 1.742 0 0 1-.4.368c-.162.11-.355.203-.578.28.993.223 1.49.76 1.49 1.61 0 .306-.058.59-.175.85-.117.26-.287.484-.51.672a2.437 2.437 0 0 1-.825.443c-.327.106-.7.16-1.12.16H8.81v-7.23h2.49zm10.515 3.615a3.91 3.91 0 0 1-.265 1.46 3.354 3.354 0 0 1-.745 1.145c-.32.32-.705.568-1.155.745-.45.176-.95.265-1.5.265h-2.755v-7.23h2.755c.55 0 1.05.089 1.5.267.45.179.835.427 1.155.745.32.319.568.7.745 1.143.177.443.265.93.265 1.46zm-1.38 0c0-.397-.052-.753-.157-1.068a2.212 2.212 0 0 0-.455-.8 1.985 1.985 0 0 0-.72-.502 2.469 2.469 0 0 0-.953-.175h-1.405v5.09h1.405c.353 0 .67-.059.953-.175.281-.117.521-.284.72-.503.198-.218.35-.485.454-.8.106-.315.158-.67.158-1.067z"
})));

var SvgBd = function SvgBd(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBd);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/bill_blocker.svg":
/*!****************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/bill_blocker.svg ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 45c11.046 0 20-8.954 20-20S36.046 5 25 5 5 13.954 5 25s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  clipPath: "url(#bill_blocker_svg__clip0)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  x: 16.75,
  y: 14.75,
  width: 16.5,
  height: 20.5,
  rx: 2.25,
  fill: "#F5E1E1",
  stroke: "#F5E1E1",
  strokeWidth: 0.5
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M19.632 22.452a1.48 1.48 0 0 0 .464-.112c.133-.061.245-.139.336-.232a.889.889 0 0 0 .208-.324c.048-.125.072-.263.072-.412a.728.728 0 0 0-.276-.592 1.149 1.149 0 0 0-.3-.18 3.925 3.925 0 0 0-.368-.14l-.136 1.992zm-.132-4.624c-.174.016-.324.05-.452.104-.126.053-.23.12-.312.2a.769.769 0 0 0-.184.272.823.823 0 0 0-.06.312c0 .128.022.24.068.336a.804.804 0 0 0 .188.248c.08.072.173.135.28.188.106.053.222.101.348.144l.124-1.804zm.316 1.944c.192.061.381.127.568.196.186.07.354.159.504.268.149.11.269.247.36.412.093.163.14.367.14.612 0 .24-.04.465-.12.676-.08.21-.198.396-.352.556-.152.16-.34.29-.564.392a2.21 2.21 0 0 1-.76.176l-.048.7a.196.196 0 0 1-.06.132.183.183 0 0 1-.14.06h-.264l.06-.9a2.625 2.625 0 0 1-.884-.24 2.437 2.437 0 0 1-.684-.496l.216-.328a.26.26 0 0 1 .08-.072.203.203 0 0 1 .104-.028c.05 0 .108.025.172.076a2.744 2.744 0 0 0 .572.36c.13.061.286.103.468.124l.144-2.124a7.912 7.912 0 0 1-.552-.188 1.838 1.838 0 0 1-.484-.276 1.326 1.326 0 0 1-.344-.428 1.436 1.436 0 0 1-.128-.644 1.485 1.485 0 0 1 .448-1.064c.146-.144.326-.261.54-.352a2.01 2.01 0 0 1 .732-.156l.04-.576a.22.22 0 0 1 .056-.136.188.188 0 0 1 .144-.06h.264l-.052.788c.277.035.517.107.72.216.205.11.386.243.544.4l-.172.264c-.054.08-.115.12-.184.12a.3.3 0 0 1-.14-.048 5.007 5.007 0 0 0-.196-.12 1.942 1.942 0 0 0-.268-.132 1.529 1.529 0 0 0-.348-.096l-.132 1.936zM25.898 21.711a.892.892 0 0 0 .268-.035.496.496 0 0 0 .184-.1.394.394 0 0 0 .107-.154.556.556 0 0 0 .034-.196.4.4 0 0 0-.148-.328c-.1-.082-.247-.122-.445-.122h-.581v.935h.581zm-.581-2.111v.917h.48a.932.932 0 0 0 .266-.034.528.528 0 0 0 .188-.094.365.365 0 0 0 .11-.144.485.485 0 0 0 .036-.188c0-.158-.048-.274-.143-.346-.095-.074-.242-.111-.442-.111h-.495zm.495-.287c.165 0 .307.016.426.049.12.032.218.079.294.139.077.06.134.133.17.22a.75.75 0 0 1 .055.293.58.58 0 0 1-.124.36.673.673 0 0 1-.157.143.86.86 0 0 1-.222.101c.198.038.346.108.445.212.1.103.15.238.15.405a.745.745 0 0 1-.064.311.653.653 0 0 1-.184.242.858.858 0 0 1-.296.158 1.36 1.36 0 0 1-.401.054h-.949v-2.687h.857zm1.707.788V22h-.334v-1.9h.334zm.071-.597a.209.209 0 0 1-.02.092.255.255 0 0 1-.053.075.234.234 0 0 1-.077.05.227.227 0 0 1-.091.02.228.228 0 0 1-.166-.07.273.273 0 0 1-.05-.075.227.227 0 0 1-.019-.092c0-.032.006-.063.019-.091a.235.235 0 0 1 .05-.077.231.231 0 0 1 .074-.053.228.228 0 0 1 .091-.019c.033 0 .064.007.092.02.03.012.056.03.077.052.023.02.04.047.053.077a.21.21 0 0 1 .02.091zm.729-.266V22h-.334v-2.762h.334zm.792 0V22h-.334v-2.762h.334z",
  fill: "#E53935"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M18.5 29.5h8M18.5 27.5h8M18.5 31.5h8M29.5 27.5h2M29.5 29.5h2M29.5 31.5h2",
  stroke: "#E53935",
  strokeLinecap: "round"
}));

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  clipRule: "evenodd",
  d: "M25 40c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  stroke: "#E53935",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M13.524 15L35 37",
  stroke: "#E53935",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("clipPath", {
  id: "bill_blocker_svg__clip0"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#fff",
  transform: "translate(17 15)",
  d: "M0 0h16v20H0z"
})));

var SvgBillBlocker = function SvgBillBlocker(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBillBlocker);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/bo.svg":
/*!******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/bo.svg ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.277 18.117c.25 0 .46-.03.63-.09.17-.06.306-.14.408-.24a.88.88 0 0 0 .22-.35 1.32 1.32 0 0 0 .067-.425 1.13 1.13 0 0 0-.075-.423.792.792 0 0 0-.234-.32 1.098 1.098 0 0 0-.413-.202 2.297 2.297 0 0 0-.607-.07H9.918v2.12h1.36zm-1.36-5.14v2.09h1.07c.46 0 .808-.084 1.043-.25.235-.167.353-.432.353-.795 0-.377-.107-.645-.32-.805-.214-.16-.547-.24-1-.24H9.916zm1.146-1.04c.473 0 .878.045 1.214.135.337.09.613.218.828.385.215.166.372.368.473.605.1.236.15.503.15.8 0 .17-.025.332-.075.487-.05.155-.128.3-.233.435a1.742 1.742 0 0 1-.4.368 2.44 2.44 0 0 1-.577.28c.993.223 1.49.76 1.49 1.61 0 .306-.059.59-.175.85-.117.26-.287.484-.51.672a2.437 2.437 0 0 1-.825.443c-.327.106-.7.16-1.12.16h-2.73v-7.23h2.49zm10.99 3.615c0 .53-.088 1.02-.263 1.472a3.457 3.457 0 0 1-.742 1.173c-.32.33-.705.587-1.155.772a3.91 3.91 0 0 1-1.5.278 3.896 3.896 0 0 1-1.495-.278 3.4 3.4 0 0 1-1.158-.772 3.484 3.484 0 0 1-.748-1.173 4.007 4.007 0 0 1-.265-1.472c0-.53.089-1.021.265-1.473.177-.452.426-.842.748-1.172a3.4 3.4 0 0 1 1.158-.773c.45-.185.948-.277 1.494-.277.367 0 .712.042 1.035.127.324.085.62.205.89.36s.513.343.728.565c.215.222.397.47.547.743.15.273.265.57.343.89.078.32.117.656.117 1.01zm-1.376 0a3.31 3.31 0 0 0-.16-1.068 2.288 2.288 0 0 0-.454-.802 1.948 1.948 0 0 0-.718-.505 2.469 2.469 0 0 0-.953-.175c-.353 0-.67.058-.952.175a1.971 1.971 0 0 0-.72.505c-.198.22-.35.487-.457.802a3.31 3.31 0 0 0-.16 1.068c0 .396.053.752.16 1.067.106.315.259.582.457.8.198.219.438.386.72.503.282.116.6.175.952.175.354 0 .671-.059.953-.175a1.97 1.97 0 0 0 .718-.503c.196-.218.348-.485.454-.8.107-.315.16-.67.16-1.067z"
})));

var SvgBo = function SvgBo(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBo);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/boar.svg":
/*!********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/boar.svg ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#BBDEFB",
  stroke: "#FF8A65",
  strokeLinejoin: "round",
  d: "M20 30.969l-3.882 3.52-1.602-4.99-5.123 1.108 1.108-5.123-4.99-1.602L9.031 20l-3.52-3.882 4.99-1.602-1.108-5.123 5.123 1.108 1.602-4.99L20 9.031l3.882-3.52 1.602 4.99 5.123-1.108-1.108 5.123 4.99 1.602L30.969 20l3.52 3.882-4.99 1.602 1.108 5.123-5.123-1.108-1.602 4.99z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-Semibold, Lato",
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.35,
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 11.345,
  y: 19
}, "$")));

var SvgBoar = function SvgBoar(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBoar);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/bod.svg":
/*!*******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/bod.svg ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M7.475 18.117c.25 0 .46-.03.63-.09.17-.06.306-.14.407-.24a.88.88 0 0 0 .22-.35 1.32 1.32 0 0 0 .068-.425 1.13 1.13 0 0 0-.075-.423.792.792 0 0 0-.235-.32 1.098 1.098 0 0 0-.412-.202 2.297 2.297 0 0 0-.608-.07H6.115v2.12h1.36zm-1.36-5.14v2.09h1.07c.46 0 .807-.084 1.042-.25.236-.167.353-.432.353-.795 0-.377-.107-.645-.32-.805-.213-.16-.547-.24-1-.24H6.115zm1.145-1.04c.473 0 .878.045 1.215.135.337.09.612.218.828.385.215.166.372.368.472.605.1.236.15.503.15.8 0 .17-.025.332-.075.487-.05.155-.127.3-.232.435a1.742 1.742 0 0 1-.4.368c-.162.11-.355.203-.578.28.993.223 1.49.76 1.49 1.61 0 .306-.058.59-.175.85-.117.26-.287.484-.51.672a2.437 2.437 0 0 1-.825.443c-.327.106-.7.16-1.12.16H4.77v-7.23h2.49zm10.99 3.615c0 .53-.087 1.02-.262 1.472a3.457 3.457 0 0 1-.743 1.173c-.32.33-.705.587-1.155.772a3.91 3.91 0 0 1-1.5.278 3.896 3.896 0 0 1-1.495-.278 3.4 3.4 0 0 1-1.158-.772 3.482 3.482 0 0 1-.747-1.173 4.007 4.007 0 0 1-.265-1.472c0-.53.088-1.021.265-1.473.177-.452.426-.842.748-1.172a3.4 3.4 0 0 1 1.157-.773c.45-.185.948-.277 1.495-.277.367 0 .712.042 1.035.127.323.085.62.205.89.36s.512.343.727.565c.216.222.398.47.548.743.15.273.264.57.343.89.078.32.117.656.117 1.01zm-1.375 0a3.31 3.31 0 0 0-.16-1.068 2.288 2.288 0 0 0-.455-.802 1.948 1.948 0 0 0-.718-.505 2.469 2.469 0 0 0-.952-.175c-.353 0-.67.058-.953.175a1.971 1.971 0 0 0-.72.505c-.198.22-.35.487-.457.802a3.31 3.31 0 0 0-.16 1.068c0 .396.053.752.16 1.067.107.315.26.582.457.8.199.219.439.386.72.503.282.116.6.175.953.175s.67-.059.953-.175c.281-.117.52-.284.717-.503.197-.218.348-.485.455-.8.107-.315.16-.67.16-1.067zm8.98 0a3.91 3.91 0 0 1-.265 1.46 3.354 3.354 0 0 1-.745 1.145c-.32.32-.705.568-1.155.745-.45.176-.95.265-1.5.265h-2.755v-7.23h2.755c.55 0 1.05.089 1.5.267.45.179.835.427 1.155.745.32.319.568.7.745 1.143.177.443.265.93.265 1.46zm-1.38 0a3.34 3.34 0 0 0-.158-1.068 2.212 2.212 0 0 0-.454-.8 1.985 1.985 0 0 0-.72-.502 2.469 2.469 0 0 0-.953-.175h-1.405v5.09h1.405c.353 0 .67-.059.952-.175.282-.117.522-.284.72-.503.199-.218.35-.485.456-.8.105-.315.157-.67.157-1.067z"
})));

var SvgBod = function SvgBod(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgBod);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/cust-issues.svg":
/*!***************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/cust-issues.svg ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5.146 5.123)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  width: 38.4,
  height: 38.4,
  x: 0.654,
  y: 0.677,
  fill: "#FFF",
  stroke: "#979797",
  strokeLinejoin: "round",
  rx: 4
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20.454,
  cy: 13.277,
  r: 4.2,
  fill: "#BBDEFB",
  stroke: "#1E88E5"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#BBDEFB",
  stroke: "#1E88E5",
  strokeLinejoin: "round",
  d: "M22.752 18.378a5.73 5.73 0 0 1 2.554 4.074l1.116 8.725H14.486l1.115-8.725a5.73 5.73 0 0 1 2.555-4.074 4.21 4.21 0 0 1 4.596 0z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FF7043",
  fillRule: "nonzero",
  d: "M33.634 15.677c-.055-.002-.108.03-.14.087l-1.864 3.419a.21.21 0 0 0-.01.156c.016.05.052.086.096.098l.722.137-1.644 3.05c-.037.072-.029.16.02.213.05.052.126.054.183.004l4.46-3.894a.208.208 0 0 0 .062-.177c-.012-.065-.054-.113-.11-.125l-1.214-.23 1.171-2.175a.21.21 0 0 0 .008-.154.146.146 0 0 0-.096-.096l-1.644-.313zm-16.068 0c.055-.002.108.03.14.087l1.864 3.419a.21.21 0 0 1 .01.156.146.146 0 0 1-.096.098l-.722.137 1.644 3.05c.037.072.029.16-.02.213-.05.052-.126.054-.183.004l-4.46-3.894a.208.208 0 0 1-.062-.177c.012-.065.054-.113.11-.125l1.214-.23-1.171-2.175a.21.21 0 0 1-.008-.154.146.146 0 0 1 .096-.096l1.644-.313z"
}));

var SvgCustIssues = function SvgCustIssues(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCustIssues);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/custom-invoicing-hover.svg":
/*!**************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/custom-invoicing-hover.svg ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "custom-invoicing-hover_svg__a",
  width: "165%",
  height: "165%",
  x: "-32.5%",
  y: "-32.5%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMerge", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#custom-invoicing-hover_svg__a)",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(9 8)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  width: 20.5,
  height: 26.5,
  x: -0.25,
  y: -0.25,
  fill: "#BBDEFB",
  stroke: "#BBDEFB",
  strokeWidth: 0.5,
  rx: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-Regular, Lato",
  fontSize: 10,
  letterSpacing: 1.125
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 1.038,
  y: 11
}, "$")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-SemiboldItalic, Lato",
  fontSize: 4,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: -0.1
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 7.95,
  y: 10
}, "Invoice")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#1E88E5",
  strokeLinecap: "round",
  d: "M1.611 19.5h9.778m-9.778-3h9.778m-9.778 6h9.778m5.111-6h2m-2 3h2m-2 3h2"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M29 10.732l-1.418 2.246-.92-2.492-2.575-.654 2.086-1.645L26 5.536l2.21 1.475 2.467-.984-.72 2.557 1.697 2.043z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#979797",
  fillOpacity: 0.08
}));

var SvgCustomInvoicingHover = function SvgCustomInvoicingHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCustomInvoicingHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/custom-invoicing.svg":
/*!********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/custom-invoicing.svg ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "custom-invoicing_svg__a",
  width: "165%",
  height: "165%",
  x: "-32.5%",
  y: "-32.5%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMerge", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#custom-invoicing_svg__a)",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(9 8)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  width: 20.5,
  height: 26.5,
  x: -0.25,
  y: -0.25,
  fill: "#BBDEFB",
  stroke: "#BBDEFB",
  strokeWidth: 0.5,
  rx: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-Regular, Lato",
  fontSize: 10,
  letterSpacing: 1.125
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 1.038,
  y: 11
}, "$")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-SemiboldItalic, Lato",
  fontSize: 4,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: -0.1
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 7.95,
  y: 10
}, "Invoice")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#1E88E5",
  strokeLinecap: "round",
  d: "M1.611 19.5h9.778m-9.778-3h9.778m-9.778 6h9.778m5.111-6h2m-2 3h2m-2 3h2"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M29 10.732l-1.418 2.246-.92-2.492-2.575-.654 2.086-1.645L26 5.536l2.21 1.475 2.467-.984-.72 2.557 1.697 2.043z"
}));

var SvgCustomInvoicing = function SvgCustomInvoicing(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCustomInvoicing);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/d.svg":
/*!*****************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/d.svg ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.523 15.552a3.91 3.91 0 0 1-.265 1.46 3.354 3.354 0 0 1-.745 1.145c-.32.32-.705.568-1.155.745-.45.176-.95.265-1.5.265h-2.756v-7.23h2.755c.55 0 1.05.089 1.5.267.45.179.835.427 1.155.745.32.319.569.7.745 1.143.177.443.265.93.265 1.46zm-1.38 0c0-.397-.053-.753-.158-1.068a2.212 2.212 0 0 0-.455-.8 1.985 1.985 0 0 0-.72-.502 2.469 2.469 0 0 0-.953-.175h-1.404v5.09h1.405c.353 0 .67-.059.952-.175.282-.117.522-.284.72-.503.198-.218.35-.485.455-.8.105-.315.157-.67.157-1.067z"
})));

var SvgD = function SvgD(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgD);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/good-health-hover.svg":
/*!*********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/good-health-hover.svg ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  id: "good-health-hover_svg__b",
  cx: 20,
  cy: 20,
  r: 20
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "good-health-hover_svg__a",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-15%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
  fill: "#000",
  filter: "url(#good-health-hover_svg__a)",
  xlinkHref: "#good-health-hover_svg__b"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#689F38",
  stroke: "#689F38",
  strokeLinejoin: "round",
  d: "M19.696 16.485C25.883 11.328 30.009 8.75 32.07 8.75c3.094 0 4.64 3.094 0 10.828-3.094 5.157-7.219 10.829-12.375 17.017-6.188-8.25-10.313-13.923-12.376-17.017-3.093-4.64-3.093-10.828 0-10.828 2.063 0 6.188 2.578 12.376 7.735z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M15 22.5l4.531 6.082L27.5 17.5"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#979797",
  fillOpacity: 0.08
}));

var SvgGoodHealthHover = function SvgGoodHealthHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgGoodHealthHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/good-health.svg":
/*!***************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/good-health.svg ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  id: "good-health_svg__b",
  cx: 20,
  cy: 20,
  r: 20
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "good-health_svg__a",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-15%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
  fill: "#000",
  filter: "url(#good-health_svg__a)",
  xlinkHref: "#good-health_svg__b"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#689F38",
  stroke: "#689F38",
  d: "M24.696 21.485c6.187-5.157 10.313-7.735 12.375-7.735 3.094 0 4.64 3.094 0 10.828-3.094 5.157-7.219 10.829-12.375 17.017-6.188-8.25-10.313-13.923-12.376-17.017-3.093-4.64-3.093-10.828 0-10.828 2.063 0 6.188 2.578 12.376 7.735z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M20 27.5l4.531 6.082L32.5 22.5"
}));

var SvgGoodHealth = function SvgGoodHealth(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgGoodHealth);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/hauler-account-issues.svg":
/*!*************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/hauler-account-issues.svg ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5.4 5.4)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  width: 38.4,
  height: 38.4,
  x: 0.4,
  y: 0.4,
  fill: "#FFF",
  stroke: "#979797",
  strokeLinejoin: "round",
  rx: 4
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FF7043",
  fillRule: "nonzero",
  d: "M32.18 10.073c-.033-.002-.066.019-.086.054l-1.147 2.167a.137.137 0 0 0-.007.099c.01.031.033.054.06.062l.444.086-1.011 1.933c-.023.046-.018.102.012.135.03.033.077.034.113.003l2.744-2.468a.134.134 0 0 0 .038-.112c-.007-.04-.033-.072-.067-.08l-.747-.145.72-1.378a.136.136 0 0 0 .005-.098.091.091 0 0 0-.059-.06l-1.012-.198zm-3.448-.036c.033.008.059.037.068.076l.505 2.399a.137.137 0 0 1-.02.097.091.091 0 0 1-.075.043l-.45-.04.438 2.138c.01.05-.01.102-.048.126-.039.024-.084.012-.11-.028l-1.958-3.129a.134.134 0 0 1-.005-.118c.018-.038.051-.06.086-.058l.759.066-.313-1.523a.136.136 0 0 1 .022-.096.091.091 0 0 1 .074-.041l1.027.088z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#1E88E5",
  transform: "translate(6.4 13.505)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  strokeLinejoin: "round",
  d: "M18.7 3.1h4.97l2.03 2.196V12.1h-7v-9z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  strokeLinejoin: "round",
  d: "M-.5-.5h20.2v13H-.5z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5.4,
  cy: 12.6,
  r: 3,
  fill: "#BBDEFB"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 19.8,
  cy: 12.6,
  r: 3,
  fill: "#BBDEFB"
})));

var SvgHaulerAccountIssues = function SvgHaulerAccountIssues(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHaulerAccountIssues);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/hauler-change.svg":
/*!*****************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/hauler-change.svg ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#1E88E5",
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  d: "M17.697 9.945c3.738-.8 6.582.316 8.532 3.347 1.95 3.032 2.502 7.194 1.654 12.485"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  d: "M27.806 28.927l-2.5-5.942 5.679.263-1.463 2.613z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  d: "M22.132 30.259c-3.737.8-6.581-.316-8.532-3.348-1.95-3.032-2.501-7.193-1.653-12.485"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  d: "M12.47 11.435l1.979 6.14-5.634-.762 1.682-2.474z"
})));

var SvgHaulerChange = function SvgHaulerChange(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHaulerChange);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/hauler_change.tsx":
/*!*****************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/hauler_change.tsx ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerChange = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var hauler_change_svg_1 = __importDefault(__webpack_require__(/*! ./hauler-change.svg */ "./src/components/location_status_icons/status_icons/hauler-change.svg"));
var swap_svg_1 = __importDefault(__webpack_require__(/*! ./swap.svg */ "./src/components/location_status_icons/status_icons/swap.svg"));
var mapping = {
    change: hauler_change_svg_1.default,
    swap: swap_svg_1.default,
};
var HaulerChange = function (props) {
    var Component = mapping[props.state];
    return React.createElement(Component, __assign({}, props));
};
exports.HaulerChange = HaulerChange;


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/health.tsx":
/*!**********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/health.tsx ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Health = exports.WarningHealth = exports.GoodHealth = exports.BadHealth = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var bad_health_svg_1 = __importDefault(__webpack_require__(/*! ./bad-health.svg */ "./src/components/location_status_icons/status_icons/bad-health.svg"));
var good_health_svg_1 = __importDefault(__webpack_require__(/*! ./good-health.svg */ "./src/components/location_status_icons/status_icons/good-health.svg"));
var warning_health_svg_1 = __importDefault(__webpack_require__(/*! ./warning-health.svg */ "./src/components/location_status_icons/status_icons/warning-health.svg"));
var bad_health_hover_svg_1 = __importDefault(__webpack_require__(/*! ./bad-health-hover.svg */ "./src/components/location_status_icons/status_icons/bad-health-hover.svg"));
var good_health_hover_svg_1 = __importDefault(__webpack_require__(/*! ./good-health-hover.svg */ "./src/components/location_status_icons/status_icons/good-health-hover.svg"));
var warning_health_hover_svg_1 = __importDefault(__webpack_require__(/*! ./warning-health-hover.svg */ "./src/components/location_status_icons/status_icons/warning-health-hover.svg"));
var BadHealth = function (props) {
    var _a = props.hover, hover = _a === void 0 ? false : _a, other = __rest(props, ["hover"]);
    if (hover) {
        return React.createElement(bad_health_hover_svg_1.default, __assign({}, other));
    }
    return React.createElement(bad_health_svg_1.default, __assign({}, other));
};
exports.BadHealth = BadHealth;
var GoodHealth = function (props) {
    var _a = props.hover, hover = _a === void 0 ? false : _a, other = __rest(props, ["hover"]);
    if (hover) {
        return React.createElement(good_health_hover_svg_1.default, __assign({}, other));
    }
    return React.createElement(good_health_svg_1.default, __assign({}, other));
};
exports.GoodHealth = GoodHealth;
var WarningHealth = function (props) {
    var _a = props.hover, hover = _a === void 0 ? false : _a, other = __rest(props, ["hover"]);
    if (hover) {
        return React.createElement(warning_health_hover_svg_1.default, __assign({}, other));
    }
    return React.createElement(warning_health_svg_1.default, __assign({}, other));
};
exports.WarningHealth = WarningHealth;
var mapping = {
    red: exports.BadHealth,
    yellow: exports.WarningHealth,
    green: exports.GoodHealth,
};
var Health = function (props) {
    var state = props.state;
    var Component = mapping[state];
    return React.createElement(Component, __assign({}, props));
};
exports.Health = Health;


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/hostile-hauler.svg":
/*!******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/hostile-hauler.svg ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#FFA000"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4.286 14.552L10 16.876m10 0l5.714-2.324M7.143 22.857C9.762 20.952 12.38 20 15 20c2.619 0 5.238.952 7.857 2.857"
})));

var SvgHostileHauler = function SvgHostileHauler(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHostileHauler);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/index.ts":
/*!********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/index.ts ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./hauler_change */ "./src/components/location_status_icons/status_icons/hauler_change.tsx"), exports);
__exportStar(__webpack_require__(/*! ./health */ "./src/components/location_status_icons/status_icons/health.tsx"), exports);
__exportStar(__webpack_require__(/*! ./payment_term */ "./src/components/location_status_icons/status_icons/payment_term.tsx"), exports);
__exportStar(__webpack_require__(/*! ./strategy */ "./src/components/location_status_icons/status_icons/strategy.tsx"), exports);
__exportStar(__webpack_require__(/*! ./svg_icons */ "./src/components/location_status_icons/status_icons/svg_icons.ts"), exports);
__exportStar(__webpack_require__(/*! ./mgp */ "./src/components/location_status_icons/status_icons/mgp.tsx"), exports);


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/invoice-blocker.svg":
/*!*******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/invoice-blocker.svg ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(12 10)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  width: 16.5,
  height: 20.5,
  x: -0.25,
  y: -0.25,
  fill: "#BBDEFB",
  stroke: "#BBDEFB",
  strokeWidth: 0.5,
  rx: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-Regular, Lato",
  fontSize: 8,
  letterSpacing: 0.9
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 0,
  y: 8
}, "$")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#1E88E5",
  fontFamily: "Lato-SemiboldItalic, Lato",
  fontSize: 3.75,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: -0.094
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 4.797,
  y: 7
}, "Invoice")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#1E88E5",
  strokeLinecap: "round",
  d: "M1.5 14.5h8m-8-2h8m-8 4h8m3-4h2m-2 2h2m-2 2h2"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#E53935",
  strokeWidth: 2,
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M3.524 5L25 27"
})));

var SvgInvoiceBlocker = function SvgInvoiceBlocker(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgInvoiceBlocker);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/key-hover.svg":
/*!*************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/key-hover.svg ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "key-hover_svg__a",
  width: "165%",
  height: "165%",
  x: "-32.5%",
  y: "-32.5%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMerge", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797",
  strokeLinejoin: "round",
  filter: "url(#key-hover_svg__a)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#FFA000",
  transform: "matrix(1 0 0 -1 9 32)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.98 5.73l-4.543-4.543m7.094 2.094L16.72.47M10.5 13.281L21.875 1.875"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 7.5,
  cy: 16.25,
  r: 7.5,
  fill: "#FFA000"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5,
  cy: 18.75,
  r: 3.75,
  fill: "#FFF"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#979797",
  fillOpacity: 0.08
}));

var SvgKeyHover = function SvgKeyHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgKeyHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/key.svg":
/*!*******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/key.svg ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "key_svg__a",
  width: "165%",
  height: "165%",
  x: "-32.5%",
  y: "-32.5%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMerge", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797",
  strokeLinejoin: "round",
  filter: "url(#key_svg__a)",
  transform: "translate(5 5)"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#FFA000",
  transform: "matrix(1 0 0 -1 14 37)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.98 5.73l-4.543-4.543m7.094 2.094L16.72.47M10.5 13.281L21.875 1.875"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 7.5,
  cy: 16.25,
  r: 7.5,
  fill: "#FFA000"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5,
  cy: 18.75,
  r: 3.75,
  fill: "#FFF"
})));

var SvgKey = function SvgKey(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgKey);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/late-payer.svg":
/*!**************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/late-payer.svg ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 7.5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  stroke: "#FF8A65",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M25.625 5l-2.5-3.125m5 3.125l1.562-3.125"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FF8A65",
  stroke: "#FF8A65",
  d: "M3.465 20.8C9.765 16.6 15 20 18.75 16.25S23.06 5 26.25 5c3.19 0 4.065 2.35 3.015 9.7-1.05 7.35-9 10.3-16.35 10.3-7.35 0-15.75 0-9.45-4.2z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#1E88E5",
  stroke: "#1E88E5"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M10.215 13.713c.471-.062.828-.22 1.07-.476.242-.256.363-.59.363-1.004 0-.169-.03-.316-.09-.443a1.059 1.059 0 0 0-.253-.337 1.64 1.64 0 0 0-.383-.253 4.881 4.881 0 0 0-.48-.2l-.227 2.713zm-.427-7.046c-.249.03-.46.083-.633.156a1.391 1.391 0 0 0-.427.27.985.985 0 0 0-.243.36 1.163 1.163 0 0 0-.077.42 1.025 1.025 0 0 0 .337.784c.104.1.228.189.37.266.142.078.298.15.467.217l.206-2.473zm.78 2.793c.32.098.638.206.954.323.315.118.599.27.85.457.25.187.454.419.61.697.155.277.233.625.233 1.043 0 .413-.069.801-.207 1.163a2.82 2.82 0 0 1-.606.96 3.139 3.139 0 0 1-.98.68 3.753 3.753 0 0 1-1.327.31l-.08.98a.433.433 0 0 1-.13.284.41.41 0 0 1-.31.13h-.607l.12-1.427a5.08 5.08 0 0 1-1.466-.427 4.122 4.122 0 0 1-1.167-.793l.507-.753a.52.52 0 0 1 .176-.164.466.466 0 0 1 .237-.063.6.6 0 0 1 .313.103l.38.24c.143.091.305.184.487.277.182.093.398.162.647.207l.246-2.98a10.29 10.29 0 0 1-.936-.314 3.14 3.14 0 0 1-.834-.476 2.216 2.216 0 0 1-.596-.75c-.151-.303-.227-.68-.227-1.134a2.579 2.579 0 0 1 .79-1.853c.26-.253.579-.462.957-.627a3.652 3.652 0 0 1 1.3-.28l.073-.84a.465.465 0 0 1 .133-.286.412.412 0 0 1 .314-.127h.606l-.106 1.307c.47.075.877.21 1.22.403.342.193.637.41.886.65l-.4.607a.732.732 0 0 1-.18.2.38.38 0 0 1-.226.066.603.603 0 0 1-.24-.063 6.52 6.52 0 0 1-.314-.153 6.01 6.01 0 0 0-.39-.184 2.789 2.789 0 0 0-.476-.153l-.234 2.76z"
})));

var SvgLatePayer = function SvgLatePayer(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLatePayer);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/liquidation.svg":
/*!***************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/liquidation.svg ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#BBDEFB",
  stroke: "#1E88E5",
  strokeLinejoin: "round",
  d: "M20.344 6.25l6.867 14.446A8.258 8.258 0 0 1 19.752 32.5a7.83 7.83 0 0 1-6.978-11.384l7.57-14.866z"
}));

var SvgLiquidation = function SvgLiquidation(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLiquidation);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp-1.svg":
/*!*********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp-1.svg ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 36c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  fill: "#D6AF36"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M24.575 29.696V31h-6.28v-1.304h2.4V22.48c0-.256.008-.517.024-.784l-1.848 1.56a.65.65 0 0 1-.248.128.566.566 0 0 1-.232 0 .75.75 0 0 1-.192-.072.554.554 0 0 1-.128-.12l-.536-.752 3.472-2.984h1.4v10.24h2.168zM16.485 11.643h-1.571V16h-.816v-4.357h-1.575v-.683h3.962v.682zM18.51 16h-.822v-5.04h.822V16zm4.841-.662l-.004.662h-3.143v-5.04h3.143v.661h-2.32v1.52h1.855v.64h-1.855v1.557h2.324zm2.85-1.963c.186 0 .35-.022.49-.066.14-.047.256-.111.35-.193a.782.782 0 0 0 .21-.29.99.99 0 0 0 .07-.379c0-.275-.091-.485-.273-.63-.182-.144-.458-.216-.826-.216h-.665v1.774h.644zM28.573 16h-.732c-.145 0-.25-.056-.315-.168l-1.176-1.698a.389.389 0 0 0-.13-.126.448.448 0 0 0-.21-.038h-.454V16h-.82v-5.04h1.485c.331 0 .616.034.854.101.24.068.437.165.591.291.154.124.267.273.34.448.074.175.112.37.112.584 0 .175-.027.339-.08.49-.052.152-.128.29-.228.413a1.43 1.43 0 0 1-.364.322c-.145.091-.31.163-.494.214.1.06.187.146.26.255L28.571 16z",
  fill: "#fff"
});

var SvgMgp1 = function SvgMgp1(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMgp1);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp-2.svg":
/*!*********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp-2.svg ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 36c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  fill: "#A7A7AD"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M24.231 29.376c.187 0 .334.056.44.168.107.107.16.245.16.416V31H17.04v-.584c0-.117.024-.24.072-.368a.986.986 0 0 1 .232-.352l3.584-3.592c.304-.304.574-.595.808-.872.24-.277.443-.555.608-.832a3.58 3.58 0 0 0 .384-.84c.091-.288.136-.59.136-.904 0-.304-.048-.57-.144-.8a1.479 1.479 0 0 0-.384-.576 1.49 1.49 0 0 0-.584-.344 2.2 2.2 0 0 0-.744-.12c-.261 0-.504.037-.728.112a2.094 2.094 0 0 0-.592.312c-.17.133-.314.293-.432.48a2.063 2.063 0 0 0-.248.6c-.08.219-.184.365-.312.44-.122.075-.304.09-.544.048l-.904-.16c.08-.544.23-1.021.448-1.432.224-.41.504-.752.84-1.024.336-.277.72-.485 1.152-.624.438-.144.91-.216 1.416-.216.512 0 .982.077 1.408.232.432.15.803.365 1.112.648.315.277.56.616.736 1.016.176.4.264.85.264 1.352 0 .427-.064.821-.192 1.184a4.68 4.68 0 0 1-.504 1.04c-.213.33-.464.653-.752.968-.282.31-.581.624-.896.944l-2.784 2.848c.23-.064.459-.115.688-.152.235-.037.456-.056.664-.056h3.384zM16.485 11.643h-1.571V16h-.816v-4.357h-1.575v-.683h3.962v.682zM18.51 16h-.822v-5.04h.822V16zm4.841-.662l-.004.662h-3.143v-5.04h3.143v.661h-2.32v1.52h1.855v.64h-1.855v1.557h2.324zm2.85-1.963c.186 0 .35-.022.49-.066.14-.047.256-.111.35-.193a.782.782 0 0 0 .21-.29.99.99 0 0 0 .07-.379c0-.275-.091-.485-.273-.63-.182-.144-.458-.216-.826-.216h-.665v1.774h.644zM28.573 16h-.732c-.145 0-.25-.056-.315-.168l-1.176-1.698a.389.389 0 0 0-.13-.126.448.448 0 0 0-.21-.038h-.454V16h-.82v-5.04h1.485c.331 0 .616.034.854.101.24.068.437.165.591.291.154.124.267.273.34.448.074.175.112.37.112.584 0 .175-.027.339-.08.49-.052.152-.128.29-.228.413a1.43 1.43 0 0 1-.364.322c-.145.091-.31.163-.494.214.1.06.187.146.26.255L28.571 16z",
  fill: "#fff"
});

var SvgMgp2 = function SvgMgp2(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMgp2);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp-3.svg":
/*!*********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp-3.svg ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 36c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  fill: "#824A02"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M17.303 22.648c.08-.544.23-1.021.448-1.432.224-.41.504-.752.84-1.024.336-.277.72-.485 1.152-.624.438-.144.91-.216 1.416-.216.512 0 .976.075 1.392.224.422.144.782.347 1.08.608.304.261.536.573.696.936.166.363.248.76.248 1.192 0 .368-.045.693-.136.976-.085.277-.21.523-.376.736-.16.213-.357.392-.592.536a3.723 3.723 0 0 1-.792.36c.715.208 1.251.541 1.608 1 .358.453.536 1.024.536 1.712 0 .555-.104 1.048-.312 1.48-.208.432-.49.797-.848 1.096a3.74 3.74 0 0 1-1.24.688c-.469.155-.968.232-1.496.232-.592 0-1.104-.07-1.536-.208a3.43 3.43 0 0 1-1.12-.608 3.509 3.509 0 0 1-.776-.96 6.583 6.583 0 0 1-.528-1.256l.744-.312a.914.914 0 0 1 .56-.072.536.536 0 0 1 .392.296c.086.17.182.355.288.552.107.192.243.37.408.536.171.16.379.296.624.408.251.107.558.16.92.16.368 0 .688-.059.96-.176.278-.123.507-.277.688-.464a1.923 1.923 0 0 0 .552-1.336c0-.288-.034-.552-.104-.792a1.245 1.245 0 0 0-.408-.624c-.197-.17-.48-.304-.848-.4-.362-.101-.84-.152-1.432-.152v-1.24c.486-.005.894-.053 1.224-.144.336-.096.603-.224.8-.384.203-.165.347-.363.432-.592.091-.23.136-.48.136-.752 0-.293-.045-.552-.136-.776a1.5 1.5 0 0 0-.384-.56 1.497 1.497 0 0 0-.576-.344 2.341 2.341 0 0 0-.744-.112c-.261 0-.504.037-.728.112a2.094 2.094 0 0 0-.592.312c-.17.133-.314.293-.432.48a1.94 1.94 0 0 0-.256.6c-.074.219-.176.365-.304.44-.122.075-.304.09-.544.048l-.904-.16zM16.485 11.643h-1.571V16h-.816v-4.357h-1.575v-.683h3.962v.682zM18.51 16h-.822v-5.04h.822V16zm4.841-.662l-.004.662h-3.143v-5.04h3.143v.661h-2.32v1.52h1.855v.64h-1.855v1.557h2.324zm2.85-1.963c.186 0 .35-.022.49-.066.14-.047.256-.111.35-.193a.782.782 0 0 0 .21-.29.99.99 0 0 0 .07-.379c0-.275-.091-.485-.273-.63-.182-.144-.458-.216-.826-.216h-.665v1.774h.644zM28.573 16h-.732c-.145 0-.25-.056-.315-.168l-1.176-1.698a.389.389 0 0 0-.13-.126.448.448 0 0 0-.21-.038h-.454V16h-.82v-5.04h1.485c.331 0 .616.034.854.101.24.068.437.165.591.291.154.124.267.273.34.448.074.175.112.37.112.584 0 .175-.027.339-.08.49-.052.152-.128.29-.228.413a1.43 1.43 0 0 1-.364.322c-.145.091-.31.163-.494.214.1.06.187.146.26.255L28.571 16z",
  fill: "#fff"
});

var SvgMgp3 = function SvgMgp3(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMgp3);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp-4.svg":
/*!*********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp-4.svg ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 36c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  fill: "#024C82"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M22.127 26.744v-4.208c0-.336.024-.704.072-1.104l-3.872 5.312h3.8zm3.088 0v.992a.353.353 0 0 1-.096.248c-.058.07-.149.104-.272.104h-1.224V31h-1.496v-2.912h-4.984a.512.512 0 0 1-.32-.104.522.522 0 0 1-.168-.272l-.176-.88 5.528-7.36h1.616v7.272h1.592zM16.485 11.643h-1.571V16h-.816v-4.357h-1.575v-.683h3.962v.682zM18.51 16h-.822v-5.04h.822V16zm4.841-.662l-.004.662h-3.143v-5.04h3.143v.661h-2.32v1.52h1.855v.64h-1.855v1.557h2.324zm2.85-1.963c.186 0 .35-.022.49-.066.14-.047.256-.111.35-.193a.782.782 0 0 0 .21-.29.99.99 0 0 0 .07-.379c0-.275-.091-.485-.273-.63-.182-.144-.458-.216-.826-.216h-.665v1.774h.644zM28.573 16h-.732c-.145 0-.25-.056-.315-.168l-1.176-1.698a.389.389 0 0 0-.13-.126.448.448 0 0 0-.21-.038h-.454V16h-.82v-5.04h1.485c.331 0 .616.034.854.101.24.068.437.165.591.291.154.124.267.273.34.448.074.175.112.37.112.584 0 .175-.027.339-.08.49-.052.152-.128.29-.228.413a1.43 1.43 0 0 1-.364.322c-.145.091-.31.163-.494.214.1.06.187.146.26.255L28.571 16z",
  fill: "#fff"
});

var SvgMgp4 = function SvgMgp4(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMgp4);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp-5.svg":
/*!*********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp-5.svg ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 36c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  fill: "#820202"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M19.44 23.736a7.102 7.102 0 0 1 1.528-.168c.602 0 1.133.09 1.591.272.464.176.851.421 1.16.736.315.315.55.685.704 1.112.16.421.24.88.24 1.376a4.23 4.23 0 0 1-.32 1.672c-.213.501-.509.93-.888 1.288a3.987 3.987 0 0 1-1.344.816 4.702 4.702 0 0 1-1.664.288 4.752 4.752 0 0 1-1.896-.384 5.248 5.248 0 0 1-.768-.416 5.647 5.647 0 0 1-.632-.496l.528-.736a.521.521 0 0 1 .448-.24c.118 0 .246.043.384.128.139.085.299.179.48.28.187.096.406.187.656.272.251.085.55.128.896.128.379 0 .718-.061 1.016-.184a2.093 2.093 0 0 0 1.224-1.312 3.1 3.1 0 0 0 .16-1.016c0-.336-.05-.637-.152-.904a1.725 1.725 0 0 0-.44-.68 1.85 1.85 0 0 0-.728-.424 3.11 3.11 0 0 0-1.016-.152 5.492 5.492 0 0 0-1.768.296l-1.072-.304.944-5.504h5.576v.744a.812.812 0 0 1-.232.6c-.154.155-.413.232-.776.232h-3.376l-.464 2.68zM16.485 11.643h-1.571V16h-.816v-4.357h-1.575v-.683h3.962v.682zM18.51 16h-.822v-5.04h.822V16zm4.841-.662l-.004.662h-3.143v-5.04h3.143v.661h-2.32v1.52h1.855v.64h-1.855v1.557h2.324zm2.85-1.963c.186 0 .35-.022.49-.066.14-.047.256-.111.35-.193a.782.782 0 0 0 .21-.29.99.99 0 0 0 .07-.379c0-.275-.091-.485-.273-.63-.182-.144-.458-.216-.826-.216h-.665v1.774h.644zM28.573 16h-.732c-.145 0-.25-.056-.315-.168l-1.176-1.698a.389.389 0 0 0-.13-.126.448.448 0 0 0-.21-.038h-.454V16h-.82v-5.04h1.485c.331 0 .616.034.854.101.24.068.437.165.591.291.154.124.267.273.34.448.074.175.112.37.112.584 0 .175-.027.339-.08.49-.052.152-.128.29-.228.413a1.43 1.43 0 0 1-.364.322c-.145.091-.31.163-.494.214.1.06.187.146.26.255L28.571 16z",
  fill: "#fff"
});

var SvgMgp5 = function SvgMgp5(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMgp5);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp-unknown.svg":
/*!***************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp-unknown.svg ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20z",
  fill: "#fff",
  stroke: "#979797"
});

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 36c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M17.975 20.512c.176-.16.368-.31.576-.448a4.038 4.038 0 0 1 1.464-.616c.288-.064.598-.096.928-.096.443 0 .848.064 1.216.192.373.123.694.301.96.536.272.23.483.51.632.84.15.325.224.69.224 1.096 0 .405-.059.757-.176 1.056-.117.293-.267.55-.448.768-.181.219-.378.41-.592.576l-.608.456c-.186.139-.35.28-.488.424a.851.851 0 0 0-.24.464l-.168 1.2h-1.168l-.12-1.32c-.026-.25.014-.467.12-.648a2.21 2.21 0 0 1 .424-.512c.181-.16.379-.312.592-.456.219-.15.421-.315.608-.496s.344-.384.472-.608c.128-.224.192-.493.192-.808 0-.208-.04-.395-.12-.56a1.214 1.214 0 0 0-.336-.432 1.58 1.58 0 0 0-.504-.272 1.962 1.962 0 0 0-.624-.096c-.314 0-.581.037-.8.112a3.079 3.079 0 0 0-.56.248 3.518 3.518 0 0 0-.384.24.487.487 0 0 1-.256.104.394.394 0 0 1-.368-.216l-.448-.728zm1.536 9.496c0-.155.027-.299.08-.432.059-.139.136-.259.232-.36.101-.101.219-.181.352-.24a1.117 1.117 0 0 1 .872 0c.139.059.259.139.36.24a1.12 1.12 0 0 1 .328.792c0 .16-.03.307-.088.44-.058.133-.138.25-.24.352a1.02 1.02 0 0 1-.36.232 1.117 1.117 0 0 1-.872 0 1.038 1.038 0 0 1-.352-.232 1.224 1.224 0 0 1-.232-.352 1.175 1.175 0 0 1-.08-.44zM16.485 11.643h-1.571V16h-.816v-4.357h-1.575v-.683h3.962v.682zM18.51 16h-.822v-5.04h.822V16zm4.841-.662l-.004.662h-3.143v-5.04h3.143v.661h-2.32v1.52h1.855v.64h-1.855v1.557h2.324zm2.85-1.963c.186 0 .35-.022.49-.066.14-.047.256-.111.35-.193a.782.782 0 0 0 .21-.29.99.99 0 0 0 .07-.379c0-.275-.091-.485-.273-.63-.182-.144-.458-.216-.826-.216h-.665v1.774h.644zM28.573 16h-.732c-.145 0-.25-.056-.315-.168l-1.176-1.698a.389.389 0 0 0-.13-.126.448.448 0 0 0-.21-.038h-.454V16h-.82v-5.04h1.485c.331 0 .616.034.854.101.24.068.437.165.591.291.154.124.267.273.34.448.074.175.112.37.112.584 0 .175-.027.339-.08.49-.052.152-.128.29-.228.413a1.43 1.43 0 0 1-.364.322c-.145.091-.31.163-.494.214.1.06.187.146.26.255L28.571 16z",
  fill: "#000"
});

var SvgMgpUnknown = function SvgMgpUnknown(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMgpUnknown);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/mgp.tsx":
/*!*******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/mgp.tsx ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mgp = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var mgp_1_svg_1 = __importDefault(__webpack_require__(/*! ./mgp-1.svg */ "./src/components/location_status_icons/status_icons/mgp-1.svg"));
var mgp_2_svg_1 = __importDefault(__webpack_require__(/*! ./mgp-2.svg */ "./src/components/location_status_icons/status_icons/mgp-2.svg"));
var mgp_3_svg_1 = __importDefault(__webpack_require__(/*! ./mgp-3.svg */ "./src/components/location_status_icons/status_icons/mgp-3.svg"));
var mgp_4_svg_1 = __importDefault(__webpack_require__(/*! ./mgp-4.svg */ "./src/components/location_status_icons/status_icons/mgp-4.svg"));
var mgp_5_svg_1 = __importDefault(__webpack_require__(/*! ./mgp-5.svg */ "./src/components/location_status_icons/status_icons/mgp-5.svg"));
var mgp_unknown_svg_1 = __importDefault(__webpack_require__(/*! ./mgp-unknown.svg */ "./src/components/location_status_icons/status_icons/mgp-unknown.svg"));
var Mgp = function (props) {
    var tier = props.tier, other = __rest(props, ["tier"]);
    switch (tier) {
        case 1:
            return React.createElement(mgp_1_svg_1.default, __assign({}, other));
        case 2:
            return React.createElement(mgp_2_svg_1.default, __assign({}, other));
        case 3:
            return React.createElement(mgp_3_svg_1.default, __assign({}, other));
        case 4:
            return React.createElement(mgp_4_svg_1.default, __assign({}, other));
        case 5:
            return React.createElement(mgp_5_svg_1.default, __assign({}, other));
    }
    return React.createElement(mgp_unknown_svg_1.default, __assign({}, other));
};
exports.Mgp = Mgp;


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/new.svg":
/*!*******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/new.svg ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M5 10h26.087L35 20l-3.913 10H5l3.913-10z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M17.293 15.873V22.5h-.633a.557.557 0 0 1-.245-.048.574.574 0 0 1-.19-.163l-3.46-4.418c.018.202.027.388.027.559v4.07h-1.086v-6.627h.646c.052 0 .097.002.135.006a.325.325 0 0 1 .101.028.33.33 0 0 1 .085.06c.027.025.058.06.092.103l3.474 4.436a8.872 8.872 0 0 1-.023-.316 4.94 4.94 0 0 1-.01-.289v-4.028h1.087zm4.327 3.735a1.37 1.37 0 0 0-.062-.415.986.986 0 0 0-.186-.341.863.863 0 0 0-.314-.232 1.078 1.078 0 0 0-.442-.085c-.327 0-.585.094-.772.28-.188.186-.308.45-.36.793h2.136zm-2.16.683c.02.241.062.45.13.625.066.176.155.321.265.436.11.114.24.2.392.257.151.056.318.084.502.084.183 0 .341-.021.474-.064.133-.043.25-.09.348-.142.1-.052.187-.1.262-.142a.438.438 0 0 1 .217-.064c.095 0 .165.035.211.105l.326.413a1.91 1.91 0 0 1-.422.369 2.419 2.419 0 0 1-.488.238 2.61 2.61 0 0 1-.518.126 3.708 3.708 0 0 1-.511.037 2.5 2.5 0 0 1-.912-.163 2.042 2.042 0 0 1-.733-.481 2.258 2.258 0 0 1-.49-.789 3.05 3.05 0 0 1-.18-1.088c0-.32.052-.623.156-.905a2.1 2.1 0 0 1 1.157-1.236 2.34 2.34 0 0 1 .947-.183c.296 0 .57.048.82.142.25.095.466.233.647.415.18.182.321.405.424.67.102.264.153.565.153.904 0 .172-.018.287-.055.346-.037.06-.107.09-.21.09H19.46zm10.74-2.494L28.705 22.5h-.907c-.104 0-.176-.067-.215-.202l-.844-2.718a6.66 6.66 0 0 1-.075-.272 3.324 3.324 0 0 1-.058-.273 6.499 6.499 0 0 1-.137.555l-.857 2.708c-.037.135-.118.202-.243.202h-.871l-1.49-4.703h.903c.083 0 .153.02.211.06.058.04.096.09.115.151l.673 2.512a7.072 7.072 0 0 1 .156.797c.034-.13.07-.262.108-.394.038-.131.079-.265.121-.403l.78-2.52a.288.288 0 0 1 .107-.152.317.317 0 0 1 .195-.06h.5c.08 0 .147.02.204.06a.28.28 0 0 1 .112.151l.756 2.521c.04.138.077.273.112.406.036.133.07.265.104.396.04-.26.096-.527.17-.802l.691-2.512a.31.31 0 0 1 .115-.15c.055-.04.12-.06.197-.06h.862z"
}));

var SvgNew = function SvgNew(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgNew);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/o.svg":
/*!*****************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/o.svg ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.76 15.552c0 .53-.087 1.02-.263 1.472a3.457 3.457 0 0 1-.742 1.173c-.32.33-.705.587-1.155.772a3.91 3.91 0 0 1-1.5.278 3.896 3.896 0 0 1-1.495-.278 3.4 3.4 0 0 1-1.158-.772 3.482 3.482 0 0 1-.747-1.173 4.007 4.007 0 0 1-.265-1.472c0-.53.088-1.021.265-1.473.177-.452.426-.842.748-1.172a3.4 3.4 0 0 1 1.157-.773c.45-.185.948-.277 1.495-.277.367 0 .712.042 1.035.127.323.085.62.205.89.36s.512.343.728.565c.215.222.397.47.547.743.15.273.264.57.342.89.079.32.118.656.118 1.01zm-1.375 0a3.31 3.31 0 0 0-.16-1.068 2.288 2.288 0 0 0-.455-.802 1.948 1.948 0 0 0-.718-.505 2.469 2.469 0 0 0-.952-.175c-.353 0-.67.058-.952.175a1.971 1.971 0 0 0-.72.505 2.26 2.26 0 0 0-.458.802 3.31 3.31 0 0 0-.16 1.068c0 .396.053.752.16 1.067.107.315.26.582.457.8.199.219.439.386.72.503.282.116.6.175.953.175s.67-.059.952-.175a1.96 1.96 0 0 0 .718-.503c.197-.218.348-.485.455-.8.107-.315.16-.67.16-1.067z"
})));

var SvgO = function SvgO(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgO);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/od.svg":
/*!******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/od.svg ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#9575CD"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M14.957 15.552c0 .53-.087 1.02-.262 1.472a3.457 3.457 0 0 1-.742 1.173c-.32.33-.705.587-1.155.772a3.91 3.91 0 0 1-1.5.278 3.896 3.896 0 0 1-1.495-.278 3.4 3.4 0 0 1-1.158-.772 3.467 3.467 0 0 1-.747-1.173 4.007 4.007 0 0 1-.265-1.472c0-.53.088-1.021.264-1.473.177-.452.426-.842.748-1.172a3.4 3.4 0 0 1 1.158-.773c.45-.185.948-.277 1.494-.277.367 0 .712.042 1.035.127.324.085.62.205.89.36s.513.343.728.565a3.49 3.49 0 0 1 .89 1.633c.078.32.117.656.117 1.01zm-1.375 0a3.31 3.31 0 0 0-.16-1.068 2.288 2.288 0 0 0-.455-.802 1.948 1.948 0 0 0-.717-.505 2.469 2.469 0 0 0-.953-.175c-.353 0-.67.058-.952.175a1.971 1.971 0 0 0-.72.505c-.198.22-.35.487-.457.802a3.31 3.31 0 0 0-.16 1.068c0 .396.053.752.16 1.067.106.315.259.582.457.8.198.219.438.386.72.503.282.116.6.175.952.175.354 0 .671-.059.953-.175.282-.117.52-.284.717-.503.197-.218.349-.485.455-.8.107-.315.16-.67.16-1.067zm8.98 0a3.91 3.91 0 0 1-.265 1.46 3.354 3.354 0 0 1-.745 1.145c-.32.32-.704.568-1.154.745-.45.176-.95.265-1.5.265h-2.756v-7.23h2.756c.55 0 1.05.089 1.5.267.45.179.834.427 1.154.745.32.319.569.7.745 1.143.177.443.265.93.265 1.46zm-1.38 0c0-.397-.052-.753-.157-1.068a2.212 2.212 0 0 0-.455-.8 1.985 1.985 0 0 0-.72-.502 2.469 2.469 0 0 0-.953-.175h-1.404v5.09h1.405c.353 0 .67-.059.952-.175.282-.117.522-.284.72-.503.198-.218.35-.485.455-.8.105-.315.158-.67.158-1.067z"
})));

var SvgOd = function SvgOd(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgOd);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/ongoing-tasks-base.svg":
/*!**********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/ongoing-tasks-base.svg ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  filter: "url(#ongoing-tasks-base_svg__filter0_d_327_21903)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  x: 4.8,
  y: 2.8,
  width: 38.4,
  height: 38.4,
  rx: 4,
  fill: "#fff",
  stroke: "#979797",
  strokeLinejoin: "round"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M31.5 11.5h-15a.75.75 0 0 0-.75.75v19.5c0 .415.335.75.75.75h15a.75.75 0 0 0 .75-.75v-19.5a.75.75 0 0 0-.75-.75zm-14.063 1.688h13.125v4.874H17.438v-4.875zm13.125 11.25H17.438v-4.875h13.125v4.875zm0 6.375H17.438v-4.875h13.125v4.875zM19.126 15.624a.938.938 0 1 0 1.875 0 .938.938 0 0 0-1.875 0zm0 6.375A.938.938 0 1 0 21 22a.938.938 0 0 0-1.875 0zm0 6.375a.938.938 0 1 0 1.875 0 .938.938 0 0 0-1.875 0z",
  fill: "#FFA000"
}));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "ongoing-tasks-base_svg__filter0_d_327_21903",
  x: 0.3,
  y: 0.3,
  width: 47.4,
  height: 47.4,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_327_21903"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_327_21903",
  result: "shape"
})));

var SvgOngoingTasksBase = function SvgOngoingTasksBase(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgOngoingTasksBase);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/ongoing-tasks-hover.svg":
/*!***********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/ongoing-tasks-hover.svg ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  filter: "url(#ongoing-tasks-hover_svg__filter0_d_378_29514)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("rect", {
  x: 4.8,
  y: 2.8,
  width: 38.4,
  height: 38.4,
  rx: 4,
  fill: "#979797",
  fillOpacity: 0.08,
  stroke: "#979797",
  strokeLinejoin: "round"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M31.5 11.5h-15a.75.75 0 0 0-.75.75v19.5c0 .415.335.75.75.75h15a.75.75 0 0 0 .75-.75v-19.5a.75.75 0 0 0-.75-.75zm-14.063 1.688h13.125v4.874H17.438v-4.875zm13.125 11.25H17.438v-4.875h13.125v4.875zm0 6.375H17.438v-4.875h13.125v4.875zM19.126 15.624a.938.938 0 1 0 1.875 0 .938.938 0 0 0-1.875 0zm0 6.375A.938.938 0 1 0 21 22a.938.938 0 0 0-1.875 0zm0 6.375a.938.938 0 1 0 1.875 0 .938.938 0 0 0-1.875 0z",
  fill: "#FFA000"
}));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "ongoing-tasks-hover_svg__filter0_d_378_29514",
  x: 0.3,
  y: 0.3,
  width: 47.4,
  height: 47.4,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_378_29514"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_378_29514",
  result: "shape"
})));

var SvgOngoingTasksHover = function SvgOngoingTasksHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgOngoingTasksHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/part-of-big-portfolio.svg":
/*!*************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/part-of-big-portfolio.svg ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#BBDEFB",
  stroke: "#1E88E5",
  strokeLinejoin: "round",
  d: "M20.576 19.424L33 17.871V20c0 7.18-5.82 13-13 13S7 27.18 7 20 12.82 7 20 7h2.129l-1.553 12.424z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#BBDEFB",
  stroke: "#1E88E5",
  strokeLinejoin: "round",
  d: "M26.684 6.623c1.931 1.176 3.42 2.329 4.464 3.46a11.458 11.458 0 0 1 2.376 3.941l-9.743 2.25 2.903-9.65z"
}));

var SvgPartOfBigPortfolio = function SvgPartOfBigPortfolio(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPartOfBigPortfolio);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/pay-ahead.svg":
/*!*************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/pay-ahead.svg ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  stroke: "#1E88E5",
  d: "M18.75 15H35v10H18.75z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M26.875 20l-5 3.125v-6.25zm6.25 0l-5 3.125v-6.25z",
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 0.5
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  fillRule: "nonzero",
  d: "M11.103 23.23c.648-.085 1.138-.303 1.471-.655.333-.351.5-.81.5-1.38a1.41 1.41 0 0 0-.124-.609 1.456 1.456 0 0 0-.348-.463 2.256 2.256 0 0 0-.527-.348 6.711 6.711 0 0 0-.66-.275l-.312 3.73zm-.587-9.688a3.297 3.297 0 0 0-.87.215c-.239.1-.434.225-.587.371a1.355 1.355 0 0 0-.335.495 1.6 1.6 0 0 0-.105.578c0 .232.041.435.123.61.083.174.196.33.34.467.143.137.313.26.508.367.196.107.41.206.642.297l.284-3.4zm1.073 3.84c.44.135.877.283 1.31.445.434.162.824.371 1.17.628.345.257.624.576.838.958.214.382.32.86.32 1.434a4.47 4.47 0 0 1-.283 1.6c-.19.498-.468.938-.834 1.32a4.316 4.316 0 0 1-1.348.935c-.532.241-1.14.384-1.824.426l-.11 1.348a.596.596 0 0 1-.179.39.563.563 0 0 1-.426.178h-.834l.165-1.962a6.986 6.986 0 0 1-2.017-.586 5.668 5.668 0 0 1-1.604-1.091l.697-1.036a.716.716 0 0 1 .242-.224.645.645 0 0 1 .326-.087.82.82 0 0 1 .43.142c.154.094.328.204.523.33.196.125.419.252.67.38.25.128.546.223.889.284l.339-4.097a14.149 14.149 0 0 1-1.288-.431 4.317 4.317 0 0 1-1.146-.656 3.046 3.046 0 0 1-.82-1.03c-.208-.416-.312-.936-.312-1.56 0-.464.092-.917.275-1.36a3.53 3.53 0 0 1 .811-1.188 4.347 4.347 0 0 1 1.316-.861c.519-.226 1.115-.355 1.787-.385l.1-1.155a.64.64 0 0 1 .184-.394.566.566 0 0 1 .431-.175h.834l-.146 1.797c.647.104 1.207.289 1.677.555.47.266.877.563 1.22.894l-.55.834c-.08.122-.163.214-.248.275a.522.522 0 0 1-.312.091.829.829 0 0 1-.33-.087 8.965 8.965 0 0 1-.43-.21 8.265 8.265 0 0 0-.537-.253 3.834 3.834 0 0 0-.655-.21l-.321 3.795z"
}));

var SvgPayAhead = function SvgPayAhead(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPayAhead);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/payment_term.tsx":
/*!****************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/payment_term.tsx ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerm = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var _15_days_svg_1 = __importDefault(__webpack_require__(/*! ./15-days.svg */ "./src/components/location_status_icons/status_icons/15-days.svg"));
var _30_days_svg_1 = __importDefault(__webpack_require__(/*! ./30-days.svg */ "./src/components/location_status_icons/status_icons/30-days.svg"));
var _45_days_svg_1 = __importDefault(__webpack_require__(/*! ./45-days.svg */ "./src/components/location_status_icons/status_icons/45-days.svg"));
var _60_days_svg_1 = __importDefault(__webpack_require__(/*! ./60-days.svg */ "./src/components/location_status_icons/status_icons/60-days.svg"));
var _90_days_svg_1 = __importDefault(__webpack_require__(/*! ./90-days.svg */ "./src/components/location_status_icons/status_icons/90-days.svg"));
var mapping = {
    15: _15_days_svg_1.default,
    30: _30_days_svg_1.default,
    45: _45_days_svg_1.default,
    60: _60_days_svg_1.default,
    90: _90_days_svg_1.default,
};
var PaymentTerm = function (props) {
    var Component = mapping[props.state];
    if (Component)
        return React.createElement(Component, __assign({}, props));
    return null;
};
exports.PaymentTerm = PaymentTerm;


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/pdm.svg":
/*!*******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/pdm.svg ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#1E88E5"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M6.633 15.572c.246 0 .461-.031.644-.093.184-.062.336-.15.458-.265.122-.115.212-.255.272-.42.06-.165.09-.349.09-.552 0-.194-.03-.369-.09-.525-.06-.157-.15-.29-.27-.4a1.201 1.201 0 0 0-.455-.253 2.153 2.153 0 0 0-.65-.087H5.629v2.595h1.005zm0-3.635c.483 0 .901.056 1.255.17.353.113.644.271.874.475.23.203.401.446.513.73.112.283.168.593.168.93 0 .35-.059.67-.175.962a1.997 1.997 0 0 1-.526.753 2.44 2.44 0 0 1-.877.49 3.92 3.92 0 0 1-1.232.175H5.628v2.545H4.282v-7.23h2.35zm10.26 3.615a3.91 3.91 0 0 1-.265 1.46 3.354 3.354 0 0 1-.745 1.145c-.32.32-.705.568-1.155.745-.45.176-.95.265-1.5.265h-2.755v-7.23h2.754c.55 0 1.05.089 1.5.267.45.179.835.427 1.155.745.32.319.569.7.746 1.143.176.443.264.93.264 1.46zm-1.38 0c0-.397-.053-.753-.158-1.068a2.212 2.212 0 0 0-.455-.8 1.985 1.985 0 0 0-.72-.502 2.469 2.469 0 0 0-.953-.175h-1.405v5.09h1.405c.354 0 .671-.059.953-.175.282-.117.522-.284.72-.503.198-.218.35-.485.455-.8.105-.315.157-.67.157-1.067zm10.405-3.615v7.23h-1.185v-4.67c0-.187.01-.389.03-.605l-2.186 4.105a.505.505 0 0 1-.475.295h-.19a.505.505 0 0 1-.474-.295l-2.21-4.12a9.395 9.395 0 0 1 .034.62v4.67h-1.184v-7.23h1.015c.06 0 .111.001.154.005a.42.42 0 0 1 .118.025.255.255 0 0 1 .095.065c.028.03.056.07.082.12l2.165 4.015c.057.106.11.216.158.33.048.113.096.23.143.35a6.207 6.207 0 0 1 .305-.69l2.135-4.005a.505.505 0 0 1 .084-.12.278.278 0 0 1 .098-.065.42.42 0 0 1 .117-.025 2.06 2.06 0 0 1 .155-.005h1.015z"
})));

var SvgPdm = function SvgPdm(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPdm);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/recently-saved.svg":
/*!******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/recently-saved.svg ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#D8D8D8",
  d: "M10.561 8.333L8.44 10.454a3.5 3.5 0 0 0 0 4.95l16.263 16.263a3.5 3.5 0 0 0 4.95 0l2.121-2.121a3.5 3.5 0 0 0 0-4.95L15.511 8.333a3.5 3.5 0 0 0-4.95 0z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M30.796 8.226l2.121 2.12a3.5 3.5 0 0 1 0 4.95L16.654 31.56a3.5 3.5 0 0 1-4.95 0l-2.121-2.121a3.5 3.5 0 0 1 0-4.95L25.846 8.226a3.5 3.5 0 0 1 4.95 0z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFECB3",
  stroke: "#FFECB3",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M16.2 21.913l7.07-7.071 3.03 3.03-7.07 7.072z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "#FFECB3",
  transform: "rotate(-45 36.398 .739)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 3.214,
  cy: 0.357,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 0.357,
  cy: 1.786,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 3.214,
  cy: 3.214,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 0.357,
  cy: 4.643,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 3.214,
  cy: 6.071,
  r: 1
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "#FFECB3",
  transform: "scale(-1 1) rotate(45 -24.255 -28.577)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 3.214,
  cy: 0.357,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 0.357,
  cy: 1.786,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 3.214,
  cy: 3.214,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 0.357,
  cy: 4.643,
  r: 1
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 3.214,
  cy: 6.071,
  r: 1
})));

var SvgRecentlySaved = function SvgRecentlySaved(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRecentlySaved);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/recycle-more.svg":
/*!****************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/recycle-more.svg ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#EAF5E1",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M20 30.969l-3.882 3.52-1.602-4.99-5.123 1.108 1.108-5.123-4.99-1.602L9.031 20l-3.52-3.882 4.99-1.602-1.108-5.123 5.123 1.108 1.602-4.99L20 9.031l3.882-3.52 1.602 4.99 5.123-1.108-1.108 5.123 4.99 1.602L30.969 20l3.52 3.882-4.99 1.602 1.108 5.123-5.123-1.108-1.602 4.99z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "#689F38",
  stroke: "#689F38",
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M23.475 17.929l-3.107-1.396 3.634-2.169z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M17 15.85L19.824 12l2.823 3.85v.7l-2.823-3.85L17 16.55zm3.307 9.017l2.681-2.21.385 4.295z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M25.547 20.198l1.92 4.503-4.878.419-.618-.372 4.877-.419-1.92-4.503zM16.488 18.452l.572 3.428-3.912-1.815z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  d: "M18.01 25.285l-4.87-.504 1.998-4.469.625-.36-1.999 4.469 4.87.504z"
})));

var SvgRecycleMore = function SvgRecycleMore(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRecycleMore);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/root.svg":
/*!********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/root.svg ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#1E88E5"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M3.695 15.377c.253 0 .474-.032.663-.095a1.28 1.28 0 0 0 .465-.263c.121-.112.212-.244.272-.397.06-.154.09-.322.09-.505 0-.367-.12-.649-.362-.845-.242-.197-.611-.295-1.108-.295h-.86v2.4h.84zm3.46 3.79H5.94c-.23 0-.397-.09-.5-.27l-1.52-2.315a.533.533 0 0 0-.188-.185.657.657 0 0 0-.302-.055h-.575v2.825H1.51v-7.23h2.205c.49 0 .91.05 1.263.152.351.102.64.244.865.428.225.183.39.402.497.657.107.255.16.536.16.843 0 .243-.036.473-.107.69a1.997 1.997 0 0 1-.81 1.055 2.508 2.508 0 0 1-.678.315 1.261 1.261 0 0 1 .44.42l1.81 2.67zm7.68-3.615c0 .53-.087 1.02-.263 1.472a3.457 3.457 0 0 1-.742 1.173c-.32.33-.705.587-1.155.772a3.91 3.91 0 0 1-1.5.278 3.896 3.896 0 0 1-1.495-.278 3.4 3.4 0 0 1-1.157-.772 3.469 3.469 0 0 1-.748-1.173 4.007 4.007 0 0 1-.265-1.472c0-.53.088-1.021.265-1.473.177-.452.426-.842.748-1.172a3.4 3.4 0 0 1 1.157-.773c.45-.185.948-.277 1.495-.277.367 0 .712.042 1.035.127.323.085.62.205.89.36s.512.343.728.565c.215.222.397.47.547.743.15.273.264.57.342.89.079.32.118.656.118 1.01zm-1.375 0a3.31 3.31 0 0 0-.16-1.068 2.288 2.288 0 0 0-.455-.802 1.948 1.948 0 0 0-.718-.505 2.469 2.469 0 0 0-.952-.175c-.353 0-.67.058-.953.175a1.971 1.971 0 0 0-.72.505c-.198.22-.35.487-.457.802a3.31 3.31 0 0 0-.16 1.068c0 .396.053.752.16 1.067.107.315.26.582.457.8.199.219.439.386.72.503.282.116.6.175.953.175s.67-.059.952-.175a1.96 1.96 0 0 0 .718-.503c.197-.218.348-.485.455-.8.107-.315.16-.67.16-1.067zm9.455 0c0 .53-.087 1.02-.262 1.472a3.457 3.457 0 0 1-.743 1.173c-.32.33-.705.587-1.155.772a3.91 3.91 0 0 1-1.5.278 3.896 3.896 0 0 1-1.495-.278 3.4 3.4 0 0 1-1.158-.772 3.482 3.482 0 0 1-.747-1.173 4.007 4.007 0 0 1-.265-1.472c0-.53.088-1.021.265-1.473.177-.452.426-.842.747-1.172a3.4 3.4 0 0 1 1.158-.773c.45-.185.948-.277 1.495-.277.367 0 .712.042 1.035.127.323.085.62.205.89.36s.512.343.727.565c.216.222.398.47.548.743.15.273.264.57.343.89.078.32.117.656.117 1.01zm-1.375 0a3.31 3.31 0 0 0-.16-1.068 2.288 2.288 0 0 0-.455-.802 1.948 1.948 0 0 0-.718-.505 2.469 2.469 0 0 0-.952-.175c-.353 0-.67.058-.953.175a1.971 1.971 0 0 0-.72.505c-.198.22-.35.487-.457.802a3.31 3.31 0 0 0-.16 1.068c0 .396.053.752.16 1.067.107.315.26.582.457.8.199.219.439.386.72.503.282.116.6.175.953.175s.67-.059.953-.175c.281-.117.52-.284.717-.503.197-.218.348-.485.455-.8.107-.315.16-.67.16-1.067zm7.61-2.51h-2.18v6.125h-1.345v-6.125h-2.18v-1.105h5.705v1.105z"
})));

var SvgRoot = function SvgRoot(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRoot);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/secondary-key-hover.svg":
/*!***********************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/secondary-key-hover.svg ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "secondary-key-hover_svg__a",
  width: "165%",
  height: "165%",
  x: "-32.5%",
  y: "-32.5%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMerge", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#secondary-key-hover_svg__a)",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797",
  strokeLinejoin: "round"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#0091FF",
  fontFamily: "Lato-Semibold, Lato",
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.35
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 26.345,
  y: 25
}, "2")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#FFA000",
  transform: "matrix(1 0 0 -1 5 32)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.98 5.73l-4.543-4.543m7.094 2.094L16.72.47M10.5 13.281L21.875 1.875"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 7.5,
  cy: 16.25,
  r: 7.5,
  fill: "#FFA000"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5,
  cy: 18.75,
  r: 3.75,
  fill: "#FFF"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#979797",
  fillOpacity: 0.08
}));

var SvgSecondaryKeyHover = function SvgSecondaryKeyHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSecondaryKeyHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/secondary-key.svg":
/*!*****************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/secondary-key.svg ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "secondary-key_svg__a",
  width: "165%",
  height: "165%",
  x: "-32.5%",
  y: "-32.5%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMerge", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#secondary-key_svg__a)",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797",
  strokeLinejoin: "round"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("text", {
  fill: "#0091FF",
  fontFamily: "Lato-Semibold, Lato",
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.35
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tspan", {
  x: 26.345,
  y: 25
}, "2")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#FFA000",
  transform: "matrix(1 0 0 -1 5 32)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.98 5.73l-4.543-4.543m7.094 2.094L16.72.47M10.5 13.281L21.875 1.875"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 7.5,
  cy: 16.25,
  r: 7.5,
  fill: "#FFA000"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 5,
  cy: 18.75,
  r: 3.75,
  fill: "#FFF"
})));

var SvgSecondaryKey = function SvgSecondaryKey(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSecondaryKey);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/ss.svg":
/*!******************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/ss.svg ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#1E88E5"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M14.27 13.252a.464.464 0 0 1-.127.152.284.284 0 0 1-.168.048.432.432 0 0 1-.227-.078 6.334 6.334 0 0 0-.293-.172 2.409 2.409 0 0 0-.398-.173 1.67 1.67 0 0 0-.537-.077c-.187 0-.35.022-.49.067a1.03 1.03 0 0 0-.352.188.75.75 0 0 0-.213.287.944.944 0 0 0-.07.368c0 .17.047.311.143.425.095.113.22.21.377.29.157.08.335.151.535.215.2.063.405.13.615.202.21.072.415.155.615.25s.378.215.535.36c.157.145.282.323.377.533.096.21.143.465.143.765 0 .326-.056.632-.167.917a2.117 2.117 0 0 1-.49.745 2.308 2.308 0 0 1-.788.5 2.9 2.9 0 0 1-1.065.183 3.58 3.58 0 0 1-1.9-.56 2.784 2.784 0 0 1-.48-.39l.395-.645a.422.422 0 0 1 .13-.118.328.328 0 0 1 .17-.047.48.48 0 0 1 .27.102c.097.069.212.144.345.228.133.083.29.159.468.227.178.069.392.103.642.103.383 0 .68-.091.89-.273.21-.182.315-.442.315-.782a.727.727 0 0 0-.143-.465 1.15 1.15 0 0 0-.377-.303 2.819 2.819 0 0 0-.535-.207 17.74 17.74 0 0 1-.61-.185 5.26 5.26 0 0 1-.61-.24 1.976 1.976 0 0 1-.535-.365 1.66 1.66 0 0 1-.377-.563c-.096-.225-.143-.502-.143-.832a1.988 1.988 0 0 1 .615-1.435c.2-.194.447-.349.74-.465a2.71 2.71 0 0 1 1.01-.175c.427 0 .82.066 1.18.2.36.133.667.32.92.56l-.335.635zm5.485 0a.464.464 0 0 1-.127.152.284.284 0 0 1-.168.048.432.432 0 0 1-.227-.078 6.334 6.334 0 0 0-.293-.172 2.409 2.409 0 0 0-.398-.173 1.67 1.67 0 0 0-.537-.077c-.187 0-.35.022-.49.067a1.03 1.03 0 0 0-.352.188.75.75 0 0 0-.213.287.944.944 0 0 0-.07.368c0 .17.047.311.143.425.095.113.22.21.377.29.157.08.335.151.535.215.2.063.405.13.615.202.21.072.415.155.615.25s.378.215.535.36c.157.145.282.323.378.533.095.21.142.465.142.765 0 .326-.056.632-.168.917a2.117 2.117 0 0 1-.49.745 2.308 2.308 0 0 1-.787.5 2.9 2.9 0 0 1-1.065.183 3.58 3.58 0 0 1-1.9-.56 2.784 2.784 0 0 1-.48-.39l.395-.645a.422.422 0 0 1 .13-.118.328.328 0 0 1 .17-.047.48.48 0 0 1 .27.102c.097.069.212.144.345.228.133.083.29.159.468.227.178.069.392.103.642.103.383 0 .68-.091.89-.273.21-.182.315-.442.315-.782a.727.727 0 0 0-.142-.465 1.15 1.15 0 0 0-.378-.303 2.819 2.819 0 0 0-.535-.207 17.74 17.74 0 0 1-.61-.185 5.26 5.26 0 0 1-.61-.24 1.976 1.976 0 0 1-.535-.365 1.66 1.66 0 0 1-.377-.563c-.096-.225-.143-.502-.143-.832 0-.264.052-.52.158-.77.105-.25.257-.472.457-.665.2-.194.447-.349.74-.465a2.71 2.71 0 0 1 1.01-.175c.427 0 .82.066 1.18.2.36.133.667.32.92.56l-.335.635z"
})));

var SvgSs = function SvgSs(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSs);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/strategy.tsx":
/*!************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/strategy.tsx ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Strategy = void 0;
var React = __importStar(__webpack_require__(/*! react */ "react"));
var b_svg_1 = __importDefault(__webpack_require__(/*! ./b.svg */ "./src/components/location_status_icons/status_icons/b.svg"));
var o_svg_1 = __importDefault(__webpack_require__(/*! ./o.svg */ "./src/components/location_status_icons/status_icons/o.svg"));
var bo_svg_1 = __importDefault(__webpack_require__(/*! ./bo.svg */ "./src/components/location_status_icons/status_icons/bo.svg"));
var bd_svg_1 = __importDefault(__webpack_require__(/*! ./bd.svg */ "./src/components/location_status_icons/status_icons/bd.svg"));
var d_svg_1 = __importDefault(__webpack_require__(/*! ./d.svg */ "./src/components/location_status_icons/status_icons/d.svg"));
var od_svg_1 = __importDefault(__webpack_require__(/*! ./od.svg */ "./src/components/location_status_icons/status_icons/od.svg"));
var bod_svg_1 = __importDefault(__webpack_require__(/*! ./bod.svg */ "./src/components/location_status_icons/status_icons/bod.svg"));
var mapping = {
    b: b_svg_1.default,
    o: o_svg_1.default,
    d: d_svg_1.default,
    bo: bo_svg_1.default,
    bd: bd_svg_1.default,
    od: od_svg_1.default,
    bod: bod_svg_1.default,
};
var Strategy = function (props) {
    var Component = mapping[props.state];
    return React.createElement(Component, __assign({}, props));
};
exports.Strategy = Strategy;


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/svg_icons.ts":
/*!************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/svg_icons.ts ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OngoingTasks = exports.OngoingTasksHover = exports.BillBlocker = exports.RecycleMore = exports.Boar = exports.CustomInvoicingHover = exports.CustomInvoicing = exports.InvoiceBlocker = exports.HaulerAccountIssue = exports.CustomerIssue = exports.LatePayer = exports.PayAhead = exports.Pdm = exports.Root = exports.SharedSavings = exports.HostileHauler = exports.Liquidation = exports.RecentlySaved = exports.New = exports.BigPortfolio = exports.SecondKeyHover = exports.SecondKey = exports.KeyHover = exports.Key = void 0;
var key_svg_1 = __webpack_require__(/*! ./key.svg */ "./src/components/location_status_icons/status_icons/key.svg");
Object.defineProperty(exports, "Key", { enumerable: true, get: function () { return __importDefault(key_svg_1).default; } });
var key_hover_svg_1 = __webpack_require__(/*! ./key-hover.svg */ "./src/components/location_status_icons/status_icons/key-hover.svg");
Object.defineProperty(exports, "KeyHover", { enumerable: true, get: function () { return __importDefault(key_hover_svg_1).default; } });
var secondary_key_svg_1 = __webpack_require__(/*! ./secondary-key.svg */ "./src/components/location_status_icons/status_icons/secondary-key.svg");
Object.defineProperty(exports, "SecondKey", { enumerable: true, get: function () { return __importDefault(secondary_key_svg_1).default; } });
var secondary_key_hover_svg_1 = __webpack_require__(/*! ./secondary-key-hover.svg */ "./src/components/location_status_icons/status_icons/secondary-key-hover.svg");
Object.defineProperty(exports, "SecondKeyHover", { enumerable: true, get: function () { return __importDefault(secondary_key_hover_svg_1).default; } });
var part_of_big_portfolio_svg_1 = __webpack_require__(/*! ./part-of-big-portfolio.svg */ "./src/components/location_status_icons/status_icons/part-of-big-portfolio.svg");
Object.defineProperty(exports, "BigPortfolio", { enumerable: true, get: function () { return __importDefault(part_of_big_portfolio_svg_1).default; } });
var new_svg_1 = __webpack_require__(/*! ./new.svg */ "./src/components/location_status_icons/status_icons/new.svg");
Object.defineProperty(exports, "New", { enumerable: true, get: function () { return __importDefault(new_svg_1).default; } });
var recently_saved_svg_1 = __webpack_require__(/*! ./recently-saved.svg */ "./src/components/location_status_icons/status_icons/recently-saved.svg");
Object.defineProperty(exports, "RecentlySaved", { enumerable: true, get: function () { return __importDefault(recently_saved_svg_1).default; } });
var liquidation_svg_1 = __webpack_require__(/*! ./liquidation.svg */ "./src/components/location_status_icons/status_icons/liquidation.svg");
Object.defineProperty(exports, "Liquidation", { enumerable: true, get: function () { return __importDefault(liquidation_svg_1).default; } });
var hostile_hauler_svg_1 = __webpack_require__(/*! ./hostile-hauler.svg */ "./src/components/location_status_icons/status_icons/hostile-hauler.svg");
Object.defineProperty(exports, "HostileHauler", { enumerable: true, get: function () { return __importDefault(hostile_hauler_svg_1).default; } });
var ss_svg_1 = __webpack_require__(/*! ./ss.svg */ "./src/components/location_status_icons/status_icons/ss.svg");
Object.defineProperty(exports, "SharedSavings", { enumerable: true, get: function () { return __importDefault(ss_svg_1).default; } });
var root_svg_1 = __webpack_require__(/*! ./root.svg */ "./src/components/location_status_icons/status_icons/root.svg");
Object.defineProperty(exports, "Root", { enumerable: true, get: function () { return __importDefault(root_svg_1).default; } });
var pdm_svg_1 = __webpack_require__(/*! ./pdm.svg */ "./src/components/location_status_icons/status_icons/pdm.svg");
Object.defineProperty(exports, "Pdm", { enumerable: true, get: function () { return __importDefault(pdm_svg_1).default; } });
var pay_ahead_svg_1 = __webpack_require__(/*! ./pay-ahead.svg */ "./src/components/location_status_icons/status_icons/pay-ahead.svg");
Object.defineProperty(exports, "PayAhead", { enumerable: true, get: function () { return __importDefault(pay_ahead_svg_1).default; } });
var late_payer_svg_1 = __webpack_require__(/*! ./late-payer.svg */ "./src/components/location_status_icons/status_icons/late-payer.svg");
Object.defineProperty(exports, "LatePayer", { enumerable: true, get: function () { return __importDefault(late_payer_svg_1).default; } });
var cust_issues_svg_1 = __webpack_require__(/*! ./cust-issues.svg */ "./src/components/location_status_icons/status_icons/cust-issues.svg");
Object.defineProperty(exports, "CustomerIssue", { enumerable: true, get: function () { return __importDefault(cust_issues_svg_1).default; } });
var hauler_account_issues_svg_1 = __webpack_require__(/*! ./hauler-account-issues.svg */ "./src/components/location_status_icons/status_icons/hauler-account-issues.svg");
Object.defineProperty(exports, "HaulerAccountIssue", { enumerable: true, get: function () { return __importDefault(hauler_account_issues_svg_1).default; } });
var invoice_blocker_svg_1 = __webpack_require__(/*! ./invoice-blocker.svg */ "./src/components/location_status_icons/status_icons/invoice-blocker.svg");
Object.defineProperty(exports, "InvoiceBlocker", { enumerable: true, get: function () { return __importDefault(invoice_blocker_svg_1).default; } });
var custom_invoicing_svg_1 = __webpack_require__(/*! ./custom-invoicing.svg */ "./src/components/location_status_icons/status_icons/custom-invoicing.svg");
Object.defineProperty(exports, "CustomInvoicing", { enumerable: true, get: function () { return __importDefault(custom_invoicing_svg_1).default; } });
var custom_invoicing_hover_svg_1 = __webpack_require__(/*! ./custom-invoicing-hover.svg */ "./src/components/location_status_icons/status_icons/custom-invoicing-hover.svg");
Object.defineProperty(exports, "CustomInvoicingHover", { enumerable: true, get: function () { return __importDefault(custom_invoicing_hover_svg_1).default; } });
var boar_svg_1 = __webpack_require__(/*! ./boar.svg */ "./src/components/location_status_icons/status_icons/boar.svg");
Object.defineProperty(exports, "Boar", { enumerable: true, get: function () { return __importDefault(boar_svg_1).default; } });
var recycle_more_svg_1 = __webpack_require__(/*! ./recycle-more.svg */ "./src/components/location_status_icons/status_icons/recycle-more.svg");
Object.defineProperty(exports, "RecycleMore", { enumerable: true, get: function () { return __importDefault(recycle_more_svg_1).default; } });
var bill_blocker_svg_1 = __webpack_require__(/*! ./bill_blocker.svg */ "./src/components/location_status_icons/status_icons/bill_blocker.svg");
Object.defineProperty(exports, "BillBlocker", { enumerable: true, get: function () { return __importDefault(bill_blocker_svg_1).default; } });
var ongoing_tasks_hover_svg_1 = __webpack_require__(/*! ./ongoing-tasks-hover.svg */ "./src/components/location_status_icons/status_icons/ongoing-tasks-hover.svg");
Object.defineProperty(exports, "OngoingTasksHover", { enumerable: true, get: function () { return __importDefault(ongoing_tasks_hover_svg_1).default; } });
var ongoing_tasks_base_svg_1 = __webpack_require__(/*! ./ongoing-tasks-base.svg */ "./src/components/location_status_icons/status_icons/ongoing-tasks-base.svg");
Object.defineProperty(exports, "OngoingTasks", { enumerable: true, get: function () { return __importDefault(ongoing_tasks_base_svg_1).default; } });


/***/ }),

/***/ "./src/components/location_status_icons/status_icons/swap.svg":
/*!********************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/swap.svg ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FFF",
  stroke: "#979797"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  stroke: "#1E88E5",
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  d: "M17.697 9.945c3.738-.8 6.582.316 8.532 3.347 1.95 3.032 2.502 7.194 1.654 12.485"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  d: "M27.806 28.927l-2.5-5.942 5.679.263-1.463 2.613z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  strokeLinecap: "round",
  d: "M22.132 30.259c-3.737.8-6.581-.316-8.532-3.348-1.95-3.032-2.501-7.193-1.653-12.485"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#1E88E5",
  d: "M12.47 11.435l1.979 6.14-5.634-.762 1.682-2.474z"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  fillRule: "nonzero",
  d: "M21.767 18.252a.464.464 0 0 1-.128.152.284.284 0 0 1-.167.048.432.432 0 0 1-.228-.078 6.334 6.334 0 0 0-.292-.172 2.409 2.409 0 0 0-.398-.173 1.67 1.67 0 0 0-.537-.077c-.187 0-.35.022-.49.067a1.03 1.03 0 0 0-.353.188.75.75 0 0 0-.212.287.944.944 0 0 0-.07.368c0 .17.047.311.142.425.095.113.221.21.378.29.156.08.335.151.535.215.2.063.405.13.615.202.21.072.415.155.615.25s.378.215.535.36c.156.145.282.323.377.533.095.21.143.465.143.765 0 .326-.056.632-.168.917a2.117 2.117 0 0 1-.49.745 2.308 2.308 0 0 1-.787.5 2.9 2.9 0 0 1-1.065.183 3.58 3.58 0 0 1-1.9-.56 2.784 2.784 0 0 1-.48-.39l.395-.645a.422.422 0 0 1 .13-.118.328.328 0 0 1 .17-.047.48.48 0 0 1 .27.102c.096.069.211.144.345.228.133.083.289.159.467.227.179.069.393.103.643.103.383 0 .68-.091.89-.273.21-.182.315-.442.315-.782a.727.727 0 0 0-.143-.465 1.15 1.15 0 0 0-.377-.303 2.819 2.819 0 0 0-.535-.207 17.74 17.74 0 0 1-.61-.185 5.26 5.26 0 0 1-.61-.24 1.976 1.976 0 0 1-.535-.365 1.66 1.66 0 0 1-.378-.563c-.095-.225-.142-.502-.142-.832a1.988 1.988 0 0 1 .615-1.435c.2-.194.446-.349.74-.465a2.71 2.71 0 0 1 1.01-.175c.426 0 .82.066 1.18.2.36.133.666.32.92.56l-.335.635z"
}));

var SvgSwap = function SvgSwap(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSwap);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/warning-health-hover.svg":
/*!************************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/warning-health-hover.svg ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  id: "warning-health-hover_svg__b",
  cx: 20,
  cy: 20,
  r: 20
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "warning-health-hover_svg__a",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-15%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  strokeLinejoin: "round"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
  fill: "#000",
  filter: "url(#warning-health-hover_svg__a)",
  xlinkHref: "#warning-health-hover_svg__b"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M19.696 16.485C25.883 11.328 30.009 8.75 32.07 8.75c3.094 0 4.64 3.094 0 10.828-3.094 5.157-7.219 10.829-12.375 17.017-6.188-8.25-10.313-13.923-12.376-17.017-3.093-4.64-3.093-10.828 0-10.828 2.063 0 6.188 2.578 12.376 7.735z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M21.175 18.992v4.29c0 .45-.02.89-.06 1.323-.04.433-.092.9-.157 1.4H19.87c-.07-.5-.124-.967-.161-1.4a15.32 15.32 0 0 1-.056-1.323v-4.29h1.522zm-1.83 9.87c0-.145.026-.282.079-.41.052-.127.126-.238.221-.333a1.01 1.01 0 0 1 .742-.307 1.02 1.02 0 0 1 .74.307c.092.095.165.206.22.334.056.127.083.264.083.409 0 .15-.027.287-.082.412a1.108 1.108 0 0 1-.222.33.97.97 0 0 1-.33.221 1.063 1.063 0 0 1-.409.08 1.021 1.021 0 0 1-1.043-1.043z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#979797",
  fillOpacity: 0.08
}));

var SvgWarningHealthHover = function SvgWarningHealthHover(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWarningHealthHover);

/***/ }),

/***/ "./src/components/location_status_icons/status_icons/warning-health.svg":
/*!******************************************************************************!*\
  !*** ./src/components/location_status_icons/status_icons/warning-health.svg ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("defs", null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  id: "warning-health_svg__b",
  cx: 20,
  cy: 20,
  r: 20
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("filter", {
  id: "warning-health_svg__a",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-15%",
  filterUnits: "objectBoundingBox"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
})));

var _ref2 =
/*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("g", {
  strokeLinejoin: "round",
  transform: "translate(5 5)"
}, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
  fill: "#000",
  filter: "url(#warning-health_svg__a)",
  xlinkHref: "#warning-health_svg__b"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20.5,
  fill: "#FFF",
  stroke: "#979797"
})), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFA000",
  stroke: "#FFA000",
  strokeLinejoin: "round",
  d: "M24.696 21.485c6.187-5.157 10.313-7.735 12.375-7.735 3.094 0 4.64 3.094 0 10.828-3.094 5.157-7.219 10.829-12.375 17.017-6.188-8.25-10.313-13.923-12.376-17.017-3.093-4.64-3.093-10.828 0-10.828 2.063 0 6.188 2.578 12.376 7.735z"
}), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M26.175 23.992v4.29c0 .45-.02.89-.06 1.323-.04.433-.092.9-.157 1.4H24.87c-.07-.5-.124-.967-.161-1.4a15.32 15.32 0 0 1-.056-1.323v-4.29h1.522zm-1.83 9.87c0-.145.026-.282.079-.41.052-.127.126-.238.221-.333a1.01 1.01 0 0 1 .742-.307 1.02 1.02 0 0 1 .74.307c.092.095.165.206.22.334.056.127.083.264.083.409 0 .15-.027.287-.082.412a1.108 1.108 0 0 1-.222.33.97.97 0 0 1-.33.221 1.063 1.063 0 0 1-.409.08 1.021 1.021 0 0 1-1.043-1.042z"
}));

var SvgWarningHealth = function SvgWarningHealth(props) {
  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWarningHealth);

/***/ }),

/***/ "./src/components/location_status_icons/utils.ts":
/*!*******************************************************!*\
  !*** ./src/components/location_status_icons/utils.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withinMonth = exports.bodStrat = exports.countEngagements = exports.style = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
exports.style = { width: 48, height: 48 };
var countEngagements = function (props) {
    var cbses = props.allCbses.nodes, rbses = props.allRbses.nodes, type = props.type;
    var engagementIds = [];
    __spreadArray(__spreadArray([], __read(cbses), false), __read(rbses), false).forEach(function (s) {
        var snapshots = s.forecastSnapshots.nodes;
        snapshots.forEach(function (snap) {
            var engagements = snap.engagementToServicesByForecastSnapshotId.nodes;
            engagements.forEach(function (engagement) {
                var _a = engagement.engagementByEngagementId, engagementType = _a.engagementType, id = _a.id;
                if (engagementType === type) {
                    engagementIds.push(id);
                }
            });
        });
    });
    return __spreadArray([], __read(new Set(engagementIds)), false).length;
};
exports.countEngagements = countEngagements;
var bodStrat = function (props) {
    var serviceChanges = props.serviceChangePeriodsByLocationId.nodes;
    return serviceChanges.reduce(function (acc, cur) {
        switch (cur.changeType) {
            case 'Brokering':
                return __assign(__assign({}, acc), { b: true });
            case 'Optimization':
                return __assign(__assign({}, acc), { o: true });
            case 'Diversion':
                // D means if an active FHS is on this month. (start of this month, end of this month).
                // Does not matter what day today is.
                var endMoment = cur.endDate ? (0, moment_1.default)(cur.endDate) : (0, moment_1.default)();
                if ((0, exports.withinMonth)((0, moment_1.default)(cur.startDate), endMoment)) {
                    return __assign(__assign({}, acc), { d: true });
                }
        }
        return acc;
    }, { b: false, o: false, d: false });
};
exports.bodStrat = bodStrat;
var withinMonth = function (startDate, endDate) {
    var thisMonth = (0, moment_1.default)().startOf('month');
    if (thisMonth.isBetween(startDate, endDate, 'D', '[]') ||
        startDate.isBetween(thisMonth, thisMonth.endOf('month'), 'D', '[]')) {
        return true;
    }
    return false;
};
exports.withinMonth = withinMonth;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// created from 'create-ts-index'
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = exports.Validators = void 0;
__exportStar(__webpack_require__(/*! ./components */ "./src/components/index.ts"), exports);
var Validators = __importStar(__webpack_require__(/*! ./validation */ "./src/validation/index.ts"));
exports.Validators = Validators;
var Constants = __importStar(__webpack_require__(/*! ./rr-constants */ "./src/rr-constants/index.ts"));
exports.Constants = Constants;


/***/ }),

/***/ "./src/rr-constants/index.ts":
/*!***********************************!*\
  !*** ./src/rr-constants/index.ts ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EXP_CODES = exports.REMOVAL_TYPES = exports.BILL_CHARGE_TYPE = void 0;
exports.BILL_CHARGE_TYPE = {
    CONTAINER_DELIVERY: 'Container Delivery',
    CONTAINER_REMOVAL: 'Container Removal',
    CONTAINER_SWAP: 'Container Swap',
    YARDAGE: 'Extra Yardage',
    LATE_FEES: 'Late Fees',
    OTHER: 'Other',
    DRY_RUN: 'Dry Run',
    CONTAMINATION: 'Contamination',
    PICKUP: 'Extra Pickup',
};
exports.REMOVAL_TYPES = {
    REAR_LOAD: 'Rear Load',
    REAR_LOAD_COMPACTOR: 'Rear Load Compactor',
    FRONT_LOAD: 'Front Load',
    FRONT_LOAD_COMPACTOR: 'Front Load Compactor',
    HAND_PICKUP: 'Hand Pickup',
    TOTER: 'Toter',
    GAYLORD: 'Gaylords',
    ROLLOFF_COMPACTOR: 'Rolloff Compactor',
    ROLLOFF_OPEN_TOP: 'Rolloff Open Top',
    ROLLOFF_GAYLORD: 'Rolloff Gaylord',
};
exports.EXP_CODES = ['5001', '5002', '5004', '5005'];


/***/ }),

/***/ "./src/validation/index.ts":
/*!*********************************!*\
  !*** ./src/validation/index.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelValidators = void 0;
var Validators = __importStar(__webpack_require__(/*! ./model_validators */ "./src/validation/model_validators/index.ts"));
__exportStar(__webpack_require__(/*! ./utils */ "./src/validation/utils.ts"), exports);
__exportStar(__webpack_require__(/*! ./index_types */ "./src/validation/index_types.ts"), exports);
exports.ModelValidators = Validators;


/***/ }),

/***/ "./src/validation/index_types.ts":
/*!***************************************!*\
  !*** ./src/validation/index_types.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "./src/validation/model_validators/account.ts":
/*!****************************************************!*\
  !*** ./src/validation/model_validators/account.ts ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
var PAYMENT_TERMS_VALUES = [15, 30, 45, 60, 90];
var PAYMENT_TYPES = {
    PAPER_CHECK: 'PAPER CHECK',
    CREDIT_CARD: 'CREDIT CARD',
    DIRECT_DEBIT: 'DIRECT DEBIT (AUTOPAY)',
    ACH_ELECT: 'ACH (ELECTRONIC)',
    ACH_CUST_INIT: 'ACH / CC (CUSTOMER INITIATED)',
};
var validator = {
    name: {
        required: true,
        type: 'string',
    },
    paymentTerms: {
        required: true,
        type: 'enum',
        transform: function (v) { return "".concat(v); },
        enum: PAYMENT_TERMS_VALUES.map(function (v) { return "".concat(v); }),
    },
    paymentType: {
        type: 'enum',
        enum: Object.values(PAYMENT_TYPES),
    },
    rrSavingsPercentage: {
        type: 'number',
        min: 0,
        max: 1,
    },
    contactType: {
        type: 'enum',
        enum: ['billing', 'ops'],
    },
};
exports.Account = {
    validator: validator,
};


/***/ }),

/***/ "./src/validation/model_validators/account_contact.ts":
/*!************************************************************!*\
  !*** ./src/validation/model_validators/account_contact.ts ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountContact = void 0;
exports.AccountContact = {
    validator: {
        name: {
            // required: true,
            type: 'string',
        },
        accountId: {
            // Actually this is not needed, because postGraphile already checks for it
            // required: true,
            type: 'number',
        },
        contactType: {
            type: 'enum',
            enum: ['billing', 'ops'],
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/address.ts":
/*!****************************************************!*\
  !*** ./src/validation/model_validators/address.ts ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
// const options: NodeGeocoder.Options = {
//   provider: 'google',
//   httpAdapter: 'https',
//   apiKey: process.env.GOOGLE_API_KEY,
// };
exports.Address = {
    validator: {
        address: {
            // Geo coding
            // validator: (rule, value, callback) => {
            //   setTimeout(() => {
            //     const e = new Error('validation failed');
            //     callback([e]);
            //   }, 100);
            // },
            required: true,
            type: 'string',
        },
        city: {
            required: true,
            type: 'string',
        },
        zip: {
            required: true,
            type: 'string',
        },
        state: {
            required: true,
            type: 'string',
        },
    },
    // modelValidator: async (data) => {
    // const geocoder = NodeGeocoder(options);
    // const {
    //   address, city, zip, state,
    // } = data;
    // return geocoder.geocode(`${address}, ${city}, ${zip}, ${state}`).then((result) => {
    //   console.log(result);
    //   return Promise.resolve(data);
    // });
    // },
};


/***/ }),

/***/ "./src/validation/model_validators/attachment.ts":
/*!*******************************************************!*\
  !*** ./src/validation/model_validators/attachment.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
var validator = {
    name: {
        required: true,
        type: 'string',
    },
};
exports.Attachment = {
    validator: validator,
};


/***/ }),

/***/ "./src/validation/model_validators/beeline_param.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/beeline_param.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BeelineParam = void 0;
var validator = {
    name: {
        required: true,
        type: 'string',
    },
};
exports.BeelineParam = {
    validator: validator,
};


/***/ }),

/***/ "./src/validation/model_validators/benchmark_fee_component.ts":
/*!********************************************************************!*\
  !*** ./src/validation/model_validators/benchmark_fee_component.ts ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkFeeComponent = void 0;
exports.BenchmarkFeeComponent = {};


/***/ }),

/***/ "./src/validation/model_validators/bill.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/bill.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bill = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
exports.Bill = {
    validator: {
        haulerAccountId: {
            required: true,
            type: 'number',
        },
        date: {
            type: 'date',
            required: true,
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        dueDate: {
            type: 'date',
            required: true,
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        billNumber: {
            type: 'string',
            required: true,
        },
        monthlyPeriod: {
            type: 'number',
            required: true,
            min: 0,
            max: Infinity,
        },
    },
    modelValidator: function (data) {
        // TODO: validate with Location.integration date.
        // Should this run for every update on location and bill?
        return Promise.resolve(data);
    },
};


/***/ }),

/***/ "./src/validation/model_validators/bill_aging.ts":
/*!*******************************************************!*\
  !*** ./src/validation/model_validators/bill_aging.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillAging = void 0;
exports.BillAging = {
    validator: {
        agingType: {
            type: 'enum',
            enum: ['RR Aged', 'Pre-RR Aged', 'Other'],
        },
        agingWindow: {
            type: 'enum',
            enum: [
                'Under 30 Days',
                'Over 30 Days',
                'Over 60 Days',
                'Over 90 Days',
                'Over 120 Days',
            ],
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/bill_charge.ts":
/*!********************************************************!*\
  !*** ./src/validation/model_validators/bill_charge.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillCharge = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var rr_constants_1 = __webpack_require__(/*! rr-constants */ "./src/rr-constants/index.ts");
exports.BillCharge = {
    validator: {
        amount: {
            type: 'number',
            min: 0,
            max: Infinity,
        },
        chargeDate: {
            type: 'date',
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        billChargeType: {
            type: 'enum',
            enum: Object.values(rr_constants_1.BILL_CHARGE_TYPE),
        },
        description: {
            type: 'string',
            validator: function (rule, value, callback) {
                callback();
            },
        },
    },
    modelValidator: function (data) {
        if (data.billChargeType === 'Other') {
            if (!data.description) {
                throw new Error('A description is needed for "other" bill charge type');
            }
        }
        return Promise.resolve(data);
    },
};


/***/ }),

/***/ "./src/validation/model_validators/bill_credit.ts":
/*!********************************************************!*\
  !*** ./src/validation/model_validators/bill_credit.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillCredit = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var rr_constants_1 = __webpack_require__(/*! rr-constants */ "./src/rr-constants/index.ts");
exports.BillCredit = {
    validator: {
        billId: {
            required: true,
            type: 'number',
        },
        intacctAccountId: {
            type: 'enum',
            transform: function (v) { return "".concat(v); },
            enum: rr_constants_1.EXP_CODES, // CHARGE_EXP_CODES
        },
        amount: {
            type: 'number',
            min: -Infinity,
            max: 0,
        },
        appliedTo: {
            type: 'enum',
            enum: ['Aging', 'Current'],
        },
        creditDate: {
            type: 'date',
            required: true,
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        description: {
            type: 'string',
            required: true,
        },
        xeroId: {
            type: 'string',
            required: false,
            len: 36,
        },
    },
    modelValidator: function (data) {
        if (data.billChargeType === 'Other') {
            if (!data.description) {
                throw new Error('A description is needed for "other" bill charge type');
            }
        }
        throw new Error('Not Implemented');
    },
};


/***/ }),

/***/ "./src/validation/model_validators/bill_fee.ts":
/*!*****************************************************!*\
  !*** ./src/validation/model_validators/bill_fee.ts ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillFee = void 0;
var VALID_TYPES = {
    FUEL: 'Fuel / Environmental',
    CONTAINER: 'Container Service',
    TAXES: 'Taxes',
    REGULATORY: 'Regulatory Cost Recovery',
    RECYCLABLE: 'Recyclable Material Offset',
    ADMIN: 'Admin',
    LOCKING: 'Locking Mechanism',
    OTHER: 'Other',
};
exports.BillFee = {
    validator: {
        feeType: {
            type: 'enum',
            enum: Object.values(VALID_TYPES),
        },
        billId: {
            required: true,
            type: 'number',
        },
        amount: {
            type: 'number',
            min: 0,
            max: Infinity,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/bill_period.ts":
/*!********************************************************!*\
  !*** ./src/validation/model_validators/bill_period.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillPeriod = void 0;
exports.BillPeriod = {
    validator: {
        billId: {
            required: true,
            type: 'number',
        },
        xeroInvoiceId: {
            type: 'string',
            required: true,
        },
        xeroId: {
            type: 'string',
            len: 36,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/bill_period_component.ts":
/*!******************************************************************!*\
  !*** ./src/validation/model_validators/bill_period_component.ts ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillPeriodComponent = void 0;
var VALID_TYPES = {
    RATE_BASED_BILL_SERVICE: 'RateBasedBillService',
    COST_BASED_BILL_SERVICE: 'CostBasedBillService',
    BILL_DEBIT: 'BillDebit',
    BILL_FEE: 'BillFee',
    BILL_CHARGE: 'BillCharge',
};
exports.BillPeriodComponent = {
    validator: {
        billPeriodId: {
            required: true,
            type: 'number',
        },
        billableType: {
            type: 'enum',
            enum: Object.values(VALID_TYPES),
        },
        amount: {
            type: 'number',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/boar.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/boar.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Boar = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
exports.Boar = {
    validator: {
        amount: {
            required: true,
            type: 'number',
        },
        startDate: {
            type: 'date',
        },
        locationId: {
            type: 'number',
            required: true,
        },
        endDate: {
            type: 'date',
        },
    },
    modelValidator: function (data) {
        var startDate = data.startDate, endDate = data.endDate;
        if (!startDate || !endDate) {
            return Promise.resolve(data);
        }
        if ((0, moment_1.default)(startDate).isAfter((0, moment_1.default)(endDate))) {
            throw new Error('Start date should be before/on end date');
        }
        return Promise.resolve(data);
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cart.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/cart.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Cart = void 0;
var VALID_STATUS = {
    READY: 'Ready',
    ON_HOLD_PROCESSING: 'On Hold - Processing',
    ON_HOLD_PURCHASE: 'On Hold - Purchase',
    ROUTED: 'Routed',
    CANCELED: 'Canceled',
};
exports.Cart = {
    validator: {
        status: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
        executionDate: {
            type: 'date',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cart_batch.ts":
/*!*******************************************************!*\
  !*** ./src/validation/model_validators/cart_batch.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CartBatch = void 0;
exports.CartBatch = {
    validator: {
        quantity: {
            type: 'number',
            required: true,
            min: 0.001,
        },
        amount: {
            type: 'number',
            required: true,
        },
        originalAmount: {
            type: 'number',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cart_transfer.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/cart_transfer.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CartTransfer = void 0;
var VALID_STATUS = {
    READY: 'Ready',
    ON_HOLD_PROCESSING: 'On Hold - Processing',
    ON_HOLD_PURCHASE: 'On Hold - Purchase',
    ROUTED: 'Routed',
    CANCELED: 'Canceled',
};
exports.CartTransfer = {
    validator: {
        status: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
        executionDate: {
            type: 'date',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cart_transfer_service.ts":
/*!******************************************************************!*\
  !*** ./src/validation/model_validators/cart_transfer_service.ts ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CartTransferService = void 0;
exports.CartTransferService = {
    validator: {},
};


/***/ }),

/***/ "./src/validation/model_validators/cart_vendor.ts":
/*!********************************************************!*\
  !*** ./src/validation/model_validators/cart_vendor.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CartVendor = void 0;
exports.CartVendor = {
    validator: {},
};


/***/ }),

/***/ "./src/validation/model_validators/carts_request.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/carts_request.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CartsRequest = void 0;
var VALID_STATUS = {
    PENDING: 'Pending',
    CONFIRMED: 'Confirmed',
    COMPLETED: 'Completed',
    ROUTED: 'Routed',
    REJECTED: 'Rejected',
    MISSED: 'Missed',
};
exports.CartsRequest = {
    validator: {
        status: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
        requestType: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
        numCarts: {
            type: 'number',
            required: true,
            min: 0.1,
        },
        executionDate: {
            type: 'date',
            required: true,
        },
        fleetHaulServiceId: {
            type: 'number',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cb_benchmark.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/cb_benchmark.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CbBenchmark = void 0;
exports.CbBenchmark = {};


/***/ }),

/***/ "./src/validation/model_validators/cb_benchmark_component.ts":
/*!*******************************************************************!*\
  !*** ./src/validation/model_validators/cb_benchmark_component.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CbBenchmarkComponent = void 0;
exports.CbBenchmarkComponent = {};


/***/ }),

/***/ "./src/validation/model_validators/cost_based_benchmark.ts":
/*!*****************************************************************!*\
  !*** ./src/validation/model_validators/cost_based_benchmark.ts ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostBasedBenchmark = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
exports.CostBasedBenchmark = {
    validator: {
        amount: {
            type: 'number',
            required: true,
        },
        startDate: {
            type: 'date',
        },
        endDate: {
            type: 'date',
        },
        locationId: {
            type: 'number',
            required: true,
        },
    },
    modelValidator: function (data) {
        var startDate = data.startDate, endDate = data.endDate;
        if (!startDate || !endDate)
            return Promise.resolve(data);
        if ((0, moment_1.default)(startDate).isAfter((0, moment_1.default)(endDate))) {
            throw new Error('Start Date cannot be later than end date');
        }
        return Promise.resolve(data);
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cost_based_bill_service.ts":
/*!********************************************************************!*\
  !*** ./src/validation/model_validators/cost_based_bill_service.ts ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CostBasedBillService = void 0;
exports.CostBasedBillService = {
    validator: {
        cost: {
            type: 'number',
            required: true,
            min: 0,
        },
        periodStartDate: {
            type: 'date',
        },
        periodEndDate: {
            type: 'date',
        },
        binSize: {
            type: 'number',
            min: 0.001,
        },
        binQuantity: {
            type: 'number',
            min: 0.001,
        },
        streamTypeId: {
            type: 'number',
            required: true,
        },
    },
    modelValidator: function () {
        // TODO: validate with sql, CBS etc
        throw new Error('Not Implemented');
    },
};


/***/ }),

/***/ "./src/validation/model_validators/cost_based_service.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/cost_based_service.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostBasedService = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var rr_constants_1 = __webpack_require__(/*! rr-constants */ "./src/rr-constants/index.ts");
exports.CostBasedService = {
    validator: {
        billAmount: {
            type: 'number',
            required: true,
            min: 0,
        },
        invoiceAmount: {
            type: 'number',
            min: 0,
        },
        startDate: {
            type: 'date',
        },
        endDate: {
            type: 'date',
        },
        removalType: {
            type: 'enum',
            enum: Object.values(rr_constants_1.REMOVAL_TYPES),
        },
        binSize: {
            type: 'number',
            min: 0.001,
        },
        binQuantity: {
            type: 'number',
            min: 0.001,
        },
        streamTypeId: {
            type: 'number',
            required: true,
        },
        frequency: {
            type: 'number',
            required: true,
            min: 0.1,
            max: 7,
        },
    },
    modelValidator: function (data) {
        var startDate = data.startDate, endDate = data.endDate;
        if (startDate && endDate && (0, moment_1.default)(startDate).isAfter((0, moment_1.default)(endDate))) {
            throw new Error('Start date should be before/on end date');
        }
        return Promise.resolve(data);
    },
};


/***/ }),

/***/ "./src/validation/model_validators/daily_routing.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/daily_routing.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyRouting = void 0;
exports.DailyRouting = {
    validator: {
        date: {
            type: 'date',
            required: true,
        },
        fleetHaulRegionId: {
            type: 'number',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/daily_routing_recovery_facility.ts":
/*!****************************************************************************!*\
  !*** ./src/validation/model_validators/daily_routing_recovery_facility.ts ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyRoutingRecoveryFacility = void 0;
exports.DailyRoutingRecoveryFacility = {
    validator: {
        dailyRoutingId: {
            required: true,
            type: 'number',
        },
        recoveryFacilityId: {
            required: true,
            type: 'number',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/daily_routing_service.ts":
/*!******************************************************************!*\
  !*** ./src/validation/model_validators/daily_routing_service.ts ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyRoutingService = void 0;
exports.DailyRoutingService = {
    validator: {
        dailyRoutingId: {
            required: true,
            type: 'number',
        },
        streamTypeId: {
            required: true,
            type: 'number',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/day_availability.ts":
/*!*************************************************************!*\
  !*** ./src/validation/model_validators/day_availability.ts ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DayAvailability = void 0;
var VALID_DAYS = {
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
};
exports.DayAvailability = {
    validator: {
        day: {
            type: 'enum',
            enum: Object.values(VALID_DAYS),
        },
        dayAvailableId: {
            type: 'number',
            required: true,
        },
        dayAvailableTYpe: {
            type: 'string',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/fleet_haul_integration_form.ts":
/*!************************************************************************!*\
  !*** ./src/validation/model_validators/fleet_haul_integration_form.ts ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetHaulIntegrationForm = void 0;
var utils_1 = __webpack_require__(/*! ../utils */ "./src/validation/utils.ts");
var RR_RESPONSIBLE = {
    SALES: 'RR Sales',
    ACCOUNT_MANAGEMENT: 'RR Account Management',
};
var eligibleValidator = {
    rrResponsible: {
        type: 'enum',
        enum: Object.values(RR_RESPONSIBLE),
    },
    streamTypeId: {
        required: true,
        type: 'number',
    },
    weeklyYds: {
        required: true,
        type: 'number',
        min: 0,
    },
    maxContainers: {
        required: true,
        type: 'number',
        min: 0,
    },
    servicedAnytime: {
        type: 'boolean',
    },
    flexSchd: {
        type: 'boolean',
    },
    rmContainers: {
        type: 'boolean',
    },
    serviceAddressId: {
        type: 'number',
        required: true,
    },
    serviceContactId: {
        type: 'number',
        required: true,
    },
};
exports.FleetHaulIntegrationForm = {
    modelValidator: function (data) {
        var eligible = data.eligible;
        // Do validation based on eligible
        var rules = eligible
            ? eligibleValidator
            : {
                eligibleExplain: {
                    required: true,
                    type: 'string',
                },
            };
        var validator = new utils_1.Schema(rules);
        return validator.validate(data).then(function () {
            return Promise.resolve(data);
        });
    },
};


/***/ }),

/***/ "./src/validation/model_validators/fleet_haul_route.ts":
/*!*************************************************************!*\
  !*** ./src/validation/model_validators/fleet_haul_route.ts ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetHaulRoute = void 0;
var VALID_STATE = {
    INITIALIZED: 'Initialized',
    SCHEDULED: 'Scheduled',
    IN_PROGRESS: 'In Progress',
    DRIVEN: 'Driven',
    COMPLETED: 'Completed',
    PAID: 'Paid',
    DISCONTINUED: 'Discontinued',
};
var VALID_TYPE = {
    UNKNOWN: 'Unknown',
    STREAM: 'Stream',
    CART: 'Cart',
};
exports.FleetHaulRoute = {
    validator: {
        state: {
            type: 'enum',
            enum: Object.values(VALID_STATE),
        },
        routeType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/fleet_haul_route_stop.ts":
/*!******************************************************************!*\
  !*** ./src/validation/model_validators/fleet_haul_route_stop.ts ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetHaulRouteStop = void 0;
var VALID_STATE = {
    SCHEDULED: 'Scheduled',
    STARTED: 'Started',
    COMPLETED: 'Completed',
    MISSED: 'Missed',
    INCOMPLETE: 'Incomplete',
};
var VALID_TYPE = {
    CART_PICKUP: 'Cart Pickup',
    CART_DROPOFF: 'Cart Dropoff',
    PICKUP: 'Pickup',
};
exports.FleetHaulRouteStop = {
    validator: {
        state: {
            type: 'enum',
            enum: Object.values(VALID_STATE),
        },
        stopType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
        stopNumber: {
            type: 'number',
            min: 0,
        },
        stoppableId: {
            type: 'number',
            required: true,
        },
        stoppableType: {
            type: 'string',
            required: true,
        },
    },
    // modelValidator: async (data) => {
    //   const { stopType, id, fleetHaulRouteId } = data;
    //   // Make sure other stops on same route stop type does not disagree
    //   const sql = `
    //       select distinct stop_type
    //       from fleet_haul_route_stops
    //       where fleet_haul_route_id = $1 and ${id && 'fleet_haul_route_stops.id != $2'}
    //   `;
    //   return pgClient.query(sql, [fleetHaulRouteId, id]).then((result) => {
    //     const stopTypes = result.rows.map(r => r.stopType);
    //     const cartType = stopType.includes('Cart');
    //     const cartRoute = stopTypes.every(s => (s || '').includes('Cart'));
    //     if (cartType !== cartRoute) {
    //       throw new Error('Stop type is not the same with other stops in this route');
    //     }
    //   });
    // },
};


/***/ }),

/***/ "./src/validation/model_validators/fleet_haul_service.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/fleet_haul_service.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetHaulService = void 0;
var utils_1 = __webpack_require__(/*! ../utils */ "./src/validation/utils.ts");
var VALID_TYPES = {
    TOTER: 'Toter',
    HAND_PICKUP: 'Hand Pickup',
    CART: 'Cart',
    TRAILER: 'Trailer',
};
exports.FleetHaulService = {
    validator: {
        removalType: {
            type: 'enum',
            enum: Object.values(VALID_TYPES),
        },
        // binSize: {
        //   type: 'number',
        //   min: 0.01,
        // },
        // binQuantity: {
        //   type: 'number',
        //   min: 0.01,
        // },
        weeklyYds: {
            type: 'number',
            min: 0,
        },
        streamTypeId: {
            type: 'number',
            required: true,
        },
        locationId: {
            type: 'number',
            required: true,
        },
        fleetHaulRegionId: {
            type: 'number',
            required: true,
        },
        // frequencyOverride: {
        //   type: 'number',
        //   min: 0.01,
        //   max: 7,
        // },
        startDate: {
            type: 'date',
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var rootId, weeklyYds, startDate, endDate, cost, haulRate;
        return __generator(this, function (_a) {
            rootId = data.rootId, weeklyYds = data.weeklyYds, startDate = data.startDate, endDate = data.endDate, cost = data.cost, haulRate = data.haulRate;
            if (rootId && weeklyYds <= 0) {
                throw new Error('Weekly Yards must be greater than 0');
            }
            (0, utils_1.validateEndDateIsAfterStartDate)(startDate, endDate);
            if (cost > 0 && haulRate > 0) {
                throw new Error('Haul Rate and Cost cannot both be >0');
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/fleet_haul_service_challenge.ts":
/*!*************************************************************************!*\
  !*** ./src/validation/model_validators/fleet_haul_service_challenge.ts ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetHaulServiceChallenge = void 0;
var CHALLENGES = {
    LOCKED_GATE: 'Locked Gate/Key Required',
    NEEDS_FASTENED: 'Hill/Windy (Cart needs to be fastened to structure)',
    GARAGE_DOOR: 'Garage Door',
    CODE_COMBO: 'Code/Combination Required',
    DOCK_SERVICE: 'Location Serviced from Dock',
    CURRENT_CARTS: 'Issues with Current Carts On Site',
    OTHER: 'Other',
};
exports.FleetHaulServiceChallenge = {
    validator: {
        label: {
            type: 'enum',
            enum: Object.values(CHALLENGES),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/fleet_hauler.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/fleet_hauler.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetHauler = void 0;
exports.FleetHauler = {
    validator: {
        abbreviation: {
            type: 'string',
            min: 2,
            max: 4,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/forecast_metum.ts":
/*!***********************************************************!*\
  !*** ./src/validation/model_validators/forecast_metum.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastMetum = void 0;
exports.ForecastMetum = {
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // TODO: needs auathorization setup, need association
            throw new Error('Not Implemented');
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/forecast_snapshot.ts":
/*!**************************************************************!*\
  !*** ./src/validation/model_validators/forecast_snapshot.ts ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastSnapshot = void 0;
exports.ForecastSnapshot = {
    validator: {
        forecastableId: {
            type: 'number',
            required: true,
        },
        forecastableType: {
            type: 'string',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/global_variable.ts":
/*!************************************************************!*\
  !*** ./src/validation/model_validators/global_variable.ts ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalVariable = void 0;
exports.GlobalVariable = {};


/***/ }),

/***/ "./src/validation/model_validators/hauler.ts":
/*!***************************************************!*\
  !*** ./src/validation/model_validators/hauler.ts ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Hauler = void 0;
exports.Hauler = {
    validator: {
        xeroContactId: {
            type: 'string',
            len: 36,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/hauler_account.ts":
/*!***********************************************************!*\
  !*** ./src/validation/model_validators/hauler_account.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerAccount = void 0;
var VALID_STATUS = {
    NO_TRANSITION: 'NT - No Transition',
    MAIL_TRANSITION: 'MT Only - Mail Transition',
    PORTAL_TRANSITION: 'PT Only - Portal Transition',
    PORTAL_AND_MAIL_TRANSITION: 'PT & MT - Portal and Mail Transition',
    CUSTOMER_TRANSITION: 'CT - Customer Transition',
    CANT_TRANSITION: "CBT - Can't Be Transitioned",
};
exports.HaulerAccount = {
    validator: {
        haulerId: {
            type: 'number',
            required: true,
        },
        status: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/hauler_account_document.ts":
/*!********************************************************************!*\
  !*** ./src/validation/model_validators/hauler_account_document.ts ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerAccountDocument = void 0;
exports.HaulerAccountDocument = {
    validator: {
        haulerAccountId: {
            required: true,
            type: 'number',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/hauler_contact.ts":
/*!***********************************************************!*\
  !*** ./src/validation/model_validators/hauler_contact.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerContact = void 0;
exports.HaulerContact = {
    validator: {
        haulerId: {
            type: 'number',
            required: true,
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var email, phone;
        return __generator(this, function (_a) {
            email = data.email, phone = data.phone;
            if (!email && !phone) {
                throw new Error('Email or Phone must present');
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/hauler_liquidation.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/hauler_liquidation.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerLiquidation = void 0;
exports.HaulerLiquidation = {
    validator: {
        billAmount: {
            required: true,
            type: 'number',
            min: 0,
        },
    },
    // modelValidator: async (data) => {
    //   const { haulerAccountId, internalContractId } = data;
    //   if (!haulerAccountId || !!internalContractId) {
    //     return Promise.resolve(data);
    //   }
    //   const sql = `select id
    //   from hauler_accounts
    //   where hauler_accounts.location_id not in (select location_id from
    // internal_contract_to_locations where internal_contract_id = $1) and hauler_accounts.id = $2`;
    //   return pgClient.query(sql, [haulerAccountId, internalContractId]).then((result) => {
    //     const { rows } = result;
    //     if (rows.length > 0) {
    //       throw new Error('Hauler Account location is not one of the Internal Contract locations');
    //     }
    //     return Promise.resolve(data);
    //   });
    // },
};


/***/ }),

/***/ "./src/validation/model_validators/hauler_org.ts":
/*!*******************************************************!*\
  !*** ./src/validation/model_validators/hauler_org.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerOrg = void 0;
exports.HaulerOrg = {};


/***/ }),

/***/ "./src/validation/model_validators/hauler_service_fee.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/hauler_service_fee.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerServiceFee = void 0;
var VALID_TYPE = {
    RATE_BASED_SERVICE: 'RateBasedService',
    COST_BASED_SERVICE: 'CostBasedService',
};
exports.HaulerServiceFee = {
    validator: {
        feePercentage: {
            type: 'number',
            min: 0,
        },
        serviceableType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var feePercentage, billDriven, billDrivenTemp;
        return __generator(this, function (_a) {
            feePercentage = data.feePercentage, billDriven = data.billDriven, billDrivenTemp = data.billDrivenTemp;
            if (!billDriven || billDrivenTemp) {
                if (!feePercentage) {
                    throw new Error('fee percentage is required when making a hauler service fee not bill driven');
                }
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/index.ts":
/*!**************************************************!*\
  !*** ./src/validation/model_validators/index.ts ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./account_contact */ "./src/validation/model_validators/account_contact.ts"), exports);
__exportStar(__webpack_require__(/*! ./account */ "./src/validation/model_validators/account.ts"), exports);
__exportStar(__webpack_require__(/*! ./address */ "./src/validation/model_validators/address.ts"), exports);
__exportStar(__webpack_require__(/*! ./attachment */ "./src/validation/model_validators/attachment.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill_aging */ "./src/validation/model_validators/bill_aging.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill_fee */ "./src/validation/model_validators/bill_fee.ts"), exports);
__exportStar(__webpack_require__(/*! ./beeline_param */ "./src/validation/model_validators/beeline_param.ts"), exports);
__exportStar(__webpack_require__(/*! ./benchmark_fee_component */ "./src/validation/model_validators/benchmark_fee_component.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill_period_component */ "./src/validation/model_validators/bill_period_component.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill_period */ "./src/validation/model_validators/bill_period.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill */ "./src/validation/model_validators/bill.ts"), exports);
__exportStar(__webpack_require__(/*! ./boar */ "./src/validation/model_validators/boar.ts"), exports);
__exportStar(__webpack_require__(/*! ./cart_batch */ "./src/validation/model_validators/cart_batch.ts"), exports);
__exportStar(__webpack_require__(/*! ./cart_transfer_service */ "./src/validation/model_validators/cart_transfer_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./cart_transfer */ "./src/validation/model_validators/cart_transfer.ts"), exports);
__exportStar(__webpack_require__(/*! ./cart_vendor */ "./src/validation/model_validators/cart_vendor.ts"), exports);
__exportStar(__webpack_require__(/*! ./cart */ "./src/validation/model_validators/cart.ts"), exports);
__exportStar(__webpack_require__(/*! ./carts_request */ "./src/validation/model_validators/carts_request.ts"), exports);
__exportStar(__webpack_require__(/*! ./cb_benchmark */ "./src/validation/model_validators/cb_benchmark.ts"), exports);
__exportStar(__webpack_require__(/*! ./cb_benchmark_component */ "./src/validation/model_validators/cb_benchmark_component.ts"), exports);
__exportStar(__webpack_require__(/*! ./cost_based_benchmark */ "./src/validation/model_validators/cost_based_benchmark.ts"), exports);
__exportStar(__webpack_require__(/*! ./cost_based_bill_service */ "./src/validation/model_validators/cost_based_bill_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./daily_routing_recovery_facility */ "./src/validation/model_validators/daily_routing_recovery_facility.ts"), exports);
__exportStar(__webpack_require__(/*! ./daily_routing_service */ "./src/validation/model_validators/daily_routing_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./daily_routing */ "./src/validation/model_validators/daily_routing.ts"), exports);
__exportStar(__webpack_require__(/*! ./day_availability */ "./src/validation/model_validators/day_availability.ts"), exports);
__exportStar(__webpack_require__(/*! ./fleet_haul_integration_form */ "./src/validation/model_validators/fleet_haul_integration_form.ts"), exports);
__exportStar(__webpack_require__(/*! ./fleet_haul_route_stop */ "./src/validation/model_validators/fleet_haul_route_stop.ts"), exports);
__exportStar(__webpack_require__(/*! ./fleet_haul_route */ "./src/validation/model_validators/fleet_haul_route.ts"), exports);
__exportStar(__webpack_require__(/*! ./fleet_haul_service_challenge */ "./src/validation/model_validators/fleet_haul_service_challenge.ts"), exports);
__exportStar(__webpack_require__(/*! ./fleet_haul_service */ "./src/validation/model_validators/fleet_haul_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./fleet_hauler */ "./src/validation/model_validators/fleet_hauler.ts"), exports);
__exportStar(__webpack_require__(/*! ./forecast_metum */ "./src/validation/model_validators/forecast_metum.ts"), exports);
__exportStar(__webpack_require__(/*! ./forecast_snapshot */ "./src/validation/model_validators/forecast_snapshot.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler_account_document */ "./src/validation/model_validators/hauler_account_document.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler_account */ "./src/validation/model_validators/hauler_account.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler_contact */ "./src/validation/model_validators/hauler_contact.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler_liquidation */ "./src/validation/model_validators/hauler_liquidation.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler_org */ "./src/validation/model_validators/hauler_org.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler_service_fee */ "./src/validation/model_validators/hauler_service_fee.ts"), exports);
__exportStar(__webpack_require__(/*! ./hauler */ "./src/validation/model_validators/hauler.ts"), exports);
__exportStar(__webpack_require__(/*! ./instruction */ "./src/validation/model_validators/instruction.ts"), exports);
__exportStar(__webpack_require__(/*! ./intacct_bill_line */ "./src/validation/model_validators/intacct_bill_line.ts"), exports);
__exportStar(__webpack_require__(/*! ./intacct_bill */ "./src/validation/model_validators/intacct_bill.ts"), exports);
__exportStar(__webpack_require__(/*! ./intacct_so_transaction_line */ "./src/validation/model_validators/intacct_so_transaction_line.ts"), exports);
__exportStar(__webpack_require__(/*! ./intacct_so_transaction */ "./src/validation/model_validators/intacct_so_transaction.ts"), exports);
__exportStar(__webpack_require__(/*! ./internal_contract */ "./src/validation/model_validators/internal_contract.ts"), exports);
__exportStar(__webpack_require__(/*! ./invoice_charge */ "./src/validation/model_validators/invoice_charge.ts"), exports);
__exportStar(__webpack_require__(/*! ./invoice_hidden_item */ "./src/validation/model_validators/invoice_hidden_item.ts"), exports);
__exportStar(__webpack_require__(/*! ./invoice_item_component */ "./src/validation/model_validators/invoice_item_component.ts"), exports);
__exportStar(__webpack_require__(/*! ./invoice_item */ "./src/validation/model_validators/invoice_item.ts"), exports);
__exportStar(__webpack_require__(/*! ./invoice */ "./src/validation/model_validators/invoice.ts"), exports);
__exportStar(__webpack_require__(/*! ./iss_daily_log */ "./src/validation/model_validators/iss_daily_log.ts"), exports);
__exportStar(__webpack_require__(/*! ./location_change_type */ "./src/validation/model_validators/location_change_type.ts"), exports);
__exportStar(__webpack_require__(/*! ./location_contact */ "./src/validation/model_validators/location_contact.ts"), exports);
__exportStar(__webpack_require__(/*! ./location_credit_item */ "./src/validation/model_validators/location_credit_item.ts"), exports);
__exportStar(__webpack_require__(/*! ./location_credit */ "./src/validation/model_validators/location_credit.ts"), exports);
__exportStar(__webpack_require__(/*! ./location_period_margin */ "./src/validation/model_validators/location_period_margin.ts"), exports);
__exportStar(__webpack_require__(/*! ./location */ "./src/validation/model_validators/location.ts"), exports);
__exportStar(__webpack_require__(/*! ./loa_agreement */ "./src/validation/model_validators/loa_agreement.ts"), exports);
__exportStar(__webpack_require__(/*! ./monet_pairing_hidden_item */ "./src/validation/model_validators/monet_pairing_hidden_item.ts"), exports);
__exportStar(__webpack_require__(/*! ./note */ "./src/validation/model_validators/note.ts"), exports);
__exportStar(__webpack_require__(/*! ./notification */ "./src/validation/model_validators/notification.ts"), exports);
__exportStar(__webpack_require__(/*! ./oss_mrr_goal */ "./src/validation/model_validators/oss_mrr_goal.ts"), exports);
__exportStar(__webpack_require__(/*! ./oss_user_info */ "./src/validation/model_validators/oss_user_info.ts"), exports);
__exportStar(__webpack_require__(/*! ./placemark */ "./src/validation/model_validators/placemark.ts"), exports);
__exportStar(__webpack_require__(/*! ./quick_task */ "./src/validation/model_validators/quick_task.ts"), exports);
__exportStar(__webpack_require__(/*! ./rate_based_bill_service */ "./src/validation/model_validators/rate_based_bill_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./rate_based_service */ "./src/validation/model_validators/rate_based_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./rb_benchmark */ "./src/validation/model_validators/rb_benchmark.ts"), exports);
__exportStar(__webpack_require__(/*! ./rb_benchmark_component */ "./src/validation/model_validators/rb_benchmark_component.ts"), exports);
__exportStar(__webpack_require__(/*! ./recovery_facility_contact */ "./src/validation/model_validators/recovery_facility_contact.ts"), exports);
__exportStar(__webpack_require__(/*! ./reimbursement_rate */ "./src/validation/model_validators/reimbursement_rate.ts"), exports);
__exportStar(__webpack_require__(/*! ./root */ "./src/validation/model_validators/root.ts"), exports);
__exportStar(__webpack_require__(/*! ./routing_period_service */ "./src/validation/model_validators/routing_period_service.ts"), exports);
__exportStar(__webpack_require__(/*! ./routing_period */ "./src/validation/model_validators/routing_period.ts"), exports);
__exportStar(__webpack_require__(/*! ./savings_lock_percent */ "./src/validation/model_validators/savings_lock_percent.ts"), exports);
__exportStar(__webpack_require__(/*! ./service_history_log */ "./src/validation/model_validators/service_history_log.ts"), exports);
__exportStar(__webpack_require__(/*! ./service_history */ "./src/validation/model_validators/service_history.ts"), exports);
__exportStar(__webpack_require__(/*! ./service_timeline_tag */ "./src/validation/model_validators/service_timeline_tag.ts"), exports);
__exportStar(__webpack_require__(/*! ./snapshot_bundle */ "./src/validation/model_validators/snapshot_bundle.ts"), exports);
__exportStar(__webpack_require__(/*! ./stream_diversion */ "./src/validation/model_validators/stream_diversion.ts"), exports);
__exportStar(__webpack_require__(/*! ./stream_type */ "./src/validation/model_validators/stream_type.ts"), exports);
__exportStar(__webpack_require__(/*! ./term */ "./src/validation/model_validators/term.ts"), exports);
__exportStar(__webpack_require__(/*! ./user */ "./src/validation/model_validators/user.ts"), exports);
__exportStar(__webpack_require__(/*! ./weight_sheet */ "./src/validation/model_validators/weight_sheet.ts"), exports);
__exportStar(__webpack_require__(/*! ./workflow_execution */ "./src/validation/model_validators/workflow_execution.ts"), exports);
__exportStar(__webpack_require__(/*! ./workflow_instance */ "./src/validation/model_validators/workflow_instance.ts"), exports);
__exportStar(__webpack_require__(/*! ./workflow */ "./src/validation/model_validators/workflow.ts"), exports);
__exportStar(__webpack_require__(/*! ./global_variable */ "./src/validation/model_validators/global_variable.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill_credit */ "./src/validation/model_validators/bill_credit.ts"), exports);
__exportStar(__webpack_require__(/*! ./bill_charge */ "./src/validation/model_validators/bill_charge.ts"), exports);
__exportStar(__webpack_require__(/*! ./cost_based_service */ "./src/validation/model_validators/cost_based_service.ts"), exports);


/***/ }),

/***/ "./src/validation/model_validators/instruction.ts":
/*!********************************************************!*\
  !*** ./src/validation/model_validators/instruction.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Instruction = void 0;
exports.Instruction = {
    validator: {
        order: {
            type: 'number',
            min: 0.1,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/intacct_bill.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/intacct_bill.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.IntacctBill = void 0;
exports.IntacctBill = {
    validator: {
        dateCreated: {
            type: 'date',
        },
        datePosted: {
            type: 'date',
        },
        dateDue: {
            type: 'date',
        },
        datePaid: {
            type: 'date',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/intacct_bill_line.ts":
/*!**************************************************************!*\
  !*** ./src/validation/model_validators/intacct_bill_line.ts ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.IntacctBillLine = void 0;
exports.IntacctBillLine = {
    validator: {
        lineNumber: {
            type: 'number',
            min: 0,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/intacct_so_transaction.ts":
/*!*******************************************************************!*\
  !*** ./src/validation/model_validators/intacct_so_transaction.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.IntacctSoTransaction = void 0;
exports.IntacctSoTransaction = {
    validator: {
        dateCreated: {
            type: 'date',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/intacct_so_transaction_line.ts":
/*!************************************************************************!*\
  !*** ./src/validation/model_validators/intacct_so_transaction_line.ts ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.IntacctSoTransactionLine = void 0;
exports.IntacctSoTransactionLine = {
    validator: {
        lineNumber: {
            type: 'number',
            min: 0,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/internal_contract.ts":
/*!**************************************************************!*\
  !*** ./src/validation/model_validators/internal_contract.ts ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalContract = void 0;
var VALID_STATUS = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};
var PAYMENT_TERMS = [15, 30, 45, 60];
exports.InternalContract = {
    validator: {
        paymentTerms: {
            type: 'enum',
            transform: function (v) { return "".concat(v); },
            enum: PAYMENT_TERMS.map(function (t) { return "".concat(t); }),
        },
        // @ts-ignore
        contractNumber: {
            type: 'string',
            pattern: /^RRC-[0-9]{6,}($|-[0-9]{1,}$)/,
        },
        status: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/invoice.ts":
/*!****************************************************!*\
  !*** ./src/validation/model_validators/invoice.ts ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
exports.Invoice = {
    validator: {
        servicePeriodMonth: {
            type: 'date',
        },
        rrSavingsPercentage: {
            type: 'number',
            min: 0,
            max: 1,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/invoice_charge.ts":
/*!***********************************************************!*\
  !*** ./src/validation/model_validators/invoice_charge.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceCharge = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var rr_constants_1 = __webpack_require__(/*! rr-constants */ "./src/rr-constants/index.ts");
exports.InvoiceCharge = {
    validator: {
        amount: {
            type: 'number',
            min: 0.001,
        },
        chargeDate: {
            type: 'date',
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        invoiceChargeType: {
            type: 'enum',
            enum: Object.values(rr_constants_1.BILL_CHARGE_TYPE),
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var invoiceChargeType, description;
        return __generator(this, function (_a) {
            invoiceChargeType = data.invoiceChargeType, description = data.description;
            if (invoiceChargeType === rr_constants_1.BILL_CHARGE_TYPE.OTHER) {
                if (!description) {
                    throw new Error('Need description for OTHER type charge');
                }
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/invoice_hidden_item.ts":
/*!****************************************************************!*\
  !*** ./src/validation/model_validators/invoice_hidden_item.ts ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceHiddenItem = void 0;
var VALID_TYPE = {
    BILL_CHARGE: 'BillCharge',
    BILL_DEBIT: 'BillDebit',
    RATE_BASED_BILL_SERVICE: 'RateBasedBillService',
    FLEET_HAUL_ROUTE_STOP: 'FleetHaulRouteStop',
};
exports.InvoiceHiddenItem = {
    validator: {
        invoiceableType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/invoice_item.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/invoice_item.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItem = void 0;
var ITEM_TYPE = {
    COST_BASED_SERVICE: 'cost based service',
    COMMERCIAL_HAUL: 'commercial haul',
    ROLLOFF_HAUL: 'rolloff haul',
    ROLLOFF_TONS: 'rolloff tons',
    FLEETHAUL_SERVICE: 'fleethaul service',
    FLEETHAUL_PICKUP: 'fleethaul pickup',
    FEE: 'fee',
    ROOT_FEE: 'root fee',
    CHARGE: 'charge',
    INVOICE_CHARGE: 'invoice charge',
    SAVINGS_SPLIT: 'savings split',
    MISC: 'miscellaneous',
};
exports.InvoiceItem = {
    validator: {
        itemType: {
            type: 'enum',
            enum: Object.values(ITEM_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/invoice_item_component.ts":
/*!*******************************************************************!*\
  !*** ./src/validation/model_validators/invoice_item_component.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItemComponent = void 0;
exports.InvoiceItemComponent = {
    validator: {
        invoiceableType: {
            type: 'string',
            required: true,
        },
        invoiceableId: {
            type: 'number',
            required: true,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/iss_daily_log.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/iss_daily_log.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.IssDailyLog = void 0;
var VALID_TYPE = {
    CALL: 'call',
};
exports.IssDailyLog = {
    validator: {
        activityDate: {
            type: 'date',
        },
        activityType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/loa_agreement.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/loa_agreement.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaAgreement = void 0;
exports.LoaAgreement = {
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Cannot handle file yet.
            throw new Error('Not Implemented');
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/location.ts":
/*!*****************************************************!*\
  !*** ./src/validation/model_validators/location.ts ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var SALES_STATUS = {
    OPEN: 'Open',
    CLOSED_LOST: 'Closed Lost',
    CLOSED_WON: 'Closed Won',
};
var OPS_STATUS = {
    PENDING_INTEGRATION: 'Pending Integration',
    PENDING_DEINTEGRATION: 'Pending De-Integration',
    FAILED_INTEGRATION: 'Failed Integration',
    INTEGRATED: 'Integrated',
    DEINTEGRATED: 'De-Integrated',
};
// const DEINT_REASON = {
//   RR_CANCELLED: 'RR Cancelled',
//   CUSTOMER_CANCELLED: 'Customer Cancelled',
//   OUT_OF_BUSINESS: 'Out Of Business',
//   MOVED: 'Moved',
// };
exports.Location = {
    validator: {
        salesStatus: {
            type: 'enum',
            enum: Object.values(SALES_STATUS),
        },
        opsStatus: {
            type: 'enum',
            enum: Object.values(OPS_STATUS),
        },
        integrationDate: {
            type: 'date',
        },
        DeIntegrationDate: {
            type: 'date',
        },
        name: {
            type: 'string',
            validator: function (rule, value, callback) {
                if (value && value.includes('ROOT')) {
                    callback('Cannot have ROOT in name');
                    return;
                }
                callback();
            },
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var name, integrationDate, DeIntegrationDate, DeintegrationReason;
        return __generator(this, function (_a) {
            name = data.name, integrationDate = data.integrationDate, DeIntegrationDate = data.DeIntegrationDate, DeintegrationReason = data.DeintegrationReason;
            if (integrationDate && DeIntegrationDate) {
                // End date should be after Start
                if ((0, moment_1.default)(DeIntegrationDate).isBefore((0, moment_1.default)(integrationDate))) {
                    throw new Error('Deintegration date should be after Integration Date');
                }
            }
            if (DeIntegrationDate && !DeintegrationReason) {
                throw new Error('Deintegration reason must be specified with a date');
            }
            if (!name) {
                throw new Error('Set Default Name is not implemented, so name cannot be null');
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/location_change_type.ts":
/*!*****************************************************************!*\
  !*** ./src/validation/model_validators/location_change_type.ts ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationChangeType = void 0;
var utils_1 = __webpack_require__(/*! ../utils */ "./src/validation/utils.ts");
var VALID_TYPE = {
    BROKERING: 'Brokering',
    OPTIMIZATION: 'Optimization',
    DIVERSION: 'Diversion',
};
exports.LocationChangeType = {
    validator: {
        startDate: {
            type: 'date',
        },
        changeType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var startDate, endDate;
        return __generator(this, function (_a) {
            startDate = data.startDate, endDate = data.endDate;
            (0, utils_1.validateEndDateIsAfterStartDate)(startDate, endDate);
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/location_contact.ts":
/*!*************************************************************!*\
  !*** ./src/validation/model_validators/location_contact.ts ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationContact = void 0;
var VALID_TYPE = {
    SERVICE: 'service',
};
exports.LocationContact = {
    validator: {
        contactType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
    modelValidator: function (data) {
        // const { contactType } = data;
        // TODO: need a location to have exactly 1 primary contact.
        // This is better to migrate to 2 table approach
        // https://dba.stackexchange.com/questions/197562/
        // constraint-one-boolean-row-is-true-all-other-rows-false
        return Promise.resolve(data);
    },
};


/***/ }),

/***/ "./src/validation/model_validators/location_credit.ts":
/*!************************************************************!*\
  !*** ./src/validation/model_validators/location_credit.ts ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationCredit = void 0;
exports.LocationCredit = {
    validator: {
        xeroId: {
            type: 'string',
            required: true,
            len: 36,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/location_credit_item.ts":
/*!*****************************************************************!*\
  !*** ./src/validation/model_validators/location_credit_item.ts ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationCreditItem = void 0;
var VALID_TYPES = {
    HAULER_SERVICE: 'hauler service',
    FLEET_HAUL_SERVICE: 'fleethaul service',
    RECYCLING_REBATE_EXPENSE: 'recycling rebate expense',
    SHARED_SAVINGS: 'shared savings',
    ROOT_SERVICE_REVENUE: 'root service revenue',
};
exports.LocationCreditItem = {
    validator: {
        amount: {
            type: 'number',
            min: 0,
        },
        itemType: {
            type: 'enum',
            enum: Object.values(VALID_TYPES),
        },
        date: {
            type: 'date',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/location_period_margin.ts":
/*!*******************************************************************!*\
  !*** ./src/validation/model_validators/location_period_margin.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LoationPeriodMargin = void 0;
var VALID_STRATEGIES = {
    NO_ACTION: 'n_a',
    DIVERSION: 'd',
    BROKERING_OR_OPTIMIZATION: 'b_o',
    BROKERING_OR_OPTIMIZATION_AND_DIVERSION: 'b_o_d',
};
exports.LoationPeriodMargin = {
    validator: {
        strategyBucket: {
            type: 'enum',
            enum: Object.values(VALID_STRATEGIES),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/monet_pairing_hidden_item.ts":
/*!**********************************************************************!*\
  !*** ./src/validation/model_validators/monet_pairing_hidden_item.ts ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MonetPairingHiddenItem = void 0;
var VALID_TYPE = {
    XERO_INVOICE: 'XeroInvoice',
    XERO_BANK_TRANSACTION: 'XeroBankTransaction',
    XERO_CREDIT_NOTE: 'XeroCreditNote',
    INTACCT_SO_TRANSACTION: 'IntacctSoTransaction',
};
exports.MonetPairingHiddenItem = {
    validator: {
        pairableType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/note.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/note.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = void 0;
exports.Note = {
    validator: {},
    modelValidator: function (data) {
        throw new Error('Not implemented');
    },
};


/***/ }),

/***/ "./src/validation/model_validators/notification.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/notification.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var VALID_TYPE = {
    EMAIL: 'email',
    SMS: 'sms',
    CALL: 'call',
};
exports.Notification = {
    validator: {
        medium: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/oss_mrr_goal.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/oss_mrr_goal.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OssMrrGoal = void 0;
exports.OssMrrGoal = {
    validator: {
        goalAmount: {
            type: 'number',
            min: 0,
        },
        month: {
            type: 'date',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/oss_user_info.ts":
/*!**********************************************************!*\
  !*** ./src/validation/model_validators/oss_user_info.ts ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OssUserInfo = void 0;
exports.OssUserInfo = {
    validator: {
        rampStartDate: {
            type: 'date',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/placemark.ts":
/*!******************************************************!*\
  !*** ./src/validation/model_validators/placemark.ts ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Placemark = void 0;
var VALID_STATES = {
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AS: 'American Samoa',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming',
};
exports.Placemark = {
    validator: {
        state: {
            type: 'enum',
            enum: Object.keys(VALID_STATES),
        },
        address: {
            type: 'string',
            validator: function (rule, value, callback) {
                if (value) {
                    if (value.includes('ROOT')) {
                        callback('Cannot have ROOT field in address');
                        return;
                    }
                }
                callback();
            },
        },
        // @ts-ignore
        zip: {
            type: 'string',
            pattern: /^\d{5}-\d{4}|^\d{5}$/,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/quick_task.ts":
/*!*******************************************************!*\
  !*** ./src/validation/model_validators/quick_task.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickTask = void 0;
exports.QuickTask = {
    validator: {
        startDate: {
            type: 'date',
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/rate_based_bill_service.ts":
/*!********************************************************************!*\
  !*** ./src/validation/model_validators/rate_based_bill_service.ts ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateBasedBillService = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var rr_constants_1 = __webpack_require__(/*! rr-constants */ "./src/rr-constants/index.ts");
exports.RateBasedBillService = {
    validator: {
        cost: {
            type: 'number',
            min: 0,
        },
        tonsServiced: {
            type: 'number',
            min: 0,
        },
        tonsBilled: {
            type: 'number',
            min: 0,
        },
        periodStartDate: {
            type: 'date',
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        periodEndDate: {
            type: 'date',
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
        removalType: {
            type: 'enum',
            enum: Object.values(rr_constants_1.REMOVAL_TYPES),
        },
        binSize: {
            type: 'number',
            min: 0.001,
        },
        binQuantity: {
            type: 'number',
            min: 0,
        },
        tonnageRate: {
            type: 'number',
            min: 0,
        },
        haulRate: {
            type: 'number',
            min: 0,
        },
        haulDate: {
            type: 'date',
            min: (0, moment_1.default)().subtract(5, 'years').valueOf(),
            max: (0, moment_1.default)().add(5, 'years').valueOf(),
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // TODO: RBS should have stream diversions
            // TODO: Also sync bill fees
            throw new Error('Not implemented');
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/rate_based_service.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/rate_based_service.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateBasedService = void 0;
var utils_1 = __webpack_require__(/*! ../utils */ "./src/validation/utils.ts");
var rr_constants_1 = __webpack_require__(/*! rr-constants */ "./src/rr-constants/index.ts");
var rollOffValidator = {
    tonnageRate: {
        type: 'number',
        min: 0,
    },
    floorTonnage: {
        type: 'number',
        min: 0,
    },
    cappTonnage: {
        type: 'number',
        min: 0,
    },
};
exports.RateBasedService = {
    validator: {
        startDate: {
            type: 'date',
        },
        endDate: {
            type: 'date',
        },
        haulRate: {
            type: 'number',
            min: 0,
        },
        rrPdmHaulRate: {
            type: 'number',
            min: 0,
        },
        rrPdmTonnageRate: {
            type: 'number',
            min: 0,
        },
        binSize: {
            type: 'number',
            min: 0.01,
        },
        binQuantity: {
            type: 'number',
            min: 0,
        },
        frequency: {
            type: 'number',
            min: 0,
            max: 7,
        },
        rrPdmFloorTonnage: {
            type: 'number',
            min: 0,
        },
        rrPdmCapTonnage: {
            type: 'number',
            min: 0,
        },
        removalType: {
            type: 'enum',
            enum: Object.values(rr_constants_1.REMOVAL_TYPES),
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var removalCategory, cap, floor, haul, ton, validator;
        return __generator(this, function (_a) {
            removalCategory = data.removalCategory, cap = data.rrPdmCapTonnage, floor = data.rrPdmFloorTonnage, haul = data.rrPdmHaulRate, ton = data.rrPdmTonnageRate;
            if (removalCategory === 'Rolloff') {
                if (cap || floor || haul || ton) {
                    if (cap && floor && haul && ton) {
                        throw new Error('If PDM, all PDM fields need to be entered');
                    }
                }
                validator = new utils_1.Schema(rollOffValidator);
                return [2 /*return*/, validator.validate(data).then(function () {
                        return Promise.resolve(data);
                    })];
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/rb_benchmark.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/rb_benchmark.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RbBenchmark = void 0;
exports.RbBenchmark = {};


/***/ }),

/***/ "./src/validation/model_validators/rb_benchmark_component.ts":
/*!*******************************************************************!*\
  !*** ./src/validation/model_validators/rb_benchmark_component.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RbBenchmarkComponent = void 0;
exports.RbBenchmarkComponent = {};


/***/ }),

/***/ "./src/validation/model_validators/recovery_facility_contact.ts":
/*!**********************************************************************!*\
  !*** ./src/validation/model_validators/recovery_facility_contact.ts ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoveryFacilityContact = void 0;
exports.RecoveryFacilityContact = {
    validator: {
        // @ts-ignore
        email: {
            type: 'string',
            pattern: /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/,
        },
        // @ts-ignore
        phone: {
            type: 'string',
            pattern: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var email, phone;
        return __generator(this, function (_a) {
            email = data.email, phone = data.phone;
            if (!email && !phone) {
                throw new Error('At least one of email and phone should present');
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/reimbursement_rate.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/reimbursement_rate.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReimbursementRate = void 0;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
exports.ReimbursementRate = {
    validator: {
        startDate: {
            type: 'date',
        },
        endDate: {
            type: 'date',
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var startDate, endDate;
        return __generator(this, function (_a) {
            startDate = data.startDate, endDate = data.endDate;
            if (startDate && endDate) {
                if ((0, moment_1.default)(endDate).isBefore((0, moment_1.default)(startDate))) {
                    throw new Error('End date should be after/on start Date');
                }
            }
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/root.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/root.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var VALID_TYPE = {
    ROLLOFF: 'Rolloff',
    HAUL_OUT: 'Haul Out',
    MOVING: 'Moving',
    DELIVERY: 'Delivery',
    RECOVERY: 'Recovery',
    FLEET_HAUL: 'Fleet Haul',
};
var VALID_STATE = {
    INITIALIZED: 'Initialized',
    NEEDS_HAULER_RATES: 'Needs Hauler Rates',
    NEEDS_CUSTOMER_RATES: 'Needs Customer Rates',
    READY_FOR_COMMUNICATION: 'Ready for Communication',
    NEEDS_BILLED: 'Needs Billed',
    NEEDS_INVOICED: 'Needs Invoiced',
    INVOICED: 'Invoiced',
    REJECTED: 'Rejected',
};
exports.Root = {
    validator: {
        rootType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
        // @ts-ignore
        serviceOrderNumber: {
            type: 'string',
            // This does not work for all Roots, but the ones have problem are old and should be
            pattern: /^R[0-9]{2,}$/,
        },
        state: {
            type: 'enum',
            enum: Object.values(VALID_STATE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/routing_period.ts":
/*!***********************************************************!*\
  !*** ./src/validation/model_validators/routing_period.ts ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingPeriod = void 0;
var utils_1 = __webpack_require__(/*! ../utils */ "./src/validation/utils.ts");
exports.RoutingPeriod = {
    validator: {
        startDate: {
            type: 'date',
        },
        endDate: {
            type: 'date',
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var startDate, endDate;
        return __generator(this, function (_a) {
            startDate = data.startDate, endDate = data.endDate;
            (0, utils_1.validateEndDateIsAfterStartDate)(startDate, endDate);
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/routing_period_service.ts":
/*!*******************************************************************!*\
  !*** ./src/validation/model_validators/routing_period_service.ts ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingPeriodService = void 0;
exports.RoutingPeriodService = {
    validator: {
        frequencyOverride: {
            type: 'number',
            min: 0.01,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/savings_lock_percent.ts":
/*!*****************************************************************!*\
  !*** ./src/validation/model_validators/savings_lock_percent.ts ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavingsLockPercent = void 0;
var utils_1 = __webpack_require__(/*! ../utils */ "./src/validation/utils.ts");
exports.SavingsLockPercent = {
    validator: {
        percent: {
            type: 'number',
            min: 0,
            max: 100,
        },
        startDate: {
            type: 'date',
        },
        endDate: {
            type: 'date',
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var startDate, endDate;
        return __generator(this, function (_a) {
            startDate = data.startDate, endDate = data.endDate;
            (0, utils_1.validateEndDateIsAfterStartDate)(startDate, endDate);
            return [2 /*return*/, Promise.resolve(data)];
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/service_history.ts":
/*!************************************************************!*\
  !*** ./src/validation/model_validators/service_history.ts ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceHistory = void 0;
exports.ServiceHistory = {
    // TODO, no mutation for this, it does complicated graph update stuff
    modelValidator: function (data) {
        throw new Error('Not implemented');
    },
};


/***/ }),

/***/ "./src/validation/model_validators/service_history_log.ts":
/*!****************************************************************!*\
  !*** ./src/validation/model_validators/service_history_log.ts ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceHistoryLog = void 0;
var VALID_TYPE = {
    BROKERING: 'Brokering',
    OPTIMIZATION: 'Optimization',
    DIVERSION: 'Diversion',
    FHPI: 'FHPI',
    API: 'API',
    SLI: 'SLI',
    SLD: 'SLD',
    RESIDUAL: 'Residual',
};
exports.ServiceHistoryLog = {
    validator: {
        changeType: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/service_timeline_tag.ts":
/*!*****************************************************************!*\
  !*** ./src/validation/model_validators/service_timeline_tag.ts ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceTimelineTag = void 0;
var VALID_TYPE = {
    ORIGIN: 'Origin Service',
    INJECTION: 'Injected Service',
    EJECTION: 'Ejected Service',
};
exports.ServiceTimelineTag = {
    validator: {
        tag: {
            type: 'enum',
            enum: Object.values(VALID_TYPE),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/snapshot_bundle.ts":
/*!************************************************************!*\
  !*** ./src/validation/model_validators/snapshot_bundle.ts ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotBundle = void 0;
exports.SnapshotBundle = {
    // TODO no mutation, this one has complicated validation
    modelValidator: function (data) {
        throw new Error('Not implemented');
    },
};


/***/ }),

/***/ "./src/validation/model_validators/stream_diversion.ts":
/*!*************************************************************!*\
  !*** ./src/validation/model_validators/stream_diversion.ts ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamDiversion = void 0;
exports.StreamDiversion = {
    validator: {
        diversionPct: {
            type: 'number',
            min: 0.001,
            max: 100,
        },
    },
    modelValidator: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // TODO: Check for the divertable, if the sum is over 100
            throw new Error('Not Implemented');
        });
    }); },
};


/***/ }),

/***/ "./src/validation/model_validators/stream_type.ts":
/*!********************************************************!*\
  !*** ./src/validation/model_validators/stream_type.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamType = void 0;
var validator = {
    // shortName: 3, // Demo, define some rule for a field
    name: {
        required: true,
        type: 'string',
    },
    secondaryName: {
        type: 'string',
    },
};
exports.StreamType = {
    validator: validator,
};


/***/ }),

/***/ "./src/validation/model_validators/term.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/term.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Term = void 0;
exports.Term = {};


/***/ }),

/***/ "./src/validation/model_validators/user.ts":
/*!*************************************************!*\
  !*** ./src/validation/model_validators/user.ts ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
exports.User = {
    validator: {},
};


/***/ }),

/***/ "./src/validation/model_validators/weight_sheet.ts":
/*!*********************************************************!*\
  !*** ./src/validation/model_validators/weight_sheet.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightSheet = void 0;
exports.WeightSheet = {
    validator: {
        penaltyAmount: {
            type: 'number',
            max: 0,
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/workflow.ts":
/*!*****************************************************!*\
  !*** ./src/validation/model_validators/workflow.ts ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Workflow = void 0;
var BUCKET = {
    STRATEGY_EXECUTION: 'strategy_execution',
    HAULER_MAINTENANCE: 'hauler_maintenance',
    ACCOUNT_MANAGEMENT: 'account_management',
};
exports.Workflow = {
    validator: {
        bucket: {
            type: 'enum',
            enum: Object.values(BUCKET),
        },
    },
};


/***/ }),

/***/ "./src/validation/model_validators/workflow_execution.ts":
/*!***************************************************************!*\
  !*** ./src/validation/model_validators/workflow_execution.ts ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowExecution = void 0;
exports.WorkflowExecution = {
    // TODO: no mutation yet, have to move sql logic here
    modelValidator: function (data) {
        throw new Error('Not implemented');
    },
};


/***/ }),

/***/ "./src/validation/model_validators/workflow_instance.ts":
/*!**************************************************************!*\
  !*** ./src/validation/model_validators/workflow_instance.ts ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowInstance = void 0;
var VALID_STATUS = {
    OPEN: 'open',
    PAUSED: 'paused',
    EXECUTED: 'executed',
    FORFEITED: 'forfeited',
};
exports.WorkflowInstance = {
    validator: {
        status: {
            type: 'enum',
            enum: Object.values(VALID_STATUS),
        },
    },
};


/***/ }),

/***/ "./src/validation/utils.ts":
/*!*********************************!*\
  !*** ./src/validation/utils.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schema = exports.guardHasValidatorForModel = exports.validateEndDateIsAfterStartDate = exports.normalizeForeignKeys = exports.normalizeIntacctVendorId = exports.normalizeXeroContactId = exports.dig = void 0;
var async_validator_1 = __importDefault(__webpack_require__(/*! async-validator */ "async-validator"));
exports.Schema = async_validator_1.default;
var moment_1 = __importDefault(__webpack_require__(/*! moment */ "moment"));
var ModelValidators = __importStar(__webpack_require__(/*! ./model_validators */ "./src/validation/model_validators/index.ts"));
/**
 * This dig function safely access deeply nested object, or array structure
 * @param {*} path the path to access the object
 * @param {*} props the object to access
 * @returns {*} The value of the path. or null if any of the middle object does not exist
 */
var dig = function (path, props) {
    if (!Array.isArray(path))
        return null;
    return path.reduce(function (cumulate, cur) { return (cumulate && cumulate.hasOwnProperty(cur) ? cumulate[cur] : null); }, props);
};
exports.dig = dig;
var normalizeXeroContactId = function (id) { return id.toLowerCase(); };
exports.normalizeXeroContactId = normalizeXeroContactId;
var normalizeIntacctVendorId = function (id) { return id.toLowerCase(); };
exports.normalizeIntacctVendorId = normalizeIntacctVendorId;
var normalizeForeignKeys = function (data) {
    var xeroContactId = data.xeroContactId, intacctVendorId = data.intacctVendorId;
    var newData = __assign({}, data);
    if (xeroContactId) {
        newData.xeroContactId = (0, exports.normalizeXeroContactId)(xeroContactId);
    }
    if (intacctVendorId) {
        newData.intacctVendorId = (0, exports.normalizeIntacctVendorId)(intacctVendorId);
    }
    return newData;
};
exports.normalizeForeignKeys = normalizeForeignKeys;
var validateEndDateIsAfterStartDate = function (startDate, endDate) {
    if (startDate && endDate && (0, moment_1.default)(endDate).isBefore((0, moment_1.default)(startDate))) {
        throw new Error('End Date should be after Start Date');
    }
};
exports.validateEndDateIsAfterStartDate = validateEndDateIsAfterStartDate;
// Modify the validator for number, add a cast first
// @ts-ignore
var numberValidator = async_validator_1.default.prototype.getValidationMethod({ type: 'number' });
// @ts-ignore
async_validator_1.default.register('number', function (rule, value, callback, source, options) {
    var numberValue = Number(value);
    numberValidator(rule, numberValue, callback, source, options);
});
// Modify the validator for date, change to Date object first
// @ts-ignore
var dateValidator = async_validator_1.default.prototype.getValidationMethod({ type: 'date' });
// @ts-ignore
async_validator_1.default.register('date', function (rule, value, callback, source, options) {
    var dateValue = new Date(value);
    dateValidator(rule, dateValue, callback, source, options);
});
function guardHasValidatorForModel(model) {
    if (Object.keys(ModelValidators).includes(model)) {
        return true;
    }
    return false;
}
exports.guardHasValidatorForModel = guardHasValidatorForModel;


/***/ }),

/***/ "antd":
/*!**********************************************************************************!*\
  !*** external {"root":"antd","commonjs2":"antd","commonjs":"antd","amd":"antd"} ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_antd__;

/***/ }),

/***/ "async-validator":
/*!******************************************************************************************************************************!*\
  !*** external {"root":"async-validator","commonjs":"async-validator","commonjs2":"async-validator","amd":"async-validator"} ***!
  \******************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_async_validator__;

/***/ }),

/***/ "graphql-tag":
/*!**************************************************************************************************************!*\
  !*** external {"root":"graphql-tag","commonjs2":"graphql-tag","commonjs":"graphql-tag","amd":"graphql-tag"} ***!
  \**************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_graphql_tag__;

/***/ }),

/***/ "moment":
/*!******************************************************************************************!*\
  !*** external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"} ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_moment__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map